{
  "version": 1,
  "milestone": "D01.6",
  "projection": "recipes/art/reference/projection.json",
  "review": "qa/art/review-d01-6.md",
  "assets": [
    {
      "recipeId": "actor-kiln-worker",
      "recipe": "recipes/art/slice/actor-kiln-worker.json",
      "recipeHash": "149f292e12cfab76899c9b764ecd1d6c33e182823b6961baca6f2862620af055",
      "class": "actor-sheet",
      "provider": "retro-diffusion:rd_animation__8_dir_rotation",
      "seed": 1305,
      "takes": 1,
      "generated": {
        "path": "assets/slice/actors/actor-kiln-worker-0.png",
        "sha256": "49dde722ea3c4f94c6475ad07e6c0552e8515f4e491769de3072d62edbda50b4"
      },
      "packed": {
        "path": "assets/slice/packed/actors/actor-kiln-worker.png",
        "sha256": "7bc676705645c70136b43a41b97c4ea0098560be028e97c5020d7e1610b4e8af",
        "size": [
          240,
          240
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "cell": {
          "width": 80,
          "height": 80
        },
        "sheet": {
          "grid": [
            3,
            3
          ],
          "cellFacings": [
            "se",
            "s",
            "sw",
            "e",
            null,
            "w",
            "ne",
            "n",
            "nw"
          ],
          "note": "Retro Diffusion's 8-direction rotation style lays the facings out as a mirrored compass: the top row looks towards the viewer (south), the bottom row looks away (north), and the left column looks screen-right (east), the right column screen-left (west). The centre cell is always empty. Read left-to-right, top-to-bottom; `cellFacings` names the facing drawn in each cell, and the manifest carries it so the renderer can pick a pose per facing. Verified by inspection of all six assets/slice/actors/*-rotation-0.png sheets (AUT-13617): the middle-left figure faces screen-right in every one."
        },
        "footY": 67
      },
      "animation": {
        "path": "assets/slice/packed/actors/painted/actor-kiln-worker.png",
        "sha256": "f452038e91e6c539b3caf424d8bae81cd4b147ffa385b177eb87e97a6e451ffc",
        "size": [
          1056,
          1280
        ],
        "cell": {
          "width": 88,
          "height": 80
        },
        "foot": [
          44,
          72
        ],
        "walkFacings": [
          "s",
          "se",
          "e",
          "ne",
          "n"
        ],
        "clips": {
          "walk": {
            "frames": [
              24,
              25,
              26,
              27,
              28,
              29
            ],
            "fps": 8,
            "loop": true,
            "facings": {
              "s": [
                0,
                1,
                2,
                3,
                4,
                5
              ],
              "se": [
                24,
                25,
                26,
                27,
                28,
                29
              ],
              "e": [
                48,
                49,
                50,
                51,
                52,
                53
              ],
              "ne": [
                72,
                73,
                74,
                75,
                76,
                77
              ],
              "n": [
                96,
                97,
                98,
                99,
                100,
                101
              ],
              "nw": [
                120,
                121,
                122,
                123,
                124,
                125
              ],
              "w": [
                144,
                145,
                146,
                147,
                148,
                149
              ],
              "sw": [
                168,
                169,
                170,
                171,
                172,
                173
              ]
            }
          },
          "attack": {
            "frames": [
              30,
              31,
              32,
              33,
              34,
              35
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                6,
                7,
                8,
                9,
                10,
                11
              ],
              "se": [
                30,
                31,
                32,
                33,
                34,
                35
              ],
              "e": [
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "ne": [
                78,
                79,
                80,
                81,
                82,
                83
              ],
              "n": [
                102,
                103,
                104,
                105,
                106,
                107
              ],
              "nw": [
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "w": [
                150,
                151,
                152,
                153,
                154,
                155
              ],
              "sw": [
                174,
                175,
                176,
                177,
                178,
                179
              ]
            }
          },
          "recoil": {
            "frames": [
              36,
              37
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                12,
                13
              ],
              "se": [
                36,
                37
              ],
              "e": [
                60,
                61
              ],
              "ne": [
                84,
                85
              ],
              "n": [
                108,
                109
              ],
              "nw": [
                132,
                133
              ],
              "w": [
                156,
                157
              ],
              "sw": [
                180,
                181
              ]
            }
          },
          "death": {
            "frames": [
              38,
              39,
              40,
              41
            ],
            "fps": 7,
            "loop": false,
            "facings": {
              "s": [
                14,
                15,
                16,
                17
              ],
              "se": [
                38,
                39,
                40,
                41
              ],
              "e": [
                62,
                63,
                64,
                65
              ],
              "ne": [
                86,
                87,
                88,
                89
              ],
              "n": [
                110,
                111,
                112,
                113
              ],
              "nw": [
                134,
                135,
                136,
                137
              ],
              "w": [
                158,
                159,
                160,
                161
              ],
              "sw": [
                182,
                183,
                184,
                185
              ]
            }
          },
          "corpse": {
            "frames": [
              41
            ],
            "fps": 1,
            "loop": false,
            "facings": {
              "s": [
                17
              ],
              "se": [
                41
              ],
              "e": [
                65
              ],
              "ne": [
                89
              ],
              "n": [
                113
              ],
              "nw": [
                137
              ],
              "w": [
                161
              ],
              "sw": [
                185
              ]
            }
          },
          "idle": {
            "frames": [
              42,
              43,
              44
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                18,
                19,
                20
              ],
              "se": [
                42,
                43,
                44
              ],
              "e": [
                66,
                67,
                68
              ],
              "ne": [
                90,
                91,
                92
              ],
              "n": [
                114,
                115,
                116
              ],
              "nw": [
                138,
                139,
                140
              ],
              "w": [
                162,
                163,
                164
              ],
              "sw": [
                186,
                187,
                188
              ]
            }
          },
          "work": {
            "frames": [
              45,
              46,
              47
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                21,
                22,
                23
              ],
              "se": [
                45,
                46,
                47
              ],
              "e": [
                69,
                70,
                71
              ],
              "ne": [
                93,
                94,
                95
              ],
              "n": [
                117,
                118,
                119
              ],
              "nw": [
                141,
                142,
                143
              ],
              "w": [
                165,
                166,
                167
              ],
              "sw": [
                189,
                190,
                191
              ]
            }
          }
        },
        "source": "assets/slice/actors/painted/directional/actor-kiln-worker/s.png",
        "sourceHash": "44a3a50d51dd4d29c339e36a8e50327b2493cfc8e062d13f5827d893645151bb",
        "recipe": "recipes/art/painted/actors/roster.json",
        "recipeHash": "c7d56c7285f33f43d1fc9f5e3542f57ab6f9a8df4d713a21717f50b7c894475a",
        "provider": "gpt-image-2",
        "sources": {
          "assets/slice/actors/painted/directional/actor-kiln-worker/s.png": "44a3a50d51dd4d29c339e36a8e50327b2493cfc8e062d13f5827d893645151bb",
          "assets/slice/actors/painted/directional/actor-kiln-worker/se.png": "36ff027bcd77b30505d7fe97b1163b5f53ecf1f68ddc1178d41375d8ac0b6b2b",
          "assets/slice/actors/painted/directional/actor-kiln-worker/e.png": "7b8983cd5214b06d7ff6ce8b52c11253be556a5e2b50e5b42c2c2e644522c827",
          "assets/slice/actors/painted/directional/actor-kiln-worker/ne.png": "f31c6ddeb6c63235fde8596c465c190506943c22703016085493529ff85aa6ff",
          "assets/slice/actors/painted/directional/actor-kiln-worker/n.png": "1b6c9d6c0c0a46cd45f9cd24e6abb9e01e822518172b2d25790e3bbb02a933d5",
          "assets/slice/actors/painted/directional/actor-kiln-worker/nw.png": "a22a77bb151bad838adf68be36d132039e1dcafe3c0b448edb9353e822a6445d",
          "assets/slice/actors/painted/directional/actor-kiln-worker/w.png": "a92a39752f13650b6f6359a113011f48eebeec8089c64fbd9bff3d954c37ffe6",
          "assets/slice/actors/painted/directional/actor-kiln-worker/sw.png": "07da8931ce572130a45678c6ea170311a731cf93371c233d9b6029370070775c"
        }
      }
    },
    {
      "recipeId": "actor-mortuary-guard-rotation",
      "recipe": "recipes/art/slice/actor-mortuary-guard-rotation.json",
      "recipeHash": "487c93771b46ed97c79a164b48e8ae3e26726903c34315777794cf4c6a4ffdb6",
      "class": "actor-sheet",
      "provider": "retro-diffusion:rd_animation__8_dir_rotation",
      "seed": 1303,
      "takes": 1,
      "generated": {
        "path": "assets/slice/actors/actor-mortuary-guard-rotation-0.png",
        "sha256": "3a7f5f9861fc58393406905e5fe76aac53cec3b881a6058b36e36d65e69e0363"
      },
      "packed": {
        "path": "assets/slice/packed/actors/actor-mortuary-guard-rotation.png",
        "sha256": "090f8194df50f0b1ba18f4dc0a40436dca8986242fdf482b1e26dc541f32a735",
        "size": [
          240,
          240
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "cell": {
          "width": 80,
          "height": 80
        },
        "sheet": {
          "grid": [
            3,
            3
          ],
          "cellFacings": [
            "se",
            "s",
            "sw",
            "e",
            null,
            "w",
            "ne",
            "n",
            "nw"
          ],
          "note": "Retro Diffusion's 8-direction rotation style lays the facings out as a mirrored compass: the top row looks towards the viewer (south), the bottom row looks away (north), and the left column looks screen-right (east), the right column screen-left (west). The centre cell is always empty. Read left-to-right, top-to-bottom; `cellFacings` names the facing drawn in each cell, and the manifest carries it so the renderer can pick a pose per facing. Verified by inspection of all six assets/slice/actors/*-rotation-0.png sheets (AUT-13617): the middle-left figure faces screen-right in every one."
        },
        "footY": 66
      },
      "animation": {
        "path": "assets/slice/packed/actors/painted/actor-mortuary-guard-rotation.png",
        "sha256": "3c16002a164177decbab21f3fc1374fda75634c0575a5b4d6919bf37b308d64c",
        "size": [
          1440,
          1408
        ],
        "cell": {
          "width": 120,
          "height": 88
        },
        "foot": [
          60,
          80
        ],
        "walkFacings": [
          "s",
          "se",
          "e",
          "ne",
          "n"
        ],
        "clips": {
          "walk": {
            "frames": [
              24,
              25,
              26,
              27,
              28,
              29
            ],
            "fps": 8,
            "loop": true,
            "facings": {
              "s": [
                0,
                1,
                2,
                3,
                4,
                5
              ],
              "se": [
                24,
                25,
                26,
                27,
                28,
                29
              ],
              "e": [
                48,
                49,
                50,
                51,
                52,
                53
              ],
              "ne": [
                72,
                73,
                74,
                75,
                76,
                77
              ],
              "n": [
                96,
                97,
                98,
                99,
                100,
                101
              ],
              "nw": [
                120,
                121,
                122,
                123,
                124,
                125
              ],
              "w": [
                144,
                145,
                146,
                147,
                148,
                149
              ],
              "sw": [
                168,
                169,
                170,
                171,
                172,
                173
              ]
            }
          },
          "attack": {
            "frames": [
              30,
              31,
              32,
              33,
              34,
              35
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                6,
                7,
                8,
                9,
                10,
                11
              ],
              "se": [
                30,
                31,
                32,
                33,
                34,
                35
              ],
              "e": [
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "ne": [
                78,
                79,
                80,
                81,
                82,
                83
              ],
              "n": [
                102,
                103,
                104,
                105,
                106,
                107
              ],
              "nw": [
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "w": [
                150,
                151,
                152,
                153,
                154,
                155
              ],
              "sw": [
                174,
                175,
                176,
                177,
                178,
                179
              ]
            }
          },
          "recoil": {
            "frames": [
              36,
              37
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                12,
                13
              ],
              "se": [
                36,
                37
              ],
              "e": [
                60,
                61
              ],
              "ne": [
                84,
                85
              ],
              "n": [
                108,
                109
              ],
              "nw": [
                132,
                133
              ],
              "w": [
                156,
                157
              ],
              "sw": [
                180,
                181
              ]
            }
          },
          "death": {
            "frames": [
              38,
              39,
              40,
              41
            ],
            "fps": 7,
            "loop": false,
            "facings": {
              "s": [
                14,
                15,
                16,
                17
              ],
              "se": [
                38,
                39,
                40,
                41
              ],
              "e": [
                62,
                63,
                64,
                65
              ],
              "ne": [
                86,
                87,
                88,
                89
              ],
              "n": [
                110,
                111,
                112,
                113
              ],
              "nw": [
                134,
                135,
                136,
                137
              ],
              "w": [
                158,
                159,
                160,
                161
              ],
              "sw": [
                182,
                183,
                184,
                185
              ]
            }
          },
          "corpse": {
            "frames": [
              41
            ],
            "fps": 1,
            "loop": false,
            "facings": {
              "s": [
                17
              ],
              "se": [
                41
              ],
              "e": [
                65
              ],
              "ne": [
                89
              ],
              "n": [
                113
              ],
              "nw": [
                137
              ],
              "w": [
                161
              ],
              "sw": [
                185
              ]
            }
          },
          "idle": {
            "frames": [
              42,
              43,
              44
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                18,
                19,
                20
              ],
              "se": [
                42,
                43,
                44
              ],
              "e": [
                66,
                67,
                68
              ],
              "ne": [
                90,
                91,
                92
              ],
              "n": [
                114,
                115,
                116
              ],
              "nw": [
                138,
                139,
                140
              ],
              "w": [
                162,
                163,
                164
              ],
              "sw": [
                186,
                187,
                188
              ]
            }
          },
          "work": {
            "frames": [
              45,
              46,
              47
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                21,
                22,
                23
              ],
              "se": [
                45,
                46,
                47
              ],
              "e": [
                69,
                70,
                71
              ],
              "ne": [
                93,
                94,
                95
              ],
              "n": [
                117,
                118,
                119
              ],
              "nw": [
                141,
                142,
                143
              ],
              "w": [
                165,
                166,
                167
              ],
              "sw": [
                189,
                190,
                191
              ]
            }
          }
        },
        "source": "assets/slice/actors/painted/directional/actor-mortuary-guard-rotation/s.png",
        "sourceHash": "7edaae3564d96096ec34ba5b9019e91eb27e6bc40ebc72717d9ea0cfc71ac54a",
        "recipe": "recipes/art/painted/actors/roster.json",
        "recipeHash": "c7d56c7285f33f43d1fc9f5e3542f57ab6f9a8df4d713a21717f50b7c894475a",
        "provider": "gpt-image-2",
        "sources": {
          "assets/slice/actors/painted/directional/actor-mortuary-guard-rotation/s.png": "7edaae3564d96096ec34ba5b9019e91eb27e6bc40ebc72717d9ea0cfc71ac54a",
          "assets/slice/actors/painted/directional/actor-mortuary-guard-rotation/se.png": "1015af78aa308ffd1d7ed0ef69b2b35e7b143f6af86c46041ecea5f61fbd2f26",
          "assets/slice/actors/painted/directional/actor-mortuary-guard-rotation/e.png": "bc61a62221e972106817235042b4d5d12f9e8f0830df094d811b71c22c7d9ce7",
          "assets/slice/actors/painted/directional/actor-mortuary-guard-rotation/ne.png": "1fe84b18dc3c776e64ab0c75f15bce6af06e55d799f33652c5a94acf47cc3e2b",
          "assets/slice/actors/painted/directional/actor-mortuary-guard-rotation/n.png": "66032dc9cf5fc59355d97b122f2b3d907a30971763b9a886406ec156e3b73000",
          "assets/slice/actors/painted/directional/actor-mortuary-guard-rotation/nw.png": "e3a9d3b70347705260ecc95820f31cd0f14cf36c6895e0b5b1c0bd907cc05e5f",
          "assets/slice/actors/painted/directional/actor-mortuary-guard-rotation/w.png": "ffa6c4d457f1a626617364ed5a68466e86f9ca69f892beb6b4eadcaaa74a1df9",
          "assets/slice/actors/painted/directional/actor-mortuary-guard-rotation/sw.png": "271f8c642b0d45abaf1242d75e1437a4b7e532efee55694545a44ae3b84bd981"
        }
      }
    },
    {
      "recipeId": "actor-outsider-axe-rotation",
      "recipe": "recipes/art/slice/actor-outsider-axe-rotation.json",
      "recipeHash": "c4876855ae56bd1a35ea45de804793f0c7a824d5712052a29d283a7051ab9ab4",
      "class": "actor-sheet",
      "provider": "retro-diffusion:rd_animation__8_dir_rotation",
      "seed": 641,
      "takes": 1,
      "generated": {
        "path": "assets/slice/actors/actor-outsider-axe-rotation-0.png",
        "sha256": "cc18299a40b6661aa2a79c9a3a98d0ddf99cf30e834d01e4f9bc99c654b086dc"
      },
      "packed": {
        "path": "assets/slice/packed/actors/actor-outsider-axe-rotation.png",
        "sha256": "7d73aa566322747e69dc5bae9a0a50b1dcf82e28fa279dea7ea26731855a3084",
        "size": [
          240,
          240
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "cell": {
          "width": 80,
          "height": 80
        },
        "sheet": {
          "grid": [
            3,
            3
          ],
          "cellFacings": [
            "se",
            "s",
            "sw",
            "e",
            null,
            "w",
            "ne",
            "n",
            "nw"
          ],
          "note": "Retro Diffusion's 8-direction rotation style lays the facings out as a mirrored compass: the top row looks towards the viewer (south), the bottom row looks away (north), and the left column looks screen-right (east), the right column screen-left (west). The centre cell is always empty. Read left-to-right, top-to-bottom; `cellFacings` names the facing drawn in each cell, and the manifest carries it so the renderer can pick a pose per facing. Verified by inspection of all six assets/slice/actors/*-rotation-0.png sheets (AUT-13617): the middle-left figure faces screen-right in every one."
        },
        "footY": 74
      },
      "animation": {
        "path": "assets/slice/packed/actors/painted/actor-outsider-axe-rotation.png",
        "sha256": "9c1ac52438cf8ddb96f8ef76ec301b8c9b71186104819cd57578f7e30f404d49",
        "size": [
          1248,
          1408
        ],
        "cell": {
          "width": 104,
          "height": 88
        },
        "foot": [
          52,
          80
        ],
        "walkFacings": [
          "s",
          "se",
          "e",
          "ne",
          "n"
        ],
        "clips": {
          "walk": {
            "frames": [
              24,
              25,
              26,
              27,
              28,
              29
            ],
            "fps": 8,
            "loop": true,
            "facings": {
              "s": [
                0,
                1,
                2,
                3,
                4,
                5
              ],
              "se": [
                24,
                25,
                26,
                27,
                28,
                29
              ],
              "e": [
                48,
                49,
                50,
                51,
                52,
                53
              ],
              "ne": [
                72,
                73,
                74,
                75,
                76,
                77
              ],
              "n": [
                96,
                97,
                98,
                99,
                100,
                101
              ],
              "nw": [
                120,
                121,
                122,
                123,
                124,
                125
              ],
              "w": [
                144,
                145,
                146,
                147,
                148,
                149
              ],
              "sw": [
                168,
                169,
                170,
                171,
                172,
                173
              ]
            }
          },
          "attack": {
            "frames": [
              30,
              31,
              32,
              33,
              34,
              35
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                6,
                7,
                8,
                9,
                10,
                11
              ],
              "se": [
                30,
                31,
                32,
                33,
                34,
                35
              ],
              "e": [
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "ne": [
                78,
                79,
                80,
                81,
                82,
                83
              ],
              "n": [
                102,
                103,
                104,
                105,
                106,
                107
              ],
              "nw": [
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "w": [
                150,
                151,
                152,
                153,
                154,
                155
              ],
              "sw": [
                174,
                175,
                176,
                177,
                178,
                179
              ]
            }
          },
          "recoil": {
            "frames": [
              36,
              37
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                12,
                13
              ],
              "se": [
                36,
                37
              ],
              "e": [
                60,
                61
              ],
              "ne": [
                84,
                85
              ],
              "n": [
                108,
                109
              ],
              "nw": [
                132,
                133
              ],
              "w": [
                156,
                157
              ],
              "sw": [
                180,
                181
              ]
            }
          },
          "death": {
            "frames": [
              38,
              39,
              40,
              41
            ],
            "fps": 7,
            "loop": false,
            "facings": {
              "s": [
                14,
                15,
                16,
                17
              ],
              "se": [
                38,
                39,
                40,
                41
              ],
              "e": [
                62,
                63,
                64,
                65
              ],
              "ne": [
                86,
                87,
                88,
                89
              ],
              "n": [
                110,
                111,
                112,
                113
              ],
              "nw": [
                134,
                135,
                136,
                137
              ],
              "w": [
                158,
                159,
                160,
                161
              ],
              "sw": [
                182,
                183,
                184,
                185
              ]
            }
          },
          "corpse": {
            "frames": [
              41
            ],
            "fps": 1,
            "loop": false,
            "facings": {
              "s": [
                17
              ],
              "se": [
                41
              ],
              "e": [
                65
              ],
              "ne": [
                89
              ],
              "n": [
                113
              ],
              "nw": [
                137
              ],
              "w": [
                161
              ],
              "sw": [
                185
              ]
            }
          },
          "idle": {
            "frames": [
              42,
              43,
              44
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                18,
                19,
                20
              ],
              "se": [
                42,
                43,
                44
              ],
              "e": [
                66,
                67,
                68
              ],
              "ne": [
                90,
                91,
                92
              ],
              "n": [
                114,
                115,
                116
              ],
              "nw": [
                138,
                139,
                140
              ],
              "w": [
                162,
                163,
                164
              ],
              "sw": [
                186,
                187,
                188
              ]
            }
          },
          "work": {
            "frames": [
              45,
              46,
              47
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                21,
                22,
                23
              ],
              "se": [
                45,
                46,
                47
              ],
              "e": [
                69,
                70,
                71
              ],
              "ne": [
                93,
                94,
                95
              ],
              "n": [
                117,
                118,
                119
              ],
              "nw": [
                141,
                142,
                143
              ],
              "w": [
                165,
                166,
                167
              ],
              "sw": [
                189,
                190,
                191
              ]
            }
          }
        },
        "source": "assets/slice/actors/painted/directional/actor-outsider-axe-rotation/s.png",
        "sourceHash": "ec3e6a02520b9c66dc7f8d72f2da1a6be02fcc25a7ea53301a686001eaf9769e",
        "recipe": "recipes/art/painted/actors/roster.json",
        "recipeHash": "c7d56c7285f33f43d1fc9f5e3542f57ab6f9a8df4d713a21717f50b7c894475a",
        "provider": "gpt-image-2",
        "sources": {
          "assets/slice/actors/painted/directional/actor-outsider-axe-rotation/s.png": "ec3e6a02520b9c66dc7f8d72f2da1a6be02fcc25a7ea53301a686001eaf9769e",
          "assets/slice/actors/painted/directional/actor-outsider-axe-rotation/se.png": "22fa3f4713f7d2acf561d3a04f014d8e58ea1f5a244c346f96aee619cddd8443",
          "assets/slice/actors/painted/directional/actor-outsider-axe-rotation/e.png": "32974138106e9daad459a1765627acaba7f99955d129892ba4aca3ec6d65481c",
          "assets/slice/actors/painted/directional/actor-outsider-axe-rotation/ne.png": "b1c9bdb63c48755bede4a86e7faf91410e4a2f806cae0d54d4d792c4d077bfed",
          "assets/slice/actors/painted/directional/actor-outsider-axe-rotation/n.png": "4be45e6b0e1c2c0c935746212433ee990bb7e639e06b7a0019252622b6f612e7",
          "assets/slice/actors/painted/directional/actor-outsider-axe-rotation/nw.png": "71ecc9d5d3efbd3288f06274cce3d61371e9aa61a11f5002cc9dbc2ddbae076b",
          "assets/slice/actors/painted/directional/actor-outsider-axe-rotation/w.png": "22eb6307c3b7c861051294e53bc4afeaf5302a123ffa340c681e8aeb48e4b1a6",
          "assets/slice/actors/painted/directional/actor-outsider-axe-rotation/sw.png": "dff2c1bbe93ec9c8c6f229f829a55cc9436b723bc63838f141a37248382eecdb"
        }
      }
    },
    {
      "recipeId": "actor-outsider-spear-shield-rotation",
      "recipe": "recipes/art/slice/actor-outsider-spear-shield-rotation.json",
      "recipeHash": "eeb6ae1e5e34331df68d71fddc3d9311822b727ce11c465dcefbe72dcd862beb",
      "class": "actor-sheet",
      "provider": "retro-diffusion:rd_animation__8_dir_rotation",
      "seed": 641,
      "takes": 1,
      "generated": {
        "path": "assets/slice/actors/actor-outsider-spear-shield-rotation-0.png",
        "sha256": "e6168fc9933111ceadcd19996bf89b749b0fc47f32bfb9fc6b167015ec0b5dc8"
      },
      "packed": {
        "path": "assets/slice/packed/actors/actor-outsider-spear-shield-rotation.png",
        "sha256": "d367f94c95d14d09d78d28b7cdcda47ed6089707622e0e3fe4e810322ebbbb47",
        "size": [
          240,
          240
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "cell": {
          "width": 80,
          "height": 80
        },
        "sheet": {
          "grid": [
            3,
            3
          ],
          "cellFacings": [
            "se",
            "s",
            "sw",
            "e",
            null,
            "w",
            "ne",
            "n",
            "nw"
          ],
          "note": "Retro Diffusion's 8-direction rotation style lays the facings out as a mirrored compass: the top row looks towards the viewer (south), the bottom row looks away (north), and the left column looks screen-right (east), the right column screen-left (west). The centre cell is always empty. Read left-to-right, top-to-bottom; `cellFacings` names the facing drawn in each cell, and the manifest carries it so the renderer can pick a pose per facing. Verified by inspection of all six assets/slice/actors/*-rotation-0.png sheets (AUT-13617): the middle-left figure faces screen-right in every one."
        },
        "footY": 70
      },
      "animation": {
        "path": "assets/slice/packed/actors/painted/actor-outsider-spear-shield-rotation.png",
        "sha256": "be601fc360693a678c201ea2f54e63ecc78b60a935565653957bc2561ec363b8",
        "size": [
          1536,
          1728
        ],
        "cell": {
          "width": 128,
          "height": 96
        },
        "foot": [
          64,
          88
        ],
        "walkFacings": [
          "s",
          "se",
          "e",
          "ne",
          "n"
        ],
        "clips": {
          "walk": {
            "frames": [
              24,
              25,
              26,
              27,
              28,
              29
            ],
            "fps": 8,
            "loop": true,
            "facings": {
              "s": [
                0,
                1,
                2,
                3,
                4,
                5
              ],
              "se": [
                24,
                25,
                26,
                27,
                28,
                29
              ],
              "e": [
                48,
                49,
                50,
                51,
                52,
                53
              ],
              "ne": [
                72,
                73,
                74,
                75,
                76,
                77
              ],
              "n": [
                96,
                97,
                98,
                99,
                100,
                101
              ],
              "nw": [
                120,
                121,
                122,
                123,
                124,
                125
              ],
              "w": [
                144,
                145,
                146,
                147,
                148,
                149
              ],
              "sw": [
                168,
                169,
                170,
                171,
                172,
                173
              ]
            }
          },
          "attack": {
            "frames": [
              30,
              31,
              32,
              33,
              34,
              35
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                6,
                7,
                8,
                9,
                10,
                11
              ],
              "se": [
                30,
                31,
                32,
                33,
                34,
                35
              ],
              "e": [
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "ne": [
                78,
                79,
                80,
                81,
                82,
                83
              ],
              "n": [
                102,
                103,
                104,
                105,
                106,
                107
              ],
              "nw": [
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "w": [
                150,
                151,
                152,
                153,
                154,
                155
              ],
              "sw": [
                174,
                175,
                176,
                177,
                178,
                179
              ]
            }
          },
          "recoil": {
            "frames": [
              36,
              37
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                12,
                13
              ],
              "se": [
                36,
                37
              ],
              "e": [
                60,
                61
              ],
              "ne": [
                84,
                85
              ],
              "n": [
                108,
                109
              ],
              "nw": [
                132,
                133
              ],
              "w": [
                156,
                157
              ],
              "sw": [
                180,
                181
              ]
            }
          },
          "death": {
            "frames": [
              38,
              39,
              40,
              41
            ],
            "fps": 7,
            "loop": false,
            "facings": {
              "s": [
                14,
                15,
                16,
                17
              ],
              "se": [
                38,
                39,
                40,
                41
              ],
              "e": [
                62,
                63,
                64,
                65
              ],
              "ne": [
                86,
                87,
                88,
                89
              ],
              "n": [
                110,
                111,
                112,
                113
              ],
              "nw": [
                134,
                135,
                136,
                137
              ],
              "w": [
                158,
                159,
                160,
                161
              ],
              "sw": [
                182,
                183,
                184,
                185
              ]
            }
          },
          "corpse": {
            "frames": [
              41
            ],
            "fps": 1,
            "loop": false,
            "facings": {
              "s": [
                17
              ],
              "se": [
                41
              ],
              "e": [
                65
              ],
              "ne": [
                89
              ],
              "n": [
                113
              ],
              "nw": [
                137
              ],
              "w": [
                161
              ],
              "sw": [
                185
              ]
            }
          },
          "idle": {
            "frames": [
              42,
              43,
              44
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                18,
                19,
                20
              ],
              "se": [
                42,
                43,
                44
              ],
              "e": [
                66,
                67,
                68
              ],
              "ne": [
                90,
                91,
                92
              ],
              "n": [
                114,
                115,
                116
              ],
              "nw": [
                138,
                139,
                140
              ],
              "w": [
                162,
                163,
                164
              ],
              "sw": [
                186,
                187,
                188
              ]
            }
          },
          "work": {
            "frames": [
              45,
              46,
              47
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                21,
                22,
                23
              ],
              "se": [
                45,
                46,
                47
              ],
              "e": [
                69,
                70,
                71
              ],
              "ne": [
                93,
                94,
                95
              ],
              "n": [
                117,
                118,
                119
              ],
              "nw": [
                141,
                142,
                143
              ],
              "w": [
                165,
                166,
                167
              ],
              "sw": [
                189,
                190,
                191
              ]
            }
          },
          "receive": {
            "frames": [
              195
            ],
            "facings": {
              "s": [
                192
              ],
              "se": [
                195
              ],
              "e": [
                198
              ],
              "ne": [
                201
              ],
              "n": [
                204
              ],
              "nw": [
                207
              ],
              "w": [
                210
              ],
              "sw": [
                213
              ]
            },
            "fps": 1,
            "loop": false
          },
          "bind": {
            "frames": [
              196
            ],
            "facings": {
              "s": [
                193
              ],
              "se": [
                196
              ],
              "e": [
                199
              ],
              "ne": [
                202
              ],
              "n": [
                205
              ],
              "nw": [
                208
              ],
              "w": [
                211
              ],
              "sw": [
                214
              ]
            },
            "fps": 1,
            "loop": false
          },
          "shove": {
            "frames": [
              197
            ],
            "facings": {
              "s": [
                194
              ],
              "se": [
                197
              ],
              "e": [
                200
              ],
              "ne": [
                203
              ],
              "n": [
                206
              ],
              "nw": [
                209
              ],
              "w": [
                212
              ],
              "sw": [
                215
              ]
            },
            "fps": 1,
            "loop": false
          }
        },
        "source": "assets/slice/actors/painted/directional/actor-outsider-spear-shield-rotation/s.png",
        "sourceHash": "05fefac32977a07d6efbca3b8067f4b0d3c5d1af6b0baf1a9a4b7bb17a0777e6",
        "recipe": "recipes/art/painted/actors/roster.json",
        "recipeHash": "c7d56c7285f33f43d1fc9f5e3542f57ab6f9a8df4d713a21717f50b7c894475a",
        "provider": "gpt-image-2",
        "sources": {
          "assets/slice/actors/painted/directional/actor-outsider-spear-shield-rotation/s.png": "05fefac32977a07d6efbca3b8067f4b0d3c5d1af6b0baf1a9a4b7bb17a0777e6",
          "assets/slice/actors/painted/directional/actor-outsider-spear-shield-rotation/se.png": "6346bc4f1318b9398681984f730dad12f8e8dc694333850b53e3ec0030670ecf",
          "assets/slice/actors/painted/directional/actor-outsider-spear-shield-rotation/e.png": "41ee297efb08f6ffe86e2710e9b81cd4cf2176a9d3bb10ea3d9e993d2b0cb7ac",
          "assets/slice/actors/painted/directional/actor-outsider-spear-shield-rotation/ne.png": "c30890dcff6074c83f9ec8e1fd774dbeefff472a9aade1c8fceb334a7d909013",
          "assets/slice/actors/painted/directional/actor-outsider-spear-shield-rotation/n.png": "346b977a06497e532c40561464fa89154a422e01921d0c432c00e648861f83c2",
          "assets/slice/actors/painted/directional/actor-outsider-spear-shield-rotation/nw.png": "65b95b7d03236f63d96dac367cbcf11f7623cdf636a52b72e93c553658911e30",
          "assets/slice/actors/painted/directional/actor-outsider-spear-shield-rotation/w.png": "5f7b0202bd0b30bab311b31c505cb66028550e8a0702fa3ff20037b635e27125",
          "assets/slice/actors/painted/directional/actor-outsider-spear-shield-rotation/sw.png": "9a38844703770003d89cb7f7b71c4571e03e09e25a9623cc9301a6b7a4860364",
          "assets/slice/actors/painted/contact/actor-outsider-spear-shield-rotation.png": "8316eaa8aeee9dc7f7f0fdf08a34840315757969c6a50f982be6283fefc82d93"
        }
      }
    },
    {
      "recipeId": "actor-outsider-sword-rotation",
      "recipe": "recipes/art/slice/actor-outsider-sword-rotation.json",
      "recipeHash": "9aa0f8711db823969cde756b5f60a5ce9dd9f61105bd67c6c8afd1ef94e1f1bb",
      "class": "actor-sheet",
      "provider": "retro-diffusion:rd_animation__8_dir_rotation",
      "seed": 641,
      "takes": 1,
      "generated": {
        "path": "assets/slice/actors/actor-outsider-sword-rotation-0.png",
        "sha256": "f66ea21bea0a8d9081ac80801edd196255c3d5ceea19f50f3e49b1989b0a28a4"
      },
      "packed": {
        "path": "assets/slice/packed/actors/actor-outsider-sword-rotation.png",
        "sha256": "e105d4b130dfdf3685b45392088d0086a40fe1e1523a3a334db111aacf27d28f",
        "size": [
          240,
          240
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "cell": {
          "width": 80,
          "height": 80
        },
        "sheet": {
          "grid": [
            3,
            3
          ],
          "cellFacings": [
            "se",
            "s",
            "sw",
            "e",
            null,
            "w",
            "ne",
            "n",
            "nw"
          ],
          "note": "Retro Diffusion's 8-direction rotation style lays the facings out as a mirrored compass: the top row looks towards the viewer (south), the bottom row looks away (north), and the left column looks screen-right (east), the right column screen-left (west). The centre cell is always empty. Read left-to-right, top-to-bottom; `cellFacings` names the facing drawn in each cell, and the manifest carries it so the renderer can pick a pose per facing. Verified by inspection of all six assets/slice/actors/*-rotation-0.png sheets (AUT-13617): the middle-left figure faces screen-right in every one."
        },
        "footY": 71
      },
      "animation": {
        "path": "assets/slice/packed/actors/painted/actor-outsider-sword-rotation.png",
        "sha256": "95c04dfaea46f1ff2386aa01caa98e76dc89948fb2f909f7b332d63ba49b55b0",
        "size": [
          1344,
          1584
        ],
        "cell": {
          "width": 112,
          "height": 88
        },
        "foot": [
          56,
          80
        ],
        "walkFacings": [
          "s",
          "se",
          "e",
          "ne",
          "n"
        ],
        "clips": {
          "walk": {
            "frames": [
              24,
              25,
              26,
              27,
              28,
              29
            ],
            "fps": 8,
            "loop": true,
            "facings": {
              "s": [
                0,
                1,
                2,
                3,
                4,
                5
              ],
              "se": [
                24,
                25,
                26,
                27,
                28,
                29
              ],
              "e": [
                48,
                49,
                50,
                51,
                52,
                53
              ],
              "ne": [
                72,
                73,
                74,
                75,
                76,
                77
              ],
              "n": [
                96,
                97,
                98,
                99,
                100,
                101
              ],
              "nw": [
                120,
                121,
                122,
                123,
                124,
                125
              ],
              "w": [
                144,
                145,
                146,
                147,
                148,
                149
              ],
              "sw": [
                168,
                169,
                170,
                171,
                172,
                173
              ]
            }
          },
          "attack": {
            "frames": [
              30,
              31,
              32,
              33,
              34,
              35
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                6,
                7,
                8,
                9,
                10,
                11
              ],
              "se": [
                30,
                31,
                32,
                33,
                34,
                35
              ],
              "e": [
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "ne": [
                78,
                79,
                80,
                81,
                82,
                83
              ],
              "n": [
                102,
                103,
                104,
                105,
                106,
                107
              ],
              "nw": [
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "w": [
                150,
                151,
                152,
                153,
                154,
                155
              ],
              "sw": [
                174,
                175,
                176,
                177,
                178,
                179
              ]
            }
          },
          "recoil": {
            "frames": [
              36,
              37
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                12,
                13
              ],
              "se": [
                36,
                37
              ],
              "e": [
                60,
                61
              ],
              "ne": [
                84,
                85
              ],
              "n": [
                108,
                109
              ],
              "nw": [
                132,
                133
              ],
              "w": [
                156,
                157
              ],
              "sw": [
                180,
                181
              ]
            }
          },
          "death": {
            "frames": [
              38,
              39,
              40,
              41
            ],
            "fps": 7,
            "loop": false,
            "facings": {
              "s": [
                14,
                15,
                16,
                17
              ],
              "se": [
                38,
                39,
                40,
                41
              ],
              "e": [
                62,
                63,
                64,
                65
              ],
              "ne": [
                86,
                87,
                88,
                89
              ],
              "n": [
                110,
                111,
                112,
                113
              ],
              "nw": [
                134,
                135,
                136,
                137
              ],
              "w": [
                158,
                159,
                160,
                161
              ],
              "sw": [
                182,
                183,
                184,
                185
              ]
            }
          },
          "corpse": {
            "frames": [
              41
            ],
            "fps": 1,
            "loop": false,
            "facings": {
              "s": [
                17
              ],
              "se": [
                41
              ],
              "e": [
                65
              ],
              "ne": [
                89
              ],
              "n": [
                113
              ],
              "nw": [
                137
              ],
              "w": [
                161
              ],
              "sw": [
                185
              ]
            }
          },
          "idle": {
            "frames": [
              42,
              43,
              44
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                18,
                19,
                20
              ],
              "se": [
                42,
                43,
                44
              ],
              "e": [
                66,
                67,
                68
              ],
              "ne": [
                90,
                91,
                92
              ],
              "n": [
                114,
                115,
                116
              ],
              "nw": [
                138,
                139,
                140
              ],
              "w": [
                162,
                163,
                164
              ],
              "sw": [
                186,
                187,
                188
              ]
            }
          },
          "work": {
            "frames": [
              45,
              46,
              47
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                21,
                22,
                23
              ],
              "se": [
                45,
                46,
                47
              ],
              "e": [
                69,
                70,
                71
              ],
              "ne": [
                93,
                94,
                95
              ],
              "n": [
                117,
                118,
                119
              ],
              "nw": [
                141,
                142,
                143
              ],
              "w": [
                165,
                166,
                167
              ],
              "sw": [
                189,
                190,
                191
              ]
            }
          },
          "receive": {
            "frames": [
              195
            ],
            "facings": {
              "s": [
                192
              ],
              "se": [
                195
              ],
              "e": [
                198
              ],
              "ne": [
                201
              ],
              "n": [
                204
              ],
              "nw": [
                207
              ],
              "w": [
                210
              ],
              "sw": [
                213
              ]
            },
            "fps": 1,
            "loop": false
          },
          "bind": {
            "frames": [
              196
            ],
            "facings": {
              "s": [
                193
              ],
              "se": [
                196
              ],
              "e": [
                199
              ],
              "ne": [
                202
              ],
              "n": [
                205
              ],
              "nw": [
                208
              ],
              "w": [
                211
              ],
              "sw": [
                214
              ]
            },
            "fps": 1,
            "loop": false
          },
          "shove": {
            "frames": [
              197
            ],
            "facings": {
              "s": [
                194
              ],
              "se": [
                197
              ],
              "e": [
                200
              ],
              "ne": [
                203
              ],
              "n": [
                206
              ],
              "nw": [
                209
              ],
              "w": [
                212
              ],
              "sw": [
                215
              ]
            },
            "fps": 1,
            "loop": false
          }
        },
        "source": "assets/slice/actors/painted/directional/actor-outsider-sword-rotation/s.png",
        "sourceHash": "1ed7e307176537cf4c1c434b67c1eb8a889b9c76624fa399ac11cf4f9fe160d2",
        "recipe": "recipes/art/painted/actors/roster.json",
        "recipeHash": "c7d56c7285f33f43d1fc9f5e3542f57ab6f9a8df4d713a21717f50b7c894475a",
        "provider": "gpt-image-2",
        "sources": {
          "assets/slice/actors/painted/directional/actor-outsider-sword-rotation/s.png": "1ed7e307176537cf4c1c434b67c1eb8a889b9c76624fa399ac11cf4f9fe160d2",
          "assets/slice/actors/painted/directional/actor-outsider-sword-rotation/se.png": "d30bec4dc348b633832d1dcf4a0c6a494a7f458dfccb0db8c03a5bc401b9d0b8",
          "assets/slice/actors/painted/directional/actor-outsider-sword-rotation/e.png": "3d22ed89b30878aada7822d8ffebb12cb8060c221ec9d5796ee41289ff022208",
          "assets/slice/actors/painted/directional/actor-outsider-sword-rotation/ne.png": "cf50980bcfd3dfe2bdf660f865cd62b40305cd1dc189dc1c482f76d0ce80f17f",
          "assets/slice/actors/painted/directional/actor-outsider-sword-rotation/n.png": "7722ebc964361f379d11f8b11a5ff5051c2e5456e580ee5f27b421b7a61fe535",
          "assets/slice/actors/painted/directional/actor-outsider-sword-rotation/nw.png": "203c83b6618dd6ff2ac7c2ffcd3c9dc1c6cc8de4ff2daed4fba543ad50b6879c",
          "assets/slice/actors/painted/directional/actor-outsider-sword-rotation/w.png": "f6047efe0adf283a6e7f1d496afe8bd7d5a961fc22b34eab59c8f24beaa4a555",
          "assets/slice/actors/painted/directional/actor-outsider-sword-rotation/sw.png": "98e0adb7b91195dee513b9b68956d6f8d39e8d2b286a64b7773d4394ee60a33f",
          "assets/slice/actors/painted/contact/actor-outsider-sword-rotation.png": "5f443b4f71b571c6c803ca7a97c708bccaa602149bff7c1e1c57a78245abf4a8"
        }
      }
    },
    {
      "recipeId": "actor-sela-venn",
      "recipe": "recipes/art/slice/actor-sela-venn.json",
      "recipeHash": "333abe481e4c54ce44b93a3707e7fe3ee4d55c376d5a723ee15b4ac4eaccab04",
      "class": "actor-sheet",
      "provider": "retro-diffusion:rd_animation__8_dir_rotation",
      "seed": 1312,
      "takes": 2,
      "generated": {
        "path": "assets/slice/actors/actor-sela-venn-0.png",
        "sha256": "589569817a3f8f6a720660b9e549142e3b87104ffdc8512eb5cbc0969a68e73c"
      },
      "packed": {
        "path": "assets/slice/packed/actors/actor-sela-venn.png",
        "sha256": "a9200bdaeaf14c113a10e435d760be8ac68d9f4073957083728e74947120f481",
        "size": [
          240,
          240
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "cell": {
          "width": 80,
          "height": 80
        },
        "sheet": {
          "grid": [
            3,
            3
          ],
          "cellFacings": [
            "se",
            "s",
            "sw",
            "e",
            null,
            "w",
            "ne",
            "n",
            "nw"
          ],
          "note": "Retro Diffusion's 8-direction rotation style lays the facings out as a mirrored compass: the top row looks towards the viewer (south), the bottom row looks away (north), and the left column looks screen-right (east), the right column screen-left (west). The centre cell is always empty. Read left-to-right, top-to-bottom; `cellFacings` names the facing drawn in each cell, and the manifest carries it so the renderer can pick a pose per facing. Verified by inspection of all six assets/slice/actors/*-rotation-0.png sheets (AUT-13617): the middle-left figure faces screen-right in every one."
        },
        "footY": 77,
        "standingHeight": 56
      },
      "animation": {
        "path": "assets/slice/packed/actors/painted/actor-sela-venn.png",
        "sha256": "dc891760f43130511eaeb64b0d4be45bc6fa64ede9136fd2d6b11c4fb43713be",
        "size": [
          1248,
          1280
        ],
        "cell": {
          "width": 104,
          "height": 80
        },
        "foot": [
          52,
          72
        ],
        "walkFacings": [
          "s",
          "se",
          "e",
          "ne",
          "n"
        ],
        "clips": {
          "walk": {
            "frames": [
              24,
              25,
              26,
              27,
              28,
              29
            ],
            "fps": 8,
            "loop": true,
            "facings": {
              "s": [
                0,
                1,
                2,
                3,
                4,
                5
              ],
              "se": [
                24,
                25,
                26,
                27,
                28,
                29
              ],
              "e": [
                48,
                49,
                50,
                51,
                52,
                53
              ],
              "ne": [
                72,
                73,
                74,
                75,
                76,
                77
              ],
              "n": [
                96,
                97,
                98,
                99,
                100,
                101
              ],
              "nw": [
                120,
                121,
                122,
                123,
                124,
                125
              ],
              "w": [
                144,
                145,
                146,
                147,
                148,
                149
              ],
              "sw": [
                168,
                169,
                170,
                171,
                172,
                173
              ]
            }
          },
          "attack": {
            "frames": [
              30,
              31,
              32,
              33,
              34,
              35
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                6,
                7,
                8,
                9,
                10,
                11
              ],
              "se": [
                30,
                31,
                32,
                33,
                34,
                35
              ],
              "e": [
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "ne": [
                78,
                79,
                80,
                81,
                82,
                83
              ],
              "n": [
                102,
                103,
                104,
                105,
                106,
                107
              ],
              "nw": [
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "w": [
                150,
                151,
                152,
                153,
                154,
                155
              ],
              "sw": [
                174,
                175,
                176,
                177,
                178,
                179
              ]
            }
          },
          "recoil": {
            "frames": [
              36,
              37
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                12,
                13
              ],
              "se": [
                36,
                37
              ],
              "e": [
                60,
                61
              ],
              "ne": [
                84,
                85
              ],
              "n": [
                108,
                109
              ],
              "nw": [
                132,
                133
              ],
              "w": [
                156,
                157
              ],
              "sw": [
                180,
                181
              ]
            }
          },
          "death": {
            "frames": [
              38,
              39,
              40,
              41
            ],
            "fps": 7,
            "loop": false,
            "facings": {
              "s": [
                14,
                15,
                16,
                17
              ],
              "se": [
                38,
                39,
                40,
                41
              ],
              "e": [
                62,
                63,
                64,
                65
              ],
              "ne": [
                86,
                87,
                88,
                89
              ],
              "n": [
                110,
                111,
                112,
                113
              ],
              "nw": [
                134,
                135,
                136,
                137
              ],
              "w": [
                158,
                159,
                160,
                161
              ],
              "sw": [
                182,
                183,
                184,
                185
              ]
            }
          },
          "corpse": {
            "frames": [
              41
            ],
            "fps": 1,
            "loop": false,
            "facings": {
              "s": [
                17
              ],
              "se": [
                41
              ],
              "e": [
                65
              ],
              "ne": [
                89
              ],
              "n": [
                113
              ],
              "nw": [
                137
              ],
              "w": [
                161
              ],
              "sw": [
                185
              ]
            }
          },
          "idle": {
            "frames": [
              42,
              43,
              44
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                18,
                19,
                20
              ],
              "se": [
                42,
                43,
                44
              ],
              "e": [
                66,
                67,
                68
              ],
              "ne": [
                90,
                91,
                92
              ],
              "n": [
                114,
                115,
                116
              ],
              "nw": [
                138,
                139,
                140
              ],
              "w": [
                162,
                163,
                164
              ],
              "sw": [
                186,
                187,
                188
              ]
            }
          },
          "work": {
            "frames": [
              45,
              46,
              47
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                21,
                22,
                23
              ],
              "se": [
                45,
                46,
                47
              ],
              "e": [
                69,
                70,
                71
              ],
              "ne": [
                93,
                94,
                95
              ],
              "n": [
                117,
                118,
                119
              ],
              "nw": [
                141,
                142,
                143
              ],
              "w": [
                165,
                166,
                167
              ],
              "sw": [
                189,
                190,
                191
              ]
            }
          }
        },
        "source": "assets/slice/actors/painted/directional/actor-sela-venn/s.png",
        "sourceHash": "343bc5d1be27a2847794c6fe4bb847b2d289d46cd88fa4a6900a539676e741a9",
        "recipe": "recipes/art/painted/actors/roster.json",
        "recipeHash": "c7d56c7285f33f43d1fc9f5e3542f57ab6f9a8df4d713a21717f50b7c894475a",
        "provider": "gpt-image-2",
        "sources": {
          "assets/slice/actors/painted/directional/actor-sela-venn/s.png": "343bc5d1be27a2847794c6fe4bb847b2d289d46cd88fa4a6900a539676e741a9",
          "assets/slice/actors/painted/directional/actor-sela-venn/se.png": "e7dc237f807f94e8bc116092b2835a9dceb663a94b25703f250bd235dc368ddd",
          "assets/slice/actors/painted/directional/actor-sela-venn/e.png": "1ae5568a7d0b23574f2b99270a8aa7f50ffff80cf0392468efc5b28fe73d6825",
          "assets/slice/actors/painted/directional/actor-sela-venn/ne.png": "8932b6bade52606797184735f172a70c2abc2e7884269b1364350b93aff1247e",
          "assets/slice/actors/painted/directional/actor-sela-venn/n.png": "be4dfd90a38575437c048ad5da831ae4c1d2ffbcb92eead31762e1092bbe551e",
          "assets/slice/actors/painted/directional/actor-sela-venn/nw.png": "523836149d15d275ed73cc1bf7238cdffc3b0426fef787f85084cd24e5f2af65",
          "assets/slice/actors/painted/directional/actor-sela-venn/w.png": "974244cea727d26a32a104e055f72f25a281df6f6452b03f6f1e75c44d35b291",
          "assets/slice/actors/painted/directional/actor-sela-venn/sw.png": "08a77d90ec44673884eee17033c07f3444fcc46a91a1b28343676a1b58b86923"
        }
      }
    },
    {
      "recipeId": "actor-tavren-noll",
      "recipe": "recipes/art/slice/actor-tavren-noll.json",
      "recipeHash": "3d26ed74370b13454ceda716d4d64c5a51a125d8724c718e81df9535cad25f25",
      "class": "actor-sheet",
      "provider": "retro-diffusion:rd_animation__8_dir_rotation",
      "seed": 1313,
      "takes": 2,
      "generated": {
        "path": "assets/slice/actors/actor-tavren-noll-0.png",
        "sha256": "d0ca88d3a0196afb7b17d7072cb6761d0b44d22844f7e601a8cecf0bcb7e5d9d"
      },
      "packed": {
        "path": "assets/slice/packed/actors/actor-tavren-noll.png",
        "sha256": "7e244345af6eef7b4cfa8e906c186a77f49dab70e57e5d4b5cc9a1dd16ff58cb",
        "size": [
          240,
          240
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "cell": {
          "width": 80,
          "height": 80
        },
        "sheet": {
          "grid": [
            3,
            3
          ],
          "cellFacings": [
            "se",
            "s",
            "sw",
            "e",
            null,
            "w",
            "ne",
            "n",
            "nw"
          ],
          "note": "Retro Diffusion's 8-direction rotation style lays the facings out as a mirrored compass: the top row looks towards the viewer (south), the bottom row looks away (north), and the left column looks screen-right (east), the right column screen-left (west). The centre cell is always empty. Read left-to-right, top-to-bottom; `cellFacings` names the facing drawn in each cell, and the manifest carries it so the renderer can pick a pose per facing. Verified by inspection of all six assets/slice/actors/*-rotation-0.png sheets (AUT-13617): the middle-left figure faces screen-right in every one."
        },
        "footY": 77
      },
      "animation": {
        "path": "assets/slice/packed/actors/painted/actor-tavren-noll.png",
        "sha256": "a742d4c15afcb59ed2e1341f1e286f724beb8f4eb9cf8b2a90ba20bcf507c329",
        "size": [
          1152,
          1408
        ],
        "cell": {
          "width": 96,
          "height": 88
        },
        "foot": [
          48,
          80
        ],
        "walkFacings": [
          "s",
          "se",
          "e",
          "ne",
          "n"
        ],
        "clips": {
          "walk": {
            "frames": [
              24,
              25,
              26,
              27,
              28,
              29
            ],
            "fps": 8,
            "loop": true,
            "facings": {
              "s": [
                0,
                1,
                2,
                3,
                4,
                5
              ],
              "se": [
                24,
                25,
                26,
                27,
                28,
                29
              ],
              "e": [
                48,
                49,
                50,
                51,
                52,
                53
              ],
              "ne": [
                72,
                73,
                74,
                75,
                76,
                77
              ],
              "n": [
                96,
                97,
                98,
                99,
                100,
                101
              ],
              "nw": [
                120,
                121,
                122,
                123,
                124,
                125
              ],
              "w": [
                144,
                145,
                146,
                147,
                148,
                149
              ],
              "sw": [
                168,
                169,
                170,
                171,
                172,
                173
              ]
            }
          },
          "attack": {
            "frames": [
              30,
              31,
              32,
              33,
              34,
              35
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                6,
                7,
                8,
                9,
                10,
                11
              ],
              "se": [
                30,
                31,
                32,
                33,
                34,
                35
              ],
              "e": [
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "ne": [
                78,
                79,
                80,
                81,
                82,
                83
              ],
              "n": [
                102,
                103,
                104,
                105,
                106,
                107
              ],
              "nw": [
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "w": [
                150,
                151,
                152,
                153,
                154,
                155
              ],
              "sw": [
                174,
                175,
                176,
                177,
                178,
                179
              ]
            }
          },
          "recoil": {
            "frames": [
              36,
              37
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                12,
                13
              ],
              "se": [
                36,
                37
              ],
              "e": [
                60,
                61
              ],
              "ne": [
                84,
                85
              ],
              "n": [
                108,
                109
              ],
              "nw": [
                132,
                133
              ],
              "w": [
                156,
                157
              ],
              "sw": [
                180,
                181
              ]
            }
          },
          "death": {
            "frames": [
              38,
              39,
              40,
              41
            ],
            "fps": 7,
            "loop": false,
            "facings": {
              "s": [
                14,
                15,
                16,
                17
              ],
              "se": [
                38,
                39,
                40,
                41
              ],
              "e": [
                62,
                63,
                64,
                65
              ],
              "ne": [
                86,
                87,
                88,
                89
              ],
              "n": [
                110,
                111,
                112,
                113
              ],
              "nw": [
                134,
                135,
                136,
                137
              ],
              "w": [
                158,
                159,
                160,
                161
              ],
              "sw": [
                182,
                183,
                184,
                185
              ]
            }
          },
          "corpse": {
            "frames": [
              41
            ],
            "fps": 1,
            "loop": false,
            "facings": {
              "s": [
                17
              ],
              "se": [
                41
              ],
              "e": [
                65
              ],
              "ne": [
                89
              ],
              "n": [
                113
              ],
              "nw": [
                137
              ],
              "w": [
                161
              ],
              "sw": [
                185
              ]
            }
          },
          "idle": {
            "frames": [
              42,
              43,
              44
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                18,
                19,
                20
              ],
              "se": [
                42,
                43,
                44
              ],
              "e": [
                66,
                67,
                68
              ],
              "ne": [
                90,
                91,
                92
              ],
              "n": [
                114,
                115,
                116
              ],
              "nw": [
                138,
                139,
                140
              ],
              "w": [
                162,
                163,
                164
              ],
              "sw": [
                186,
                187,
                188
              ]
            }
          },
          "work": {
            "frames": [
              45,
              46,
              47
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                21,
                22,
                23
              ],
              "se": [
                45,
                46,
                47
              ],
              "e": [
                69,
                70,
                71
              ],
              "ne": [
                93,
                94,
                95
              ],
              "n": [
                117,
                118,
                119
              ],
              "nw": [
                141,
                142,
                143
              ],
              "w": [
                165,
                166,
                167
              ],
              "sw": [
                189,
                190,
                191
              ]
            }
          }
        },
        "source": "assets/slice/actors/painted/directional/actor-tavren-noll/s.png",
        "sourceHash": "ee3643c962f52b8fece2b088a1fa46a17254097cb2f426aaf819f70c0c3ee5d3",
        "recipe": "recipes/art/painted/actors/roster.json",
        "recipeHash": "c7d56c7285f33f43d1fc9f5e3542f57ab6f9a8df4d713a21717f50b7c894475a",
        "provider": "gpt-image-2",
        "sources": {
          "assets/slice/actors/painted/directional/actor-tavren-noll/s.png": "ee3643c962f52b8fece2b088a1fa46a17254097cb2f426aaf819f70c0c3ee5d3",
          "assets/slice/actors/painted/directional/actor-tavren-noll/se.png": "922cf71c9344c3ce3783b8eeccf94f100cab8e41906057e3156f452a0dfb87fb",
          "assets/slice/actors/painted/directional/actor-tavren-noll/e.png": "24384f19b0bfc923ec03f569ff143b9910bcdb699cba143b30762121e798023d",
          "assets/slice/actors/painted/directional/actor-tavren-noll/ne.png": "d286bfc8e6c33d9c29acd1b4f1f15563a14ecd69d65359e35937b7cfe2055147",
          "assets/slice/actors/painted/directional/actor-tavren-noll/n.png": "accea05d3265cd6128cb6558582c46aeab3f66d1a9ea3d627be9ec1a9c82c013",
          "assets/slice/actors/painted/directional/actor-tavren-noll/nw.png": "09f03aaf75006884bad9605ee8de35c1279b1fd49d232a48f61d35bf25ff252b",
          "assets/slice/actors/painted/directional/actor-tavren-noll/w.png": "2e99a158640f3e2ab8244103e1342fc6fc938b91ad084ec3d15708292e207803",
          "assets/slice/actors/painted/directional/actor-tavren-noll/sw.png": "b131379ae7862f57e8a1e36727815204223d7fdc3fb2cd55eb37da45776cc870"
        }
      }
    },
    {
      "recipeId": "actor-towpath-scout-rotation",
      "recipe": "recipes/art/slice/actor-towpath-scout-rotation.json",
      "recipeHash": "f826887332fb3ab355f7c3791dbb4f13ab719e460c4f9f6a4154408b36ec35e7",
      "class": "actor-sheet",
      "provider": "retro-diffusion:rd_animation__8_dir_rotation",
      "seed": 1202,
      "takes": 1,
      "generated": {
        "path": "assets/slice/actors/actor-towpath-scout-rotation-0.png",
        "sha256": "6299694f3f20fe762b3849ec2c7bf8dd319a01c394f1c0cc491989e99a8a3846"
      },
      "packed": {
        "path": "assets/slice/packed/actors/actor-towpath-scout-rotation.png",
        "sha256": "42d3bdf21c196ee8dd2dd1430a3d3053515d2e18388913e05af0590c54cf0606",
        "size": [
          240,
          240
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "cell": {
          "width": 80,
          "height": 80
        },
        "sheet": {
          "grid": [
            3,
            3
          ],
          "cellFacings": [
            "se",
            "s",
            "sw",
            "e",
            null,
            "w",
            "ne",
            "n",
            "nw"
          ],
          "note": "Retro Diffusion's 8-direction rotation style lays the facings out as a mirrored compass: the top row looks towards the viewer (south), the bottom row looks away (north), and the left column looks screen-right (east), the right column screen-left (west). The centre cell is always empty. Read left-to-right, top-to-bottom; `cellFacings` names the facing drawn in each cell, and the manifest carries it so the renderer can pick a pose per facing. Verified by inspection of all six assets/slice/actors/*-rotation-0.png sheets (AUT-13617): the middle-left figure faces screen-right in every one."
        },
        "footY": 70
      },
      "animation": {
        "path": "assets/slice/packed/actors/painted/actor-towpath-scout-rotation.png",
        "sha256": "bb5dc604ccb3cb201ead78534ae5cfe8a7be95b0ef9c0a237353d2c1523b0f62",
        "size": [
          1152,
          1408
        ],
        "cell": {
          "width": 96,
          "height": 88
        },
        "foot": [
          48,
          80
        ],
        "walkFacings": [
          "s",
          "se",
          "e",
          "ne",
          "n"
        ],
        "clips": {
          "walk": {
            "frames": [
              24,
              25,
              26,
              27,
              28,
              29
            ],
            "fps": 8,
            "loop": true,
            "facings": {
              "s": [
                0,
                1,
                2,
                3,
                4,
                5
              ],
              "se": [
                24,
                25,
                26,
                27,
                28,
                29
              ],
              "e": [
                48,
                49,
                50,
                51,
                52,
                53
              ],
              "ne": [
                72,
                73,
                74,
                75,
                76,
                77
              ],
              "n": [
                96,
                97,
                98,
                99,
                100,
                101
              ],
              "nw": [
                120,
                121,
                122,
                123,
                124,
                125
              ],
              "w": [
                144,
                145,
                146,
                147,
                148,
                149
              ],
              "sw": [
                168,
                169,
                170,
                171,
                172,
                173
              ]
            }
          },
          "attack": {
            "frames": [
              30,
              31,
              32,
              33,
              34,
              35
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                6,
                7,
                8,
                9,
                10,
                11
              ],
              "se": [
                30,
                31,
                32,
                33,
                34,
                35
              ],
              "e": [
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "ne": [
                78,
                79,
                80,
                81,
                82,
                83
              ],
              "n": [
                102,
                103,
                104,
                105,
                106,
                107
              ],
              "nw": [
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "w": [
                150,
                151,
                152,
                153,
                154,
                155
              ],
              "sw": [
                174,
                175,
                176,
                177,
                178,
                179
              ]
            }
          },
          "recoil": {
            "frames": [
              36,
              37
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                12,
                13
              ],
              "se": [
                36,
                37
              ],
              "e": [
                60,
                61
              ],
              "ne": [
                84,
                85
              ],
              "n": [
                108,
                109
              ],
              "nw": [
                132,
                133
              ],
              "w": [
                156,
                157
              ],
              "sw": [
                180,
                181
              ]
            }
          },
          "death": {
            "frames": [
              38,
              39,
              40,
              41
            ],
            "fps": 7,
            "loop": false,
            "facings": {
              "s": [
                14,
                15,
                16,
                17
              ],
              "se": [
                38,
                39,
                40,
                41
              ],
              "e": [
                62,
                63,
                64,
                65
              ],
              "ne": [
                86,
                87,
                88,
                89
              ],
              "n": [
                110,
                111,
                112,
                113
              ],
              "nw": [
                134,
                135,
                136,
                137
              ],
              "w": [
                158,
                159,
                160,
                161
              ],
              "sw": [
                182,
                183,
                184,
                185
              ]
            }
          },
          "corpse": {
            "frames": [
              41
            ],
            "fps": 1,
            "loop": false,
            "facings": {
              "s": [
                17
              ],
              "se": [
                41
              ],
              "e": [
                65
              ],
              "ne": [
                89
              ],
              "n": [
                113
              ],
              "nw": [
                137
              ],
              "w": [
                161
              ],
              "sw": [
                185
              ]
            }
          },
          "idle": {
            "frames": [
              42,
              43,
              44
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                18,
                19,
                20
              ],
              "se": [
                42,
                43,
                44
              ],
              "e": [
                66,
                67,
                68
              ],
              "ne": [
                90,
                91,
                92
              ],
              "n": [
                114,
                115,
                116
              ],
              "nw": [
                138,
                139,
                140
              ],
              "w": [
                162,
                163,
                164
              ],
              "sw": [
                186,
                187,
                188
              ]
            }
          },
          "work": {
            "frames": [
              45,
              46,
              47
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                21,
                22,
                23
              ],
              "se": [
                45,
                46,
                47
              ],
              "e": [
                69,
                70,
                71
              ],
              "ne": [
                93,
                94,
                95
              ],
              "n": [
                117,
                118,
                119
              ],
              "nw": [
                141,
                142,
                143
              ],
              "w": [
                165,
                166,
                167
              ],
              "sw": [
                189,
                190,
                191
              ]
            }
          }
        },
        "source": "assets/slice/actors/painted/directional/actor-towpath-scout-rotation/s.png",
        "sourceHash": "9f58be7c55974a019a05b99f079ef28ffd716a970c4fb8e042a759211aa778f4",
        "recipe": "recipes/art/painted/actors/roster.json",
        "recipeHash": "c7d56c7285f33f43d1fc9f5e3542f57ab6f9a8df4d713a21717f50b7c894475a",
        "provider": "gpt-image-2",
        "sources": {
          "assets/slice/actors/painted/directional/actor-towpath-scout-rotation/s.png": "9f58be7c55974a019a05b99f079ef28ffd716a970c4fb8e042a759211aa778f4",
          "assets/slice/actors/painted/directional/actor-towpath-scout-rotation/se.png": "943043ee360c31f88f9a620a38a004f9c66adc5b8fc0e856b18b9ddf84fe7525",
          "assets/slice/actors/painted/directional/actor-towpath-scout-rotation/e.png": "e87dc96752d494989090ff9857ac67ed04bb649a87c0042a2be8a106b772185b",
          "assets/slice/actors/painted/directional/actor-towpath-scout-rotation/ne.png": "7c9f57c0e4919aec30d1319721f4376f40b995393cd5ba379c01fcd3ce83c72a",
          "assets/slice/actors/painted/directional/actor-towpath-scout-rotation/n.png": "208824a7b1fbc3e3af4a856a979e2ed223ba9f54fa0dac8aa45bcc74fceba17b",
          "assets/slice/actors/painted/directional/actor-towpath-scout-rotation/nw.png": "ed95795c0d5f2c68046df820d3210cc510436f4865bae8510c9c1056725a1edd",
          "assets/slice/actors/painted/directional/actor-towpath-scout-rotation/w.png": "1ce2f0f9a864cc33cde87511c64e44de9e9b13a6b6b5414c1e616f4f15b8eea2",
          "assets/slice/actors/painted/directional/actor-towpath-scout-rotation/sw.png": "76c283c0a2c60010d8a55b5901970e800f89906f9e9577b0df4ee4a568ac4ad4"
        }
      }
    },
    {
      "recipeId": "actor-unpaid-shield-rotation",
      "recipe": "recipes/art/slice/actor-unpaid-shield-rotation.json",
      "recipeHash": "5890059cf60e9ece5a2cfeaa6694d44c84c47538905054f2b523cdcedd978db5",
      "class": "actor-sheet",
      "provider": "retro-diffusion:rd_animation__8_dir_rotation",
      "seed": 1801,
      "takes": 8,
      "generated": {
        "path": "assets/slice/actors/actor-unpaid-shield-rotation-0.png",
        "sha256": "b524cc2284dddefc9781e7eeecb0c0079073f60434a21f530c7c35c57e0b05f3"
      },
      "packed": {
        "path": "assets/slice/packed/actors/actor-unpaid-shield-rotation.png",
        "sha256": "88dc3a83391062ced6ce6a1059c8443c17d1a3e4d5566d4bba3e8d7e16232e41",
        "size": [
          240,
          240
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "cell": {
          "width": 80,
          "height": 80
        },
        "sheet": {
          "grid": [
            3,
            3
          ],
          "cellFacings": [
            "se",
            "s",
            "sw",
            "e",
            null,
            "w",
            "ne",
            "n",
            "nw"
          ],
          "note": "Retro Diffusion's 8-direction rotation style lays the facings out as a mirrored compass: the top row looks towards the viewer (south), the bottom row looks away (north), and the left column looks screen-right (east), the right column screen-left (west). The centre cell is always empty. Read left-to-right, top-to-bottom; `cellFacings` names the facing drawn in each cell, and the manifest carries it so the renderer can pick a pose per facing. Verified by inspection of all six assets/slice/actors/*-rotation-0.png sheets (AUT-13617): the middle-left figure faces screen-right in every one."
        },
        "footY": 66
      },
      "animation": {
        "path": "assets/slice/packed/actors/painted/actor-unpaid-shield-rotation.png",
        "sha256": "7f4c4685f1b840a1fd63ad4542fc064bb9f574e567b33c3b2858bb2544fcb6c1",
        "size": [
          1536,
          1408
        ],
        "cell": {
          "width": 128,
          "height": 88
        },
        "foot": [
          64,
          80
        ],
        "walkFacings": [
          "s",
          "se",
          "e",
          "ne",
          "n"
        ],
        "clips": {
          "walk": {
            "frames": [
              24,
              25,
              26,
              27,
              28,
              29
            ],
            "fps": 8,
            "loop": true,
            "facings": {
              "s": [
                0,
                1,
                2,
                3,
                4,
                5
              ],
              "se": [
                24,
                25,
                26,
                27,
                28,
                29
              ],
              "e": [
                48,
                49,
                50,
                51,
                52,
                53
              ],
              "ne": [
                72,
                73,
                74,
                75,
                76,
                77
              ],
              "n": [
                96,
                97,
                98,
                99,
                100,
                101
              ],
              "nw": [
                120,
                121,
                122,
                123,
                124,
                125
              ],
              "w": [
                144,
                145,
                146,
                147,
                148,
                149
              ],
              "sw": [
                168,
                169,
                170,
                171,
                172,
                173
              ]
            }
          },
          "attack": {
            "frames": [
              30,
              31,
              32,
              33,
              34,
              35
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                6,
                7,
                8,
                9,
                10,
                11
              ],
              "se": [
                30,
                31,
                32,
                33,
                34,
                35
              ],
              "e": [
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "ne": [
                78,
                79,
                80,
                81,
                82,
                83
              ],
              "n": [
                102,
                103,
                104,
                105,
                106,
                107
              ],
              "nw": [
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "w": [
                150,
                151,
                152,
                153,
                154,
                155
              ],
              "sw": [
                174,
                175,
                176,
                177,
                178,
                179
              ]
            }
          },
          "recoil": {
            "frames": [
              36,
              37
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                12,
                13
              ],
              "se": [
                36,
                37
              ],
              "e": [
                60,
                61
              ],
              "ne": [
                84,
                85
              ],
              "n": [
                108,
                109
              ],
              "nw": [
                132,
                133
              ],
              "w": [
                156,
                157
              ],
              "sw": [
                180,
                181
              ]
            }
          },
          "death": {
            "frames": [
              38,
              39,
              40,
              41
            ],
            "fps": 7,
            "loop": false,
            "facings": {
              "s": [
                14,
                15,
                16,
                17
              ],
              "se": [
                38,
                39,
                40,
                41
              ],
              "e": [
                62,
                63,
                64,
                65
              ],
              "ne": [
                86,
                87,
                88,
                89
              ],
              "n": [
                110,
                111,
                112,
                113
              ],
              "nw": [
                134,
                135,
                136,
                137
              ],
              "w": [
                158,
                159,
                160,
                161
              ],
              "sw": [
                182,
                183,
                184,
                185
              ]
            }
          },
          "corpse": {
            "frames": [
              41
            ],
            "fps": 1,
            "loop": false,
            "facings": {
              "s": [
                17
              ],
              "se": [
                41
              ],
              "e": [
                65
              ],
              "ne": [
                89
              ],
              "n": [
                113
              ],
              "nw": [
                137
              ],
              "w": [
                161
              ],
              "sw": [
                185
              ]
            }
          },
          "idle": {
            "frames": [
              42,
              43,
              44
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                18,
                19,
                20
              ],
              "se": [
                42,
                43,
                44
              ],
              "e": [
                66,
                67,
                68
              ],
              "ne": [
                90,
                91,
                92
              ],
              "n": [
                114,
                115,
                116
              ],
              "nw": [
                138,
                139,
                140
              ],
              "w": [
                162,
                163,
                164
              ],
              "sw": [
                186,
                187,
                188
              ]
            }
          },
          "work": {
            "frames": [
              45,
              46,
              47
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                21,
                22,
                23
              ],
              "se": [
                45,
                46,
                47
              ],
              "e": [
                69,
                70,
                71
              ],
              "ne": [
                93,
                94,
                95
              ],
              "n": [
                117,
                118,
                119
              ],
              "nw": [
                141,
                142,
                143
              ],
              "w": [
                165,
                166,
                167
              ],
              "sw": [
                189,
                190,
                191
              ]
            }
          }
        },
        "source": "assets/slice/actors/painted/directional/actor-unpaid-shield-rotation/s.png",
        "sourceHash": "e0cc6bf39095ec6af0c866a56bc61ecc9eada3ae95af66112856a96e2a431e0f",
        "recipe": "recipes/art/painted/actors/roster.json",
        "recipeHash": "c7d56c7285f33f43d1fc9f5e3542f57ab6f9a8df4d713a21717f50b7c894475a",
        "provider": "gpt-image-2",
        "sources": {
          "assets/slice/actors/painted/directional/actor-unpaid-shield-rotation/s.png": "e0cc6bf39095ec6af0c866a56bc61ecc9eada3ae95af66112856a96e2a431e0f",
          "assets/slice/actors/painted/directional/actor-unpaid-shield-rotation/se.png": "51ab852f1180c5f7427a0863709ffb632659fd33fdc4b0a212db43482121676f",
          "assets/slice/actors/painted/directional/actor-unpaid-shield-rotation/e.png": "88033149fc523af0b69f1c709087b358c2ef832b418b85da856428b64a9b7873",
          "assets/slice/actors/painted/directional/actor-unpaid-shield-rotation/ne.png": "e8c8cf8be7cc2ac1e2bfbd663caa49b09a4e6d5b8e2713702ff41cf6e6a64d8e",
          "assets/slice/actors/painted/directional/actor-unpaid-shield-rotation/n.png": "50945d376657d27d2c662bb6e633f283f3c1d2a4503c460c4af797d9e27d2a8d",
          "assets/slice/actors/painted/directional/actor-unpaid-shield-rotation/nw.png": "dd2b535c971ee2e447e9a73335b28227a981c59c80947036d2262f2d8c7f754f",
          "assets/slice/actors/painted/directional/actor-unpaid-shield-rotation/w.png": "531dd116e81489cbf28cde8db485f24a7ae8ded0341962a3f9c1c648a694038f",
          "assets/slice/actors/painted/directional/actor-unpaid-shield-rotation/sw.png": "55160fecce756e24653adcf46c656aff367005c1999cd0b26d8c375d8a246cf1"
        }
      }
    },
    {
      "recipeId": "actor-waiting-family",
      "recipe": "recipes/art/slice/actor-waiting-family.json",
      "recipeHash": "43911f469b9773485cba04ab8cf3284f388408b2ddc35e8357b206fa71b3d409",
      "class": "actor-sheet",
      "provider": "retro-diffusion:rd_animation__8_dir_rotation",
      "seed": 1314,
      "takes": 2,
      "generated": {
        "path": "assets/slice/actors/actor-waiting-family-0.png",
        "sha256": "eedf00ab44cb26c595095f96b5506e2653e03763ecc707d208d111066b7e0b42"
      },
      "packed": {
        "path": "assets/slice/packed/actors/actor-waiting-family.png",
        "sha256": "f3fecffb8a7abfc142cf6215eb29bd23a3843f8d2ec82f53cdb85222308ae87d",
        "size": [
          240,
          240
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "cell": {
          "width": 80,
          "height": 80
        },
        "sheet": {
          "grid": [
            3,
            3
          ],
          "cellFacings": [
            "se",
            "s",
            "sw",
            "e",
            null,
            "w",
            "ne",
            "n",
            "nw"
          ],
          "note": "Retro Diffusion's 8-direction rotation style lays the facings out as a mirrored compass: the top row looks towards the viewer (south), the bottom row looks away (north), and the left column looks screen-right (east), the right column screen-left (west). The centre cell is always empty. Read left-to-right, top-to-bottom; `cellFacings` names the facing drawn in each cell, and the manifest carries it so the renderer can pick a pose per facing. Verified by inspection of all six assets/slice/actors/*-rotation-0.png sheets (AUT-13617): the middle-left figure faces screen-right in every one."
        },
        "footY": 75
      },
      "animation": {
        "path": "assets/slice/packed/actors/painted/actor-waiting-family.png",
        "sha256": "a49b36e7e012b8fcda6716c3e1dcf071219fe0c9b778f3524d3a4bdc68b7a362",
        "size": [
          1344,
          1280
        ],
        "cell": {
          "width": 112,
          "height": 80
        },
        "foot": [
          56,
          72
        ],
        "walkFacings": [
          "s",
          "se",
          "e",
          "ne",
          "n"
        ],
        "clips": {
          "walk": {
            "frames": [
              24,
              25,
              26,
              27,
              28,
              29
            ],
            "fps": 8,
            "loop": true,
            "facings": {
              "s": [
                0,
                1,
                2,
                3,
                4,
                5
              ],
              "se": [
                24,
                25,
                26,
                27,
                28,
                29
              ],
              "e": [
                48,
                49,
                50,
                51,
                52,
                53
              ],
              "ne": [
                72,
                73,
                74,
                75,
                76,
                77
              ],
              "n": [
                96,
                97,
                98,
                99,
                100,
                101
              ],
              "nw": [
                120,
                121,
                122,
                123,
                124,
                125
              ],
              "w": [
                144,
                145,
                146,
                147,
                148,
                149
              ],
              "sw": [
                168,
                169,
                170,
                171,
                172,
                173
              ]
            }
          },
          "attack": {
            "frames": [
              30,
              31,
              32,
              33,
              34,
              35
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                6,
                7,
                8,
                9,
                10,
                11
              ],
              "se": [
                30,
                31,
                32,
                33,
                34,
                35
              ],
              "e": [
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "ne": [
                78,
                79,
                80,
                81,
                82,
                83
              ],
              "n": [
                102,
                103,
                104,
                105,
                106,
                107
              ],
              "nw": [
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "w": [
                150,
                151,
                152,
                153,
                154,
                155
              ],
              "sw": [
                174,
                175,
                176,
                177,
                178,
                179
              ]
            }
          },
          "recoil": {
            "frames": [
              36,
              37
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                12,
                13
              ],
              "se": [
                36,
                37
              ],
              "e": [
                60,
                61
              ],
              "ne": [
                84,
                85
              ],
              "n": [
                108,
                109
              ],
              "nw": [
                132,
                133
              ],
              "w": [
                156,
                157
              ],
              "sw": [
                180,
                181
              ]
            }
          },
          "death": {
            "frames": [
              38,
              39,
              40,
              41
            ],
            "fps": 7,
            "loop": false,
            "facings": {
              "s": [
                14,
                15,
                16,
                17
              ],
              "se": [
                38,
                39,
                40,
                41
              ],
              "e": [
                62,
                63,
                64,
                65
              ],
              "ne": [
                86,
                87,
                88,
                89
              ],
              "n": [
                110,
                111,
                112,
                113
              ],
              "nw": [
                134,
                135,
                136,
                137
              ],
              "w": [
                158,
                159,
                160,
                161
              ],
              "sw": [
                182,
                183,
                184,
                185
              ]
            }
          },
          "corpse": {
            "frames": [
              41
            ],
            "fps": 1,
            "loop": false,
            "facings": {
              "s": [
                17
              ],
              "se": [
                41
              ],
              "e": [
                65
              ],
              "ne": [
                89
              ],
              "n": [
                113
              ],
              "nw": [
                137
              ],
              "w": [
                161
              ],
              "sw": [
                185
              ]
            }
          },
          "idle": {
            "frames": [
              42,
              43,
              44
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                18,
                19,
                20
              ],
              "se": [
                42,
                43,
                44
              ],
              "e": [
                66,
                67,
                68
              ],
              "ne": [
                90,
                91,
                92
              ],
              "n": [
                114,
                115,
                116
              ],
              "nw": [
                138,
                139,
                140
              ],
              "w": [
                162,
                163,
                164
              ],
              "sw": [
                186,
                187,
                188
              ]
            }
          },
          "work": {
            "frames": [
              45,
              46,
              47
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                21,
                22,
                23
              ],
              "se": [
                45,
                46,
                47
              ],
              "e": [
                69,
                70,
                71
              ],
              "ne": [
                93,
                94,
                95
              ],
              "n": [
                117,
                118,
                119
              ],
              "nw": [
                141,
                142,
                143
              ],
              "w": [
                165,
                166,
                167
              ],
              "sw": [
                189,
                190,
                191
              ]
            }
          }
        },
        "source": "assets/slice/actors/painted/directional/actor-waiting-family/s.png",
        "sourceHash": "798d94cf917475a03eaca8453dffae7120c572963a600e9ec96ed35d54640e60",
        "recipe": "recipes/art/painted/actors/roster.json",
        "recipeHash": "c7d56c7285f33f43d1fc9f5e3542f57ab6f9a8df4d713a21717f50b7c894475a",
        "provider": "gpt-image-2",
        "sources": {
          "assets/slice/actors/painted/directional/actor-waiting-family/s.png": "798d94cf917475a03eaca8453dffae7120c572963a600e9ec96ed35d54640e60",
          "assets/slice/actors/painted/directional/actor-waiting-family/se.png": "e354bce129cd03c3f3724ddf01b87407890e2a27bca11dedd22ea587960bb0fa",
          "assets/slice/actors/painted/directional/actor-waiting-family/e.png": "09b6c9eb6b7018b9e67583635e412a97548facee402ec169a55b71d54fed5b89",
          "assets/slice/actors/painted/directional/actor-waiting-family/ne.png": "393926705cb0570c56383653ced7c9ffc15e63d0e523cbc17acec5a5ed76c69f",
          "assets/slice/actors/painted/directional/actor-waiting-family/n.png": "138f86ffbd65f23746ea86e5604ff8260e5255d57176311a02ec5780c14686f6",
          "assets/slice/actors/painted/directional/actor-waiting-family/nw.png": "b31a6bf43ed828567777fabc7d999ba6c4cf84846124b97c32083d214c0f1a9e",
          "assets/slice/actors/painted/directional/actor-waiting-family/w.png": "045ed17ad1434d7c16d398cd1d9839af4c0f01862fee8a5c50a046e4ce285fd7",
          "assets/slice/actors/painted/directional/actor-waiting-family/sw.png": "a8a188c9fbbe58f54eb3244467e326fdeafa280c834855cca0fdd27845b12e62"
        }
      }
    },
    {
      "recipeId": "actor-working-dead",
      "recipe": "recipes/art/slice/actor-working-dead.json",
      "recipeHash": "1b702fbf7ff15511ab9fa703ee25dc726fbf15d3ebceb7b4cac6b11cad05dce2",
      "class": "actor-sheet",
      "provider": "retro-diffusion:rd_animation__8_dir_rotation",
      "seed": 1311,
      "takes": 2,
      "generated": {
        "path": "assets/slice/actors/actor-working-dead-0.png",
        "sha256": "80f3c3d02191e3dd0f16a9e9622a54801dbab0d83ea8b8b1eeea0e25919ff42d"
      },
      "packed": {
        "path": "assets/slice/packed/actors/actor-working-dead.png",
        "sha256": "6b442001aaa96868474370ecb4acc8bd0417be687c4a815fb7a71a9d27f3c6f4",
        "size": [
          240,
          240
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "cell": {
          "width": 80,
          "height": 80
        },
        "sheet": {
          "grid": [
            3,
            3
          ],
          "cellFacings": [
            "se",
            "s",
            "sw",
            "e",
            null,
            "w",
            "ne",
            "n",
            "nw"
          ],
          "note": "Retro Diffusion's 8-direction rotation style lays the facings out as a mirrored compass: the top row looks towards the viewer (south), the bottom row looks away (north), and the left column looks screen-right (east), the right column screen-left (west). The centre cell is always empty. Read left-to-right, top-to-bottom; `cellFacings` names the facing drawn in each cell, and the manifest carries it so the renderer can pick a pose per facing. Verified by inspection of all six assets/slice/actors/*-rotation-0.png sheets (AUT-13617): the middle-left figure faces screen-right in every one."
        },
        "footY": 61
      },
      "animation": {
        "path": "assets/slice/packed/actors/painted/actor-working-dead.png",
        "sha256": "35705a249fc9b32841e6de766b07bb73760c2fef826c80da6d03f211c5c48e09",
        "size": [
          1152,
          1280
        ],
        "cell": {
          "width": 96,
          "height": 80
        },
        "foot": [
          48,
          72
        ],
        "walkFacings": [
          "s",
          "se",
          "e",
          "ne",
          "n"
        ],
        "clips": {
          "walk": {
            "frames": [
              24,
              25,
              26,
              27,
              28,
              29
            ],
            "fps": 8,
            "loop": true,
            "facings": {
              "s": [
                0,
                1,
                2,
                3,
                4,
                5
              ],
              "se": [
                24,
                25,
                26,
                27,
                28,
                29
              ],
              "e": [
                48,
                49,
                50,
                51,
                52,
                53
              ],
              "ne": [
                72,
                73,
                74,
                75,
                76,
                77
              ],
              "n": [
                96,
                97,
                98,
                99,
                100,
                101
              ],
              "nw": [
                120,
                121,
                122,
                123,
                124,
                125
              ],
              "w": [
                144,
                145,
                146,
                147,
                148,
                149
              ],
              "sw": [
                168,
                169,
                170,
                171,
                172,
                173
              ]
            }
          },
          "attack": {
            "frames": [
              30,
              31,
              32,
              33,
              34,
              35
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                6,
                7,
                8,
                9,
                10,
                11
              ],
              "se": [
                30,
                31,
                32,
                33,
                34,
                35
              ],
              "e": [
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "ne": [
                78,
                79,
                80,
                81,
                82,
                83
              ],
              "n": [
                102,
                103,
                104,
                105,
                106,
                107
              ],
              "nw": [
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "w": [
                150,
                151,
                152,
                153,
                154,
                155
              ],
              "sw": [
                174,
                175,
                176,
                177,
                178,
                179
              ]
            }
          },
          "recoil": {
            "frames": [
              36,
              37
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                12,
                13
              ],
              "se": [
                36,
                37
              ],
              "e": [
                60,
                61
              ],
              "ne": [
                84,
                85
              ],
              "n": [
                108,
                109
              ],
              "nw": [
                132,
                133
              ],
              "w": [
                156,
                157
              ],
              "sw": [
                180,
                181
              ]
            }
          },
          "death": {
            "frames": [
              38,
              39,
              40,
              41
            ],
            "fps": 7,
            "loop": false,
            "facings": {
              "s": [
                14,
                15,
                16,
                17
              ],
              "se": [
                38,
                39,
                40,
                41
              ],
              "e": [
                62,
                63,
                64,
                65
              ],
              "ne": [
                86,
                87,
                88,
                89
              ],
              "n": [
                110,
                111,
                112,
                113
              ],
              "nw": [
                134,
                135,
                136,
                137
              ],
              "w": [
                158,
                159,
                160,
                161
              ],
              "sw": [
                182,
                183,
                184,
                185
              ]
            }
          },
          "corpse": {
            "frames": [
              41
            ],
            "fps": 1,
            "loop": false,
            "facings": {
              "s": [
                17
              ],
              "se": [
                41
              ],
              "e": [
                65
              ],
              "ne": [
                89
              ],
              "n": [
                113
              ],
              "nw": [
                137
              ],
              "w": [
                161
              ],
              "sw": [
                185
              ]
            }
          },
          "idle": {
            "frames": [
              42,
              43,
              44
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                18,
                19,
                20
              ],
              "se": [
                42,
                43,
                44
              ],
              "e": [
                66,
                67,
                68
              ],
              "ne": [
                90,
                91,
                92
              ],
              "n": [
                114,
                115,
                116
              ],
              "nw": [
                138,
                139,
                140
              ],
              "w": [
                162,
                163,
                164
              ],
              "sw": [
                186,
                187,
                188
              ]
            }
          },
          "work": {
            "frames": [
              45,
              46,
              47
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                21,
                22,
                23
              ],
              "se": [
                45,
                46,
                47
              ],
              "e": [
                69,
                70,
                71
              ],
              "ne": [
                93,
                94,
                95
              ],
              "n": [
                117,
                118,
                119
              ],
              "nw": [
                141,
                142,
                143
              ],
              "w": [
                165,
                166,
                167
              ],
              "sw": [
                189,
                190,
                191
              ]
            }
          }
        },
        "source": "assets/slice/actors/painted/directional/actor-working-dead/s.png",
        "sourceHash": "b64c5a6cbc391ea56091e3fd974f53ebfde0ac7b97648ef2088edbf5d15afcd9",
        "recipe": "recipes/art/painted/actors/roster.json",
        "recipeHash": "c7d56c7285f33f43d1fc9f5e3542f57ab6f9a8df4d713a21717f50b7c894475a",
        "provider": "gpt-image-2",
        "sources": {
          "assets/slice/actors/painted/directional/actor-working-dead/s.png": "b64c5a6cbc391ea56091e3fd974f53ebfde0ac7b97648ef2088edbf5d15afcd9",
          "assets/slice/actors/painted/directional/actor-working-dead/se.png": "cb6f41534551272d5c930d946a6f02656ebd9eec36373fb2be5b90ea9149ae39",
          "assets/slice/actors/painted/directional/actor-working-dead/e.png": "d92f7554b7e8f1150c59595019df59daa49ed599eb2730f1d797f58cbfb27b9a",
          "assets/slice/actors/painted/directional/actor-working-dead/ne.png": "7fe521256d33cab3a63a0551b8c96028669c153e31442e04b7fdf7d382e33375",
          "assets/slice/actors/painted/directional/actor-working-dead/n.png": "5c65b57ae3f8f381b1876288e639aa49b3ae230fabfdd45c50fc0cc45e19c809",
          "assets/slice/actors/painted/directional/actor-working-dead/nw.png": "3eda7192bdb2f7b13b542c27025de692d8362ccea58d16fd66dd8690e64db9da",
          "assets/slice/actors/painted/directional/actor-working-dead/w.png": "907aa98613ff551cf6b33f145cd73c17dc4fd4136c22db774709536ef6fc9850",
          "assets/slice/actors/painted/directional/actor-working-dead/sw.png": "ec95bf05a600ebf60dd7c254c284da0607fec19f68a9a6953406ba100994c971"
        }
      }
    },
    {
      "recipeId": "mark-brz-sun-disc",
      "recipe": "recipes/art/slice/mark-brz-sun-disc.json",
      "recipeHash": "a1f00080651b6cf4c52275106d22c3c8f60543ec27b9c3ae3a68a48b260426fd",
      "class": "faction-mark",
      "provider": "retro-diffusion:rd_pro__isometric",
      "seed": 7102,
      "takes": 1,
      "generated": {
        "path": "assets/slice/marks/mark-brz-sun-disc-0.png",
        "sha256": "dfb23bd17fc403470d95c14cbb6ad96a5978e0dd7415c426344f6be656071ee2"
      },
      "packed": {
        "path": "assets/slice/packed/marks/mark-brz-sun-disc.png",
        "sha256": "c28413491f2cabef8378ac6607644b1de73d26fabf31f1a3e2df303c38b896d3",
        "size": [
          31,
          32
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "screenHeight": 32,
        "anchor": "bottom-centre"
      }
    },
    {
      "recipeId": "mark-ree-reed-hook",
      "recipe": "recipes/art/slice/mark-ree-reed-hook.json",
      "recipeHash": "1ebca09a7efd00a2f3fbffa747d734e9259ce2182db34f9777a14a813450f3ca",
      "class": "faction-mark",
      "provider": "retro-diffusion:rd_pro__isometric",
      "seed": 7103,
      "takes": 1,
      "generated": {
        "path": "assets/slice/marks/mark-ree-reed-hook-0.png",
        "sha256": "128247a97df957756a613784652ca61e5042b1e2c4294b21a0d4696d0e1a55a1"
      },
      "packed": {
        "path": "assets/slice/packed/marks/mark-ree-reed-hook.png",
        "sha256": "90eaa69c9e9350cf26fe112dbe4fdfa1c278e878e87318dab15208c7808066d5",
        "size": [
          29,
          32
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "screenHeight": 32,
        "anchor": "bottom-centre"
      }
    },
    {
      "recipeId": "mark-sal-sail-weight",
      "recipe": "recipes/art/slice/mark-sal-sail-weight.json",
      "recipeHash": "23e54988876f1a48c0728504fc91597c0652aa095b41eb646e7910168c58dc72",
      "class": "faction-mark",
      "provider": "retro-diffusion:rd_pro__isometric",
      "seed": 7104,
      "takes": 1,
      "generated": {
        "path": "assets/slice/marks/mark-sal-sail-weight-0.png",
        "sha256": "d18f93e774f88c31307293da0bb1f8cd23767c8b1c1c322a08f06a742eaa8b2a"
      },
      "packed": {
        "path": "assets/slice/packed/marks/mark-sal-sail-weight.png",
        "sha256": "af25df756b61958d5377e554a35defa0a6c8c7003b2338e829deed75c426eb72",
        "size": [
          28,
          32
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "screenHeight": 32,
        "anchor": "bottom-centre"
      }
    },
    {
      "recipeId": "mark-sen-broken-ring",
      "recipe": "recipes/art/slice/mark-sen-broken-ring.json",
      "recipeHash": "57c9a028bb4c3411f78bed47e4de8963f8226aad9252dce97c4e4b35d952475e",
      "class": "faction-mark",
      "provider": "retro-diffusion:rd_pro__isometric",
      "seed": 7101,
      "takes": 1,
      "generated": {
        "path": "assets/slice/marks/mark-sen-broken-ring-0.png",
        "sha256": "d0d09e730a57c91521ad8fc2dec0101e53a4f814e469ab08b65b1d2896d851f7"
      },
      "packed": {
        "path": "assets/slice/packed/marks/mark-sen-broken-ring.png",
        "sha256": "6f1e281c7f552ddeacf3a1d3784f42b5a482c29e85a5dff848aab14de06cd0da",
        "size": [
          29,
          32
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "screenHeight": 32,
        "anchor": "bottom-centre"
      }
    },
    {
      "recipeId": "prop-arch-gate",
      "recipe": "recipes/art/slice/prop-arch-gate.json",
      "recipeHash": "95d95160bfdd54a56135d38b4848d95ba71e37f921b88c85a1cdcb311f1fa782",
      "class": "environment-prop",
      "provider": "retro-diffusion:rd_pro__isometric",
      "seed": 7001,
      "takes": 1,
      "generated": {
        "path": "assets/slice/props/prop-arch-gate-0.png",
        "sha256": "0ff63b47bf4d48b8b14a295f71368fc70ddca9bde142fcb6a2703d6d89fc3913"
      },
      "packed": {
        "path": "assets/slice/packed/props/prop-arch-gate.png",
        "sha256": "daabce5e81d3bf5512218854d4f8d12f6ec618637e5e9b7a76706d2389baeb41",
        "size": [
          70,
          96
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "screenHeight": 96,
        "anchor": "bottom-centre"
      }
    },
    {
      "recipeId": "prop-bollard-rope",
      "recipe": "recipes/art/slice/prop-bollard-rope.json",
      "recipeHash": "d79c96be04950ffba361960f045980606f45a0da73c314e9dc4f7c84a064e924",
      "class": "environment-prop",
      "provider": "retro-diffusion:rd_pro__isometric",
      "seed": 7001,
      "takes": 1,
      "generated": {
        "path": "assets/slice/props/prop-bollard-rope-0.png",
        "sha256": "1a170834a081d65ec74c9965d33103c4f564f73d11e5a45c42ca8aec20dd535e"
      },
      "packed": {
        "path": "assets/slice/packed/props/prop-bollard-rope.png",
        "sha256": "730b2eb240de718fdd081de72585b75c5e9721ada15df4b6820f86d825dab7aa",
        "size": [
          27,
          30
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "screenHeight": 30,
        "anchor": "bottom-centre"
      }
    },
    {
      "recipeId": "prop-brazier",
      "recipe": "recipes/art/slice/prop-brazier.json",
      "recipeHash": "e846d2fdf8ec246ee4d2012e7e7d5faa4d6aac1f5b864e015d9b285f1a7b73f0",
      "class": "environment-prop",
      "provider": "retro-diffusion:rd_pro__isometric",
      "seed": 7001,
      "takes": 1,
      "generated": {
        "path": "assets/slice/props/prop-brazier-0.png",
        "sha256": "6f9d7dd17fa65ebc4f18d11a62437f1e00701ce46089ef3c8f7e92fe08ad2216"
      },
      "packed": {
        "path": "assets/slice/packed/props/prop-brazier.png",
        "sha256": "17f30af32d69c1ee933884f839c33c4a9d20cda870ae6c357f95496e9d45c6de",
        "size": [
          28,
          34
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "screenHeight": 34,
        "anchor": "bottom-centre"
      }
    },
    {
      "recipeId": "prop-burial-cart",
      "recipe": "recipes/art/slice/prop-burial-cart.json",
      "recipeHash": "b742039752a4e54dccfc8e97dcec692ec722d72beb677e98634916887ac21e6b",
      "class": "environment-prop",
      "provider": "retro-diffusion:user__dissidium_82e0058b",
      "seed": 7112,
      "takes": 2,
      "generated": {
        "path": "assets/slice/props/prop-burial-cart-0.png",
        "sha256": "bb8c3e6e1171f7c9cf4a026e269d753f2059c620d27889d6031cab39b9f79cc1"
      },
      "packed": {
        "path": "assets/slice/packed/props/prop-burial-cart.png",
        "sha256": "e50e6624dc30b2a4de277bc288d518a7e3ac9ed39b8be1cd8a5602df3f61d1b7",
        "size": [
          40,
          40
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "screenHeight": 40,
        "anchor": "bottom-centre"
      }
    },
    {
      "recipeId": "prop-cold-bath-drain",
      "recipe": "recipes/art/slice/prop-cold-bath-drain.json",
      "recipeHash": "2638547a12010649a2f6ab031124889e9c4420e183456e5d1a895ea003586b9d",
      "class": "environment-prop",
      "provider": "retro-diffusion:rd_pro__isometric",
      "seed": 7112,
      "takes": 1,
      "generated": {
        "path": "assets/slice/props/prop-cold-bath-drain-0.png",
        "sha256": "87e69698f37ada932aa81be91707632f0906e10872b66844250614973bcf5e4d"
      },
      "packed": {
        "path": "assets/slice/packed/props/prop-cold-bath-drain.png",
        "sha256": "cfa51ec765f869f188313a969b4ee64b1e73e58f194615290ec1ddc721e1d56f",
        "size": [
          41,
          30
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "screenHeight": 30,
        "anchor": "bottom-centre"
      }
    },
    {
      "recipeId": "prop-column-stub",
      "recipe": "recipes/art/slice/prop-column-stub.json",
      "recipeHash": "da5fd7da33d1efc924f6960afe3ff0968d786b217ac148fe6273020bd062935d",
      "class": "environment-prop",
      "provider": "retro-diffusion:rd_pro__isometric",
      "seed": 7001,
      "takes": 1,
      "generated": {
        "path": "assets/slice/props/prop-column-stub-0.png",
        "sha256": "a3ceef7cda6c5cba5a2173af1a821dc5f9df3ad226474eeb98221f5e2b0bafa2"
      },
      "packed": {
        "path": "assets/slice/packed/props/prop-column-stub.png",
        "sha256": "b71869c6afc151cdcc5080beeb58a8c90712773793d6f52aa71b64323863a35f",
        "size": [
          37,
          46
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "screenHeight": 46,
        "anchor": "bottom-centre"
      }
    },
    {
      "recipeId": "prop-crate-stack",
      "recipe": "recipes/art/slice/prop-crate-stack.json",
      "recipeHash": "9efa359772c89a585cc8f69b75854b84c34e51adfba42404c66ff599bacf3080",
      "class": "environment-prop",
      "provider": "retro-diffusion:rd_pro__isometric",
      "seed": 7001,
      "takes": 1,
      "generated": {
        "path": "assets/slice/props/prop-crate-stack-0.png",
        "sha256": "0bf548dc6df920869589ef36176b516305891abcf4aa958724ded21c5197d04a"
      },
      "packed": {
        "path": "assets/slice/packed/props/prop-crate-stack.png",
        "sha256": "32c409f8f5ab31b65ecc7042b6d9948b456b004380571173cf277f43f08ecf5e",
        "size": [
          53,
          46
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "screenHeight": 46,
        "anchor": "bottom-centre"
      }
    },
    {
      "recipeId": "prop-empty-coffin",
      "recipe": "recipes/art/slice/prop-empty-coffin.json",
      "recipeHash": "a5d6aee0a097a3d6aa9d7ab62f36854bf8b28cf800acfe4f0ebb39612dfb5117",
      "class": "environment-prop",
      "provider": "retro-diffusion:rd_pro__isometric",
      "seed": 7101,
      "takes": 1,
      "generated": {
        "path": "assets/slice/props/prop-empty-coffin-0.png",
        "sha256": "da2c4a70a89e4086a839634975088e78fe5b94d9e2951885e9b4781bf346b2a1"
      },
      "packed": {
        "path": "assets/slice/packed/props/prop-empty-coffin.png",
        "sha256": "a1e2637c52eb9b2d55d06ced7cd33ed2c273464ce315421060de500c3f1bee8d",
        "size": [
          41,
          36
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "screenHeight": 36,
        "anchor": "bottom-centre"
      }
    },
    {
      "recipeId": "prop-ledger-desk",
      "recipe": "recipes/art/slice/prop-ledger-desk.json",
      "recipeHash": "0b3050211df0ea389706711f01232e1db23db58f8ae7cd6d00195743c32c8b33",
      "class": "environment-prop",
      "provider": "retro-diffusion:user__dissidium_82e0058b",
      "seed": 7103,
      "takes": 1,
      "generated": {
        "path": "assets/slice/props/prop-ledger-desk-0.png",
        "sha256": "269712be24427ef5c77db03ca5b9a14046b82a3f3f89443f19f4a9e99314d93f"
      },
      "packed": {
        "path": "assets/slice/packed/props/prop-ledger-desk.png",
        "sha256": "2eab1cf29942d026784a58a4cc4d9a0321d528a7dd2938593a06ed5409fb8a71",
        "size": [
          24,
          32
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "screenHeight": 32,
        "anchor": "bottom-centre"
      }
    },
    {
      "recipeId": "prop-lift-winch",
      "recipe": "recipes/art/slice/prop-lift-winch.json",
      "recipeHash": "01d057bbec1bbbbb885b5ea3294c6230716865938d1496541397e72ef56570a3",
      "class": "environment-prop",
      "provider": "retro-diffusion:rd_pro__isometric",
      "seed": 7001,
      "takes": 1,
      "generated": {
        "path": "assets/slice/props/prop-lift-winch-0.png",
        "sha256": "fc83049114ddb9d67adc494ef147584d370188acadc4a014f618e2fa45b6dc59"
      },
      "packed": {
        "path": "assets/slice/packed/props/prop-lift-winch.png",
        "sha256": "b85deab2ec50624cfe8ff96cf97928ee06e22d4ca965c5154523832b42ad26d4",
        "size": [
          64,
          56
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "screenHeight": 56,
        "anchor": "bottom-centre"
      }
    },
    {
      "recipeId": "prop-mortar-seam",
      "recipe": "recipes/art/slice/prop-mortar-seam.json",
      "recipeHash": "89386fbc59a7b5163bd85bf9c5ea52ce841ad21a82ba44a4f06eb000abe08a29",
      "class": "environment-prop",
      "provider": "retro-diffusion:user__dissidium_82e0058b",
      "seed": 7104,
      "takes": 1,
      "generated": {
        "path": "assets/slice/props/prop-mortar-seam-0.png",
        "sha256": "bdddb4c6e310d175f964dd06867cf4e031905a7a187eb228e5f0eac914cedf45"
      },
      "packed": {
        "path": "assets/slice/packed/props/prop-mortar-seam.png",
        "sha256": "8c500f698c57875f489704c6cf96ae8269690b1d2e8715f1ac954d856cdbe13c",
        "size": [
          20,
          20
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "screenHeight": 20,
        "anchor": "bottom-centre"
      }
    },
    {
      "recipeId": "prop-sluice-pawl-gauge",
      "recipe": "recipes/art/slice/prop-sluice-pawl-gauge.json",
      "recipeHash": "455dce3e36524b15db67f37dcff4c1cf3b490c16298773a4fc72fb5f0c5f6265",
      "class": "environment-prop",
      "provider": "retro-diffusion:rd_pro__isometric",
      "seed": 7103,
      "takes": 1,
      "generated": {
        "path": "assets/slice/props/prop-sluice-pawl-gauge-0.png",
        "sha256": "a813be4fb8ff8dc378752774cd175262fe0e6f5b202fa7a03f35d1346a23abdc"
      },
      "packed": {
        "path": "assets/slice/packed/props/prop-sluice-pawl-gauge.png",
        "sha256": "9f2dbb4b1f6c767ac8584b1fb8ce7023d0eabe26e140507e96bae72d061dfaaa",
        "size": [
          26,
          40
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "screenHeight": 40,
        "anchor": "bottom-centre"
      }
    },
    {
      "recipeId": "prop-stair-block",
      "recipe": "recipes/art/slice/prop-stair-block.json",
      "recipeHash": "6b37520b9e3c1dc041aa6bb603dd8de691d896264765756534f1e8ee26c92136",
      "class": "environment-prop",
      "provider": "retro-diffusion:rd_pro__isometric",
      "seed": 7001,
      "takes": 1,
      "generated": {
        "path": "assets/slice/props/prop-stair-block-0.png",
        "sha256": "b40d33e6b8512e05b98ae46b8aaa0c24d47c9a961eb10417e355500decba9bd8"
      },
      "packed": {
        "path": "assets/slice/packed/props/prop-stair-block.png",
        "sha256": "0a32472a60ed005f2b5a3efe41ee2ee867973997c0e4ad5e63ffde7a8a8e6fe3",
        "size": [
          48,
          48
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "screenHeight": 48,
        "anchor": "bottom-centre"
      }
    },
    {
      "recipeId": "prop-station-anchor",
      "recipe": "recipes/art/slice/prop-station-anchor.json",
      "recipeHash": "17c62216efcbf3adebf7833368cce47c5cb7494389833fa2cbcaa31814ac2b7a",
      "class": "environment-prop",
      "provider": "retro-diffusion:user__dissidium_82e0058b",
      "seed": 7101,
      "takes": 1,
      "generated": {
        "path": "assets/slice/props/prop-station-anchor-0.png",
        "sha256": "9cce461bb9751c77070432c80af0519d7d53f15d1909b1491a43b7978ac39728"
      },
      "packed": {
        "path": "assets/slice/packed/props/prop-station-anchor.png",
        "sha256": "a29d6a619df86ca4785d3b5c040f7b3cb292fef38f6f757c8b14f4d5560348a7",
        "size": [
          18,
          30
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "screenHeight": 30,
        "anchor": "bottom-centre"
      }
    },
    {
      "recipeId": "prop-urn-niche",
      "recipe": "recipes/art/slice/prop-urn-niche.json",
      "recipeHash": "1b01c3d324ab94fa93ad7521ec8dbe9424ba845159980800c757887d55f53b15",
      "class": "environment-prop",
      "provider": "retro-diffusion:rd_pro__isometric",
      "seed": 7042,
      "takes": 2,
      "generated": {
        "path": "assets/slice/props/prop-urn-niche-0.png",
        "sha256": "ed9be64f73af3e54f8bef6eed05afaf098e92ea7e53c015fecbeacfb6a1ae6ac"
      },
      "packed": {
        "path": "assets/slice/packed/props/prop-urn-niche.png",
        "sha256": "ccd234ed393c72005e1a44322c94625da74368e758715e26d8e8018e5925feec",
        "size": [
          24,
          40
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "screenHeight": 40,
        "anchor": "bottom-centre"
      }
    },
    {
      "recipeId": "tile-ground-brick",
      "recipe": "recipes/art/slice/tile-ground-brick.json",
      "recipeHash": "52386bd60690c54c958d083e6d94fbc87c38d93a2196ae7404c201b02742d4d9",
      "class": "environment-tile",
      "provider": "retro-diffusion:user__dissidium_82e0058b",
      "seed": 7412,
      "takes": 2,
      "generated": {
        "path": "assets/slice/tiles/tile-ground-brick-0.png",
        "sha256": "4222d90d7a1d2b47c00c1c76a384c6372e2e4a46f19f8ca2fa255adc588f3f76"
      },
      "packed": {
        "path": "assets/slice/packed/tiles/tile-ground-brick.png",
        "sha256": "9411da1fe6692c1d8efb90190df612e81cdcfbe6f30df271cbab210cb332ad73",
        "size": [
          64,
          32
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "surface": "ground",
        "tile": {
          "width": 64,
          "height": 32
        },
        "storey": 48
      }
    },
    {
      "recipeId": "tile-ground-flagstone",
      "recipe": "recipes/art/slice/tile-ground-flagstone.json",
      "recipeHash": "d0c1153799de006ecb3cdc1d78692ee2167d99cab7ffd7607484d483f90a50c1",
      "class": "environment-tile",
      "provider": "retro-diffusion:user__dissidium_82e0058b",
      "seed": 7011,
      "takes": 1,
      "generated": {
        "path": "assets/slice/tiles/tile-ground-flagstone-0.png",
        "sha256": "bc8753bf8caa30237499d85a5920c3ac532bbe100019fe213ba425990b296fea"
      },
      "packed": {
        "path": "assets/slice/packed/tiles/tile-ground-flagstone.png",
        "sha256": "ed7fb86f9095f9afd626452f1c69a415ba69aa8cdd61c30654b353e26753a296",
        "size": [
          64,
          32
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "surface": "ground",
        "tile": {
          "width": 64,
          "height": 32
        },
        "storey": 48
      }
    },
    {
      "recipeId": "tile-ground-gravel",
      "recipe": "recipes/art/slice/tile-ground-gravel.json",
      "recipeHash": "1ad05419bfc9ed77491712c2d0ac2a44a3d04838385b62ad673f6b77890e4cb6",
      "class": "environment-tile",
      "provider": "retro-diffusion:user__dissidium_82e0058b",
      "seed": 7102,
      "takes": 2,
      "generated": {
        "path": "assets/slice/tiles/tile-ground-gravel-0.png",
        "sha256": "c985dce86397fa0b4e685e56b4edb2b3ba49e12df4ee528b0d9fbe36d6e61e1a"
      },
      "packed": {
        "path": "assets/slice/packed/tiles/tile-ground-gravel.png",
        "sha256": "3731dbb9d679029c48bd3ea55a5174ec70d14370a28072ed5498b50f630639f5",
        "size": [
          64,
          32
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "surface": "ground",
        "tile": {
          "width": 64,
          "height": 32
        },
        "storey": 48
      }
    },
    {
      "recipeId": "tile-ground-limestone-cut",
      "recipe": "recipes/art/slice/tile-ground-limestone-cut.json",
      "recipeHash": "8ba827c199c40129000e101b03f4dcc06ecc26a44dfe3954a64ba37bdc69305e",
      "class": "environment-tile",
      "provider": "retro-diffusion:user__dissidium_82e0058b",
      "seed": 7115,
      "takes": 2,
      "generated": {
        "path": "assets/slice/tiles/tile-ground-limestone-cut-0.png",
        "sha256": "abda4f8b4af32957d320de556af508becf8cef14cb2a362179e2f812e9d86c7b"
      },
      "packed": {
        "path": "assets/slice/packed/tiles/tile-ground-limestone-cut.png",
        "sha256": "6f0765d6da59af791d12de41695ce290fd8f2c6ac70bca2e85660cb0d616ddc8",
        "size": [
          64,
          32
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "surface": "ground",
        "tile": {
          "width": 64,
          "height": 32
        },
        "storey": 48
      }
    },
    {
      "recipeId": "tile-ground-silt",
      "recipe": "recipes/art/slice/tile-ground-silt.json",
      "recipeHash": "d74cf030e9018220603079c11d5d414957e7df27d7f624f26c8d18df6e985c7e",
      "class": "environment-tile",
      "provider": "retro-diffusion:user__dissidium_82e0058b",
      "seed": 7044,
      "takes": 2,
      "generated": {
        "path": "assets/slice/tiles/tile-ground-silt-0.png",
        "sha256": "a5393554d25dec038270d453ee46f431c3749f8cb0eea04725ee780783b72d1e"
      },
      "packed": {
        "path": "assets/slice/packed/tiles/tile-ground-silt.png",
        "sha256": "ab61710fe772c0ea6524b421997934d0ce5127ea2d6ea4a498231618ecfc0fc6",
        "size": [
          64,
          32
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "surface": "ground",
        "tile": {
          "width": 64,
          "height": 32
        },
        "storey": 48
      }
    },
    {
      "recipeId": "tile-ground-timber",
      "recipe": "recipes/art/slice/tile-ground-timber.json",
      "recipeHash": "186528371c9e295f94c9ea590adc05c0bb6c5a32a573981b80f74cd025285ccb",
      "class": "environment-tile",
      "provider": "retro-diffusion:user__dissidium_82e0058b",
      "seed": 7011,
      "takes": 1,
      "generated": {
        "path": "assets/slice/tiles/tile-ground-timber-0.png",
        "sha256": "f48a3a5714eb27c7ab84dfe35bc821b6b91cccdc2f7f209eff8c2140e5673bb3"
      },
      "packed": {
        "path": "assets/slice/packed/tiles/tile-ground-timber.png",
        "sha256": "3ae402cc5a3886a29e34c8cc96d2cdfb3d3d20b5e5caf69ea880e9616eab161a",
        "size": [
          64,
          32
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "surface": "ground",
        "tile": {
          "width": 64,
          "height": 32
        },
        "storey": 48
      }
    },
    {
      "recipeId": "tile-wall-ashlar",
      "recipe": "recipes/art/slice/tile-wall-ashlar.json",
      "recipeHash": "653cc79d0f7df58cfd8786ed0de8e7f74fd94d166f1d2c37d847c1da9f888ceb",
      "class": "environment-tile",
      "provider": "retro-diffusion:user__dissidium_82e0058b",
      "seed": 7051,
      "takes": 1,
      "generated": {
        "path": "assets/slice/tiles/tile-wall-ashlar-0.png",
        "sha256": "2544359d6724b251edee30d77f72e0f90a29d0e2a68d9138540b0e410823693a"
      },
      "packed": {
        "path": "assets/slice/packed/tiles/tile-wall-ashlar.png",
        "sha256": "c4cea3c7dbae5cc8cad2fef80a0df1f53dc35212dcea88d3986af0cda83cd353",
        "size": [
          32,
          64
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "surface": "wall",
        "tile": {
          "width": 64,
          "height": 32
        },
        "storey": 48
      }
    },
    {
      "recipeId": "tile-wall-plaster",
      "recipe": "recipes/art/slice/tile-wall-plaster.json",
      "recipeHash": "b2448da913a888b11884a45cfad664774754c14fc43efa228e7e403b2f11b9dc",
      "class": "environment-tile",
      "provider": "retro-diffusion:user__dissidium_82e0058b",
      "seed": 7061,
      "takes": 2,
      "generated": {
        "path": "assets/slice/tiles/tile-wall-plaster-0.png",
        "sha256": "a1944fffca31a53d86c8a7dbc94686071175a967404156359f6a129252284314"
      },
      "packed": {
        "path": "assets/slice/packed/tiles/tile-wall-plaster.png",
        "sha256": "5a55b4f1cb4476b2d423106080aba3b0c8192d671e3625eb26096d354b863888",
        "size": [
          32,
          64
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "surface": "wall",
        "tile": {
          "width": 64,
          "height": 32
        },
        "storey": 48
      }
    },
    {
      "recipeId": "actor-heavy-labourer",
      "recipe": "recipes/art/painted/actors/roster.json",
      "recipeHash": "c7d56c7285f33f43d1fc9f5e3542f57ab6f9a8df4d713a21717f50b7c894475a",
      "class": "actor-sheet",
      "provider": "gpt-image-2",
      "seed": null,
      "takes": 1,
      "generated": {
        "path": "assets/slice/actors/painted/directional/actor-heavy-labourer/s.png",
        "sha256": "96364d080daf8cf8d5ab41b2682337365ac2529dc95d86c40bec245d43ac0183"
      },
      "packed": {
        "path": "assets/slice/packed/actors/painted/actor-heavy-labourer.png",
        "sha256": "eadf1f6f7003f326cd7c3060667b08a5c0442f30e25c894322f67901a334c49c",
        "size": [
          1152,
          1408
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "cell": {
          "width": 96,
          "height": 88
        },
        "sheet": {
          "grid": [
            12,
            16
          ],
          "cellFacings": [
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "s",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "se",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "e",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "ne",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "n",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "nw",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "w",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "sw",
            null,
            null,
            null,
            null,
            null
          ]
        },
        "footY": 80
      },
      "animation": {
        "path": "assets/slice/packed/actors/painted/actor-heavy-labourer.png",
        "sha256": "eadf1f6f7003f326cd7c3060667b08a5c0442f30e25c894322f67901a334c49c",
        "size": [
          1152,
          1408
        ],
        "cell": {
          "width": 96,
          "height": 88
        },
        "foot": [
          48,
          80
        ],
        "walkFacings": [
          "s",
          "se",
          "e",
          "ne",
          "n"
        ],
        "clips": {
          "walk": {
            "frames": [
              24,
              25,
              26,
              27,
              28,
              29
            ],
            "fps": 8,
            "loop": true,
            "facings": {
              "s": [
                0,
                1,
                2,
                3,
                4,
                5
              ],
              "se": [
                24,
                25,
                26,
                27,
                28,
                29
              ],
              "e": [
                48,
                49,
                50,
                51,
                52,
                53
              ],
              "ne": [
                72,
                73,
                74,
                75,
                76,
                77
              ],
              "n": [
                96,
                97,
                98,
                99,
                100,
                101
              ],
              "nw": [
                120,
                121,
                122,
                123,
                124,
                125
              ],
              "w": [
                144,
                145,
                146,
                147,
                148,
                149
              ],
              "sw": [
                168,
                169,
                170,
                171,
                172,
                173
              ]
            }
          },
          "attack": {
            "frames": [
              30,
              31,
              32,
              33,
              34,
              35
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                6,
                7,
                8,
                9,
                10,
                11
              ],
              "se": [
                30,
                31,
                32,
                33,
                34,
                35
              ],
              "e": [
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "ne": [
                78,
                79,
                80,
                81,
                82,
                83
              ],
              "n": [
                102,
                103,
                104,
                105,
                106,
                107
              ],
              "nw": [
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "w": [
                150,
                151,
                152,
                153,
                154,
                155
              ],
              "sw": [
                174,
                175,
                176,
                177,
                178,
                179
              ]
            }
          },
          "recoil": {
            "frames": [
              36,
              37
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                12,
                13
              ],
              "se": [
                36,
                37
              ],
              "e": [
                60,
                61
              ],
              "ne": [
                84,
                85
              ],
              "n": [
                108,
                109
              ],
              "nw": [
                132,
                133
              ],
              "w": [
                156,
                157
              ],
              "sw": [
                180,
                181
              ]
            }
          },
          "death": {
            "frames": [
              38,
              39,
              40,
              41
            ],
            "fps": 7,
            "loop": false,
            "facings": {
              "s": [
                14,
                15,
                16,
                17
              ],
              "se": [
                38,
                39,
                40,
                41
              ],
              "e": [
                62,
                63,
                64,
                65
              ],
              "ne": [
                86,
                87,
                88,
                89
              ],
              "n": [
                110,
                111,
                112,
                113
              ],
              "nw": [
                134,
                135,
                136,
                137
              ],
              "w": [
                158,
                159,
                160,
                161
              ],
              "sw": [
                182,
                183,
                184,
                185
              ]
            }
          },
          "corpse": {
            "frames": [
              41
            ],
            "fps": 1,
            "loop": false,
            "facings": {
              "s": [
                17
              ],
              "se": [
                41
              ],
              "e": [
                65
              ],
              "ne": [
                89
              ],
              "n": [
                113
              ],
              "nw": [
                137
              ],
              "w": [
                161
              ],
              "sw": [
                185
              ]
            }
          },
          "idle": {
            "frames": [
              42,
              43,
              44
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                18,
                19,
                20
              ],
              "se": [
                42,
                43,
                44
              ],
              "e": [
                66,
                67,
                68
              ],
              "ne": [
                90,
                91,
                92
              ],
              "n": [
                114,
                115,
                116
              ],
              "nw": [
                138,
                139,
                140
              ],
              "w": [
                162,
                163,
                164
              ],
              "sw": [
                186,
                187,
                188
              ]
            }
          },
          "work": {
            "frames": [
              45,
              46,
              47
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                21,
                22,
                23
              ],
              "se": [
                45,
                46,
                47
              ],
              "e": [
                69,
                70,
                71
              ],
              "ne": [
                93,
                94,
                95
              ],
              "n": [
                117,
                118,
                119
              ],
              "nw": [
                141,
                142,
                143
              ],
              "w": [
                165,
                166,
                167
              ],
              "sw": [
                189,
                190,
                191
              ]
            }
          }
        },
        "source": "assets/slice/actors/painted/directional/actor-heavy-labourer/s.png",
        "sourceHash": "96364d080daf8cf8d5ab41b2682337365ac2529dc95d86c40bec245d43ac0183",
        "recipe": "recipes/art/painted/actors/roster.json",
        "recipeHash": "c7d56c7285f33f43d1fc9f5e3542f57ab6f9a8df4d713a21717f50b7c894475a",
        "provider": "gpt-image-2",
        "sources": {
          "assets/slice/actors/painted/directional/actor-heavy-labourer/s.png": "96364d080daf8cf8d5ab41b2682337365ac2529dc95d86c40bec245d43ac0183",
          "assets/slice/actors/painted/directional/actor-heavy-labourer/se.png": "c5e75c62a615296183535980f940f976b14f28c34b3d4b84f220bc54460f9136",
          "assets/slice/actors/painted/directional/actor-heavy-labourer/e.png": "aa416bf723c17b154353f6e17eaf453c585811a60d87cb77cb6912f6bfad8ff2",
          "assets/slice/actors/painted/directional/actor-heavy-labourer/ne.png": "eea1cd81072486c48f12c6efe100bb50ff552bbe920314ea995a15143db3e884",
          "assets/slice/actors/painted/directional/actor-heavy-labourer/n.png": "46fa398414891822d93d4c32a32894b978caebfc36ca5b48aadde59de69c72b9",
          "assets/slice/actors/painted/directional/actor-heavy-labourer/nw.png": "d4dea72f1d5b9c6c01e34c0efea75ae904987c6133ed214bb7468d52022ec9da",
          "assets/slice/actors/painted/directional/actor-heavy-labourer/w.png": "f6b36deb7c693a37a46200d98aac037e91f12316c1e6e7af1fcec0a5f252476c",
          "assets/slice/actors/painted/directional/actor-heavy-labourer/sw.png": "9f6ba8efc97b6eb51dc726196903d278f8fd5e4760a24fcfde310ec683b88409"
        }
      }
    },
    {
      "recipeId": "actor-nessa-tal",
      "recipe": "recipes/art/painted/actors/roster.json",
      "recipeHash": "c7d56c7285f33f43d1fc9f5e3542f57ab6f9a8df4d713a21717f50b7c894475a",
      "class": "actor-sheet",
      "provider": "gpt-image-2",
      "seed": null,
      "takes": 1,
      "generated": {
        "path": "assets/slice/actors/painted/directional/actor-nessa-tal/s.png",
        "sha256": "4849444e5b96e08ec9cc2692da7331b183be60c383abcc2021975d0abece572d"
      },
      "packed": {
        "path": "assets/slice/packed/actors/painted/actor-nessa-tal.png",
        "sha256": "ab806e4d4e718e8c1cfbd00d89093c5b802a63e8f7391bc4939d0034586bd074",
        "size": [
          1056,
          1280
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "cell": {
          "width": 88,
          "height": 80
        },
        "sheet": {
          "grid": [
            12,
            16
          ],
          "cellFacings": [
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "s",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "se",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "e",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "ne",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "n",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "nw",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "w",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "sw",
            null,
            null,
            null,
            null,
            null
          ]
        },
        "footY": 72
      },
      "animation": {
        "path": "assets/slice/packed/actors/painted/actor-nessa-tal.png",
        "sha256": "ab806e4d4e718e8c1cfbd00d89093c5b802a63e8f7391bc4939d0034586bd074",
        "size": [
          1056,
          1280
        ],
        "cell": {
          "width": 88,
          "height": 80
        },
        "foot": [
          44,
          72
        ],
        "walkFacings": [
          "s",
          "se",
          "e",
          "ne",
          "n"
        ],
        "clips": {
          "walk": {
            "frames": [
              24,
              25,
              26,
              27,
              28,
              29
            ],
            "fps": 8,
            "loop": true,
            "facings": {
              "s": [
                0,
                1,
                2,
                3,
                4,
                5
              ],
              "se": [
                24,
                25,
                26,
                27,
                28,
                29
              ],
              "e": [
                48,
                49,
                50,
                51,
                52,
                53
              ],
              "ne": [
                72,
                73,
                74,
                75,
                76,
                77
              ],
              "n": [
                96,
                97,
                98,
                99,
                100,
                101
              ],
              "nw": [
                120,
                121,
                122,
                123,
                124,
                125
              ],
              "w": [
                144,
                145,
                146,
                147,
                148,
                149
              ],
              "sw": [
                168,
                169,
                170,
                171,
                172,
                173
              ]
            }
          },
          "attack": {
            "frames": [
              30,
              31,
              32,
              33,
              34,
              35
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                6,
                7,
                8,
                9,
                10,
                11
              ],
              "se": [
                30,
                31,
                32,
                33,
                34,
                35
              ],
              "e": [
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "ne": [
                78,
                79,
                80,
                81,
                82,
                83
              ],
              "n": [
                102,
                103,
                104,
                105,
                106,
                107
              ],
              "nw": [
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "w": [
                150,
                151,
                152,
                153,
                154,
                155
              ],
              "sw": [
                174,
                175,
                176,
                177,
                178,
                179
              ]
            }
          },
          "recoil": {
            "frames": [
              36,
              37
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                12,
                13
              ],
              "se": [
                36,
                37
              ],
              "e": [
                60,
                61
              ],
              "ne": [
                84,
                85
              ],
              "n": [
                108,
                109
              ],
              "nw": [
                132,
                133
              ],
              "w": [
                156,
                157
              ],
              "sw": [
                180,
                181
              ]
            }
          },
          "death": {
            "frames": [
              38,
              39,
              40,
              41
            ],
            "fps": 7,
            "loop": false,
            "facings": {
              "s": [
                14,
                15,
                16,
                17
              ],
              "se": [
                38,
                39,
                40,
                41
              ],
              "e": [
                62,
                63,
                64,
                65
              ],
              "ne": [
                86,
                87,
                88,
                89
              ],
              "n": [
                110,
                111,
                112,
                113
              ],
              "nw": [
                134,
                135,
                136,
                137
              ],
              "w": [
                158,
                159,
                160,
                161
              ],
              "sw": [
                182,
                183,
                184,
                185
              ]
            }
          },
          "corpse": {
            "frames": [
              41
            ],
            "fps": 1,
            "loop": false,
            "facings": {
              "s": [
                17
              ],
              "se": [
                41
              ],
              "e": [
                65
              ],
              "ne": [
                89
              ],
              "n": [
                113
              ],
              "nw": [
                137
              ],
              "w": [
                161
              ],
              "sw": [
                185
              ]
            }
          },
          "idle": {
            "frames": [
              42,
              43,
              44
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                18,
                19,
                20
              ],
              "se": [
                42,
                43,
                44
              ],
              "e": [
                66,
                67,
                68
              ],
              "ne": [
                90,
                91,
                92
              ],
              "n": [
                114,
                115,
                116
              ],
              "nw": [
                138,
                139,
                140
              ],
              "w": [
                162,
                163,
                164
              ],
              "sw": [
                186,
                187,
                188
              ]
            }
          },
          "work": {
            "frames": [
              45,
              46,
              47
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                21,
                22,
                23
              ],
              "se": [
                45,
                46,
                47
              ],
              "e": [
                69,
                70,
                71
              ],
              "ne": [
                93,
                94,
                95
              ],
              "n": [
                117,
                118,
                119
              ],
              "nw": [
                141,
                142,
                143
              ],
              "w": [
                165,
                166,
                167
              ],
              "sw": [
                189,
                190,
                191
              ]
            }
          }
        },
        "source": "assets/slice/actors/painted/directional/actor-nessa-tal/s.png",
        "sourceHash": "4849444e5b96e08ec9cc2692da7331b183be60c383abcc2021975d0abece572d",
        "recipe": "recipes/art/painted/actors/roster.json",
        "recipeHash": "c7d56c7285f33f43d1fc9f5e3542f57ab6f9a8df4d713a21717f50b7c894475a",
        "provider": "gpt-image-2",
        "sources": {
          "assets/slice/actors/painted/directional/actor-nessa-tal/s.png": "4849444e5b96e08ec9cc2692da7331b183be60c383abcc2021975d0abece572d",
          "assets/slice/actors/painted/directional/actor-nessa-tal/se.png": "c8ad17bc813d70366b6738b0660264c0de39019dca847ba432e88f1280924392",
          "assets/slice/actors/painted/directional/actor-nessa-tal/e.png": "b2f7cb35d1cccff66510787b473decf5f4af5768eda54dad24279eba9c34fa12",
          "assets/slice/actors/painted/directional/actor-nessa-tal/ne.png": "577dd4108a47a1ee18c4f19bb90896441dceb3ad13731219c261c437dfa185dd",
          "assets/slice/actors/painted/directional/actor-nessa-tal/n.png": "7dc3648a0943dd58f74ac87deea4f26f4208ee4b3a2b399a02e2574d52fbf810",
          "assets/slice/actors/painted/directional/actor-nessa-tal/nw.png": "9d64dd6258119046ac74bd37c384306325bc782c347bab6e174d7ef12550412d",
          "assets/slice/actors/painted/directional/actor-nessa-tal/w.png": "358c2b4f011c1bac5080302e0ad0d25c90fe8a297c8af693ae02e486e98a3962",
          "assets/slice/actors/painted/directional/actor-nessa-tal/sw.png": "818d7e65ac02b281d8d6c6493aa21183cf566838bb9f5eb9a230e6d21017ae30"
        }
      }
    },
    {
      "recipeId": "actor-melian-sar",
      "recipe": "recipes/art/painted/actors/roster.json",
      "recipeHash": "c7d56c7285f33f43d1fc9f5e3542f57ab6f9a8df4d713a21717f50b7c894475a",
      "class": "actor-sheet",
      "provider": "gpt-image-2",
      "seed": null,
      "takes": 1,
      "generated": {
        "path": "assets/slice/actors/painted/directional/actor-melian-sar/s.png",
        "sha256": "139a34e9bf5b6cbcd12ea71ccb25fc7509b25c9fdc196f8485e5512efdd818a0"
      },
      "packed": {
        "path": "assets/slice/packed/actors/painted/actor-melian-sar.png",
        "sha256": "d8e2026790a4a8ae74dcc6c473d26447bae7e9878ba491758926605dcfe0ff31",
        "size": [
          1056,
          1280
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "cell": {
          "width": 88,
          "height": 80
        },
        "sheet": {
          "grid": [
            12,
            16
          ],
          "cellFacings": [
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "s",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "se",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "e",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "ne",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "n",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "nw",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "w",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "sw",
            null,
            null,
            null,
            null,
            null
          ]
        },
        "footY": 72
      },
      "animation": {
        "path": "assets/slice/packed/actors/painted/actor-melian-sar.png",
        "sha256": "d8e2026790a4a8ae74dcc6c473d26447bae7e9878ba491758926605dcfe0ff31",
        "size": [
          1056,
          1280
        ],
        "cell": {
          "width": 88,
          "height": 80
        },
        "foot": [
          44,
          72
        ],
        "walkFacings": [
          "s",
          "se",
          "e",
          "ne",
          "n"
        ],
        "clips": {
          "walk": {
            "frames": [
              24,
              25,
              26,
              27,
              28,
              29
            ],
            "fps": 8,
            "loop": true,
            "facings": {
              "s": [
                0,
                1,
                2,
                3,
                4,
                5
              ],
              "se": [
                24,
                25,
                26,
                27,
                28,
                29
              ],
              "e": [
                48,
                49,
                50,
                51,
                52,
                53
              ],
              "ne": [
                72,
                73,
                74,
                75,
                76,
                77
              ],
              "n": [
                96,
                97,
                98,
                99,
                100,
                101
              ],
              "nw": [
                120,
                121,
                122,
                123,
                124,
                125
              ],
              "w": [
                144,
                145,
                146,
                147,
                148,
                149
              ],
              "sw": [
                168,
                169,
                170,
                171,
                172,
                173
              ]
            }
          },
          "attack": {
            "frames": [
              30,
              31,
              32,
              33,
              34,
              35
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                6,
                7,
                8,
                9,
                10,
                11
              ],
              "se": [
                30,
                31,
                32,
                33,
                34,
                35
              ],
              "e": [
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "ne": [
                78,
                79,
                80,
                81,
                82,
                83
              ],
              "n": [
                102,
                103,
                104,
                105,
                106,
                107
              ],
              "nw": [
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "w": [
                150,
                151,
                152,
                153,
                154,
                155
              ],
              "sw": [
                174,
                175,
                176,
                177,
                178,
                179
              ]
            }
          },
          "recoil": {
            "frames": [
              36,
              37
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                12,
                13
              ],
              "se": [
                36,
                37
              ],
              "e": [
                60,
                61
              ],
              "ne": [
                84,
                85
              ],
              "n": [
                108,
                109
              ],
              "nw": [
                132,
                133
              ],
              "w": [
                156,
                157
              ],
              "sw": [
                180,
                181
              ]
            }
          },
          "death": {
            "frames": [
              38,
              39,
              40,
              41
            ],
            "fps": 7,
            "loop": false,
            "facings": {
              "s": [
                14,
                15,
                16,
                17
              ],
              "se": [
                38,
                39,
                40,
                41
              ],
              "e": [
                62,
                63,
                64,
                65
              ],
              "ne": [
                86,
                87,
                88,
                89
              ],
              "n": [
                110,
                111,
                112,
                113
              ],
              "nw": [
                134,
                135,
                136,
                137
              ],
              "w": [
                158,
                159,
                160,
                161
              ],
              "sw": [
                182,
                183,
                184,
                185
              ]
            }
          },
          "corpse": {
            "frames": [
              41
            ],
            "fps": 1,
            "loop": false,
            "facings": {
              "s": [
                17
              ],
              "se": [
                41
              ],
              "e": [
                65
              ],
              "ne": [
                89
              ],
              "n": [
                113
              ],
              "nw": [
                137
              ],
              "w": [
                161
              ],
              "sw": [
                185
              ]
            }
          },
          "idle": {
            "frames": [
              42,
              43,
              44
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                18,
                19,
                20
              ],
              "se": [
                42,
                43,
                44
              ],
              "e": [
                66,
                67,
                68
              ],
              "ne": [
                90,
                91,
                92
              ],
              "n": [
                114,
                115,
                116
              ],
              "nw": [
                138,
                139,
                140
              ],
              "w": [
                162,
                163,
                164
              ],
              "sw": [
                186,
                187,
                188
              ]
            }
          },
          "work": {
            "frames": [
              45,
              46,
              47
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                21,
                22,
                23
              ],
              "se": [
                45,
                46,
                47
              ],
              "e": [
                69,
                70,
                71
              ],
              "ne": [
                93,
                94,
                95
              ],
              "n": [
                117,
                118,
                119
              ],
              "nw": [
                141,
                142,
                143
              ],
              "w": [
                165,
                166,
                167
              ],
              "sw": [
                189,
                190,
                191
              ]
            }
          }
        },
        "source": "assets/slice/actors/painted/directional/actor-melian-sar/s.png",
        "sourceHash": "139a34e9bf5b6cbcd12ea71ccb25fc7509b25c9fdc196f8485e5512efdd818a0",
        "recipe": "recipes/art/painted/actors/roster.json",
        "recipeHash": "c7d56c7285f33f43d1fc9f5e3542f57ab6f9a8df4d713a21717f50b7c894475a",
        "provider": "gpt-image-2",
        "sources": {
          "assets/slice/actors/painted/directional/actor-melian-sar/s.png": "139a34e9bf5b6cbcd12ea71ccb25fc7509b25c9fdc196f8485e5512efdd818a0",
          "assets/slice/actors/painted/directional/actor-melian-sar/se.png": "ffc083c8852b83d958b019963b17cff183c9a164fca958d97625c52a4a083638",
          "assets/slice/actors/painted/directional/actor-melian-sar/e.png": "c1569529393f0356aa564e9fd127e8c79ca00918890daa1e8285742b7b22b665",
          "assets/slice/actors/painted/directional/actor-melian-sar/ne.png": "4f70b92572a7545e3877036c3e6b0fb902ffc3939b90e0d172c6ab291bfdeb06",
          "assets/slice/actors/painted/directional/actor-melian-sar/n.png": "99d02e1843d9f736f9114709a65d5d8d84040bd7c78d8816e6478710d2b1188f",
          "assets/slice/actors/painted/directional/actor-melian-sar/nw.png": "b867d59c22f454f8bf7492c90ffc9da1aaba65cad1a8799a5ac127007d0f954b",
          "assets/slice/actors/painted/directional/actor-melian-sar/w.png": "b8ce34607c3ab1384e641da75584b87302c319c67aec41f295975c31ca37a7df",
          "assets/slice/actors/painted/directional/actor-melian-sar/sw.png": "a1e8e2e19a8e3254619a94aef51cac3c42e1d1f955d50bff562615589e48236b"
        }
      }
    },
    {
      "recipeId": "actor-odel-thann",
      "recipe": "recipes/art/slice/actor-kiln-worker.json",
      "recipeHash": "149f292e12cfab76899c9b764ecd1d6c33e182823b6961baca6f2862620af055",
      "class": "actor-sheet",
      "provider": "retro-diffusion:rd_animation__8_dir_rotation",
      "seed": 1305,
      "takes": 1,
      "generated": {
        "path": "assets/slice/actors/actor-kiln-worker-0.png",
        "sha256": "49dde722ea3c4f94c6475ad07e6c0552e8515f4e491769de3072d62edbda50b4"
      },
      "packed": {
        "path": "assets/slice/packed/actors/actor-kiln-worker.png",
        "sha256": "7bc676705645c70136b43a41b97c4ea0098560be028e97c5020d7e1610b4e8af",
        "size": [
          240,
          240
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "cell": {
          "width": 80,
          "height": 80
        },
        "sheet": {
          "grid": [
            3,
            3
          ],
          "cellFacings": [
            "se",
            "s",
            "sw",
            "e",
            null,
            "w",
            "ne",
            "n",
            "nw"
          ],
          "note": "Retro Diffusion's 8-direction rotation style lays the facings out as a mirrored compass: the top row looks towards the viewer (south), the bottom row looks away (north), and the left column looks screen-right (east), the right column screen-left (west). The centre cell is always empty. Read left-to-right, top-to-bottom; `cellFacings` names the facing drawn in each cell, and the manifest carries it so the renderer can pick a pose per facing. Verified by inspection of all six assets/slice/actors/*-rotation-0.png sheets (AUT-13617): the middle-left figure faces screen-right in every one."
        },
        "footY": 67
      },
      "animation": {
        "path": "assets/slice/packed/actors/painted/actor-kiln-worker.png",
        "sha256": "f452038e91e6c539b3caf424d8bae81cd4b147ffa385b177eb87e97a6e451ffc",
        "size": [
          1056,
          1280
        ],
        "cell": {
          "width": 88,
          "height": 80
        },
        "foot": [
          44,
          72
        ],
        "walkFacings": [
          "s",
          "se",
          "e",
          "ne",
          "n"
        ],
        "clips": {
          "walk": {
            "frames": [
              24,
              25,
              26,
              27,
              28,
              29
            ],
            "fps": 8,
            "loop": true,
            "facings": {
              "s": [
                0,
                1,
                2,
                3,
                4,
                5
              ],
              "se": [
                24,
                25,
                26,
                27,
                28,
                29
              ],
              "e": [
                48,
                49,
                50,
                51,
                52,
                53
              ],
              "ne": [
                72,
                73,
                74,
                75,
                76,
                77
              ],
              "n": [
                96,
                97,
                98,
                99,
                100,
                101
              ],
              "nw": [
                120,
                121,
                122,
                123,
                124,
                125
              ],
              "w": [
                144,
                145,
                146,
                147,
                148,
                149
              ],
              "sw": [
                168,
                169,
                170,
                171,
                172,
                173
              ]
            }
          },
          "attack": {
            "frames": [
              30,
              31,
              32,
              33,
              34,
              35
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                6,
                7,
                8,
                9,
                10,
                11
              ],
              "se": [
                30,
                31,
                32,
                33,
                34,
                35
              ],
              "e": [
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "ne": [
                78,
                79,
                80,
                81,
                82,
                83
              ],
              "n": [
                102,
                103,
                104,
                105,
                106,
                107
              ],
              "nw": [
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "w": [
                150,
                151,
                152,
                153,
                154,
                155
              ],
              "sw": [
                174,
                175,
                176,
                177,
                178,
                179
              ]
            }
          },
          "recoil": {
            "frames": [
              36,
              37
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                12,
                13
              ],
              "se": [
                36,
                37
              ],
              "e": [
                60,
                61
              ],
              "ne": [
                84,
                85
              ],
              "n": [
                108,
                109
              ],
              "nw": [
                132,
                133
              ],
              "w": [
                156,
                157
              ],
              "sw": [
                180,
                181
              ]
            }
          },
          "death": {
            "frames": [
              38,
              39,
              40,
              41
            ],
            "fps": 7,
            "loop": false,
            "facings": {
              "s": [
                14,
                15,
                16,
                17
              ],
              "se": [
                38,
                39,
                40,
                41
              ],
              "e": [
                62,
                63,
                64,
                65
              ],
              "ne": [
                86,
                87,
                88,
                89
              ],
              "n": [
                110,
                111,
                112,
                113
              ],
              "nw": [
                134,
                135,
                136,
                137
              ],
              "w": [
                158,
                159,
                160,
                161
              ],
              "sw": [
                182,
                183,
                184,
                185
              ]
            }
          },
          "corpse": {
            "frames": [
              41
            ],
            "fps": 1,
            "loop": false,
            "facings": {
              "s": [
                17
              ],
              "se": [
                41
              ],
              "e": [
                65
              ],
              "ne": [
                89
              ],
              "n": [
                113
              ],
              "nw": [
                137
              ],
              "w": [
                161
              ],
              "sw": [
                185
              ]
            }
          },
          "idle": {
            "frames": [
              42,
              43,
              44
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                18,
                19,
                20
              ],
              "se": [
                42,
                43,
                44
              ],
              "e": [
                66,
                67,
                68
              ],
              "ne": [
                90,
                91,
                92
              ],
              "n": [
                114,
                115,
                116
              ],
              "nw": [
                138,
                139,
                140
              ],
              "w": [
                162,
                163,
                164
              ],
              "sw": [
                186,
                187,
                188
              ]
            }
          },
          "work": {
            "frames": [
              45,
              46,
              47
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                21,
                22,
                23
              ],
              "se": [
                45,
                46,
                47
              ],
              "e": [
                69,
                70,
                71
              ],
              "ne": [
                93,
                94,
                95
              ],
              "n": [
                117,
                118,
                119
              ],
              "nw": [
                141,
                142,
                143
              ],
              "w": [
                165,
                166,
                167
              ],
              "sw": [
                189,
                190,
                191
              ]
            }
          }
        },
        "source": "assets/slice/actors/painted/directional/actor-kiln-worker/s.png",
        "sourceHash": "44a3a50d51dd4d29c339e36a8e50327b2493cfc8e062d13f5827d893645151bb",
        "recipe": "recipes/art/painted/actors/roster.json",
        "recipeHash": "c7d56c7285f33f43d1fc9f5e3542f57ab6f9a8df4d713a21717f50b7c894475a",
        "provider": "gpt-image-2",
        "sources": {
          "assets/slice/actors/painted/directional/actor-kiln-worker/s.png": "44a3a50d51dd4d29c339e36a8e50327b2493cfc8e062d13f5827d893645151bb",
          "assets/slice/actors/painted/directional/actor-kiln-worker/se.png": "36ff027bcd77b30505d7fe97b1163b5f53ecf1f68ddc1178d41375d8ac0b6b2b",
          "assets/slice/actors/painted/directional/actor-kiln-worker/e.png": "7b8983cd5214b06d7ff6ce8b52c11253be556a5e2b50e5b42c2c2e644522c827",
          "assets/slice/actors/painted/directional/actor-kiln-worker/ne.png": "f31c6ddeb6c63235fde8596c465c190506943c22703016085493529ff85aa6ff",
          "assets/slice/actors/painted/directional/actor-kiln-worker/n.png": "1b6c9d6c0c0a46cd45f9cd24e6abb9e01e822518172b2d25790e3bbb02a933d5",
          "assets/slice/actors/painted/directional/actor-kiln-worker/nw.png": "a22a77bb151bad838adf68be36d132039e1dcafe3c0b448edb9353e822a6445d",
          "assets/slice/actors/painted/directional/actor-kiln-worker/w.png": "a92a39752f13650b6f6359a113011f48eebeec8089c64fbd9bff3d954c37ffe6",
          "assets/slice/actors/painted/directional/actor-kiln-worker/sw.png": "07da8931ce572130a45678c6ea170311a731cf93371c233d9b6029370070775c"
        }
      }
    },
    {
      "recipeId": "actor-guard",
      "recipe": "recipes/art/painted/actors/roster.json",
      "recipeHash": "c7d56c7285f33f43d1fc9f5e3542f57ab6f9a8df4d713a21717f50b7c894475a",
      "class": "actor-sheet",
      "provider": "gpt-image-2",
      "seed": null,
      "takes": 1,
      "generated": {
        "path": "assets/slice/actors/painted/directional/actor-guard/s.png",
        "sha256": "76b5ce8741ed230e501089040837c5953663fbc49ec17fe87abfb04b633fe03f"
      },
      "packed": {
        "path": "assets/slice/packed/actors/painted/actor-guard.png",
        "sha256": "439bd7716cc04784bc7b474aa2a9476dc7b9d2cc9d3f1d44f57ba28e14689f1e",
        "size": [
          1536,
          1584
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "cell": {
          "width": 128,
          "height": 88
        },
        "sheet": {
          "grid": [
            12,
            18
          ],
          "cellFacings": [
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "s",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "se",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "e",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "ne",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "n",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "nw",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "w",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "sw",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null
          ]
        },
        "footY": 80
      },
      "animation": {
        "path": "assets/slice/packed/actors/painted/actor-guard.png",
        "sha256": "439bd7716cc04784bc7b474aa2a9476dc7b9d2cc9d3f1d44f57ba28e14689f1e",
        "size": [
          1536,
          1584
        ],
        "cell": {
          "width": 128,
          "height": 88
        },
        "foot": [
          64,
          80
        ],
        "walkFacings": [
          "s",
          "se",
          "e",
          "ne",
          "n"
        ],
        "clips": {
          "walk": {
            "frames": [
              24,
              25,
              26,
              27,
              28,
              29
            ],
            "fps": 8,
            "loop": true,
            "facings": {
              "s": [
                0,
                1,
                2,
                3,
                4,
                5
              ],
              "se": [
                24,
                25,
                26,
                27,
                28,
                29
              ],
              "e": [
                48,
                49,
                50,
                51,
                52,
                53
              ],
              "ne": [
                72,
                73,
                74,
                75,
                76,
                77
              ],
              "n": [
                96,
                97,
                98,
                99,
                100,
                101
              ],
              "nw": [
                120,
                121,
                122,
                123,
                124,
                125
              ],
              "w": [
                144,
                145,
                146,
                147,
                148,
                149
              ],
              "sw": [
                168,
                169,
                170,
                171,
                172,
                173
              ]
            }
          },
          "attack": {
            "frames": [
              30,
              31,
              32,
              33,
              34,
              35
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                6,
                7,
                8,
                9,
                10,
                11
              ],
              "se": [
                30,
                31,
                32,
                33,
                34,
                35
              ],
              "e": [
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "ne": [
                78,
                79,
                80,
                81,
                82,
                83
              ],
              "n": [
                102,
                103,
                104,
                105,
                106,
                107
              ],
              "nw": [
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "w": [
                150,
                151,
                152,
                153,
                154,
                155
              ],
              "sw": [
                174,
                175,
                176,
                177,
                178,
                179
              ]
            }
          },
          "recoil": {
            "frames": [
              36,
              37
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                12,
                13
              ],
              "se": [
                36,
                37
              ],
              "e": [
                60,
                61
              ],
              "ne": [
                84,
                85
              ],
              "n": [
                108,
                109
              ],
              "nw": [
                132,
                133
              ],
              "w": [
                156,
                157
              ],
              "sw": [
                180,
                181
              ]
            }
          },
          "death": {
            "frames": [
              38,
              39,
              40,
              41
            ],
            "fps": 7,
            "loop": false,
            "facings": {
              "s": [
                14,
                15,
                16,
                17
              ],
              "se": [
                38,
                39,
                40,
                41
              ],
              "e": [
                62,
                63,
                64,
                65
              ],
              "ne": [
                86,
                87,
                88,
                89
              ],
              "n": [
                110,
                111,
                112,
                113
              ],
              "nw": [
                134,
                135,
                136,
                137
              ],
              "w": [
                158,
                159,
                160,
                161
              ],
              "sw": [
                182,
                183,
                184,
                185
              ]
            }
          },
          "corpse": {
            "frames": [
              41
            ],
            "fps": 1,
            "loop": false,
            "facings": {
              "s": [
                17
              ],
              "se": [
                41
              ],
              "e": [
                65
              ],
              "ne": [
                89
              ],
              "n": [
                113
              ],
              "nw": [
                137
              ],
              "w": [
                161
              ],
              "sw": [
                185
              ]
            }
          },
          "idle": {
            "frames": [
              42,
              43,
              44
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                18,
                19,
                20
              ],
              "se": [
                42,
                43,
                44
              ],
              "e": [
                66,
                67,
                68
              ],
              "ne": [
                90,
                91,
                92
              ],
              "n": [
                114,
                115,
                116
              ],
              "nw": [
                138,
                139,
                140
              ],
              "w": [
                162,
                163,
                164
              ],
              "sw": [
                186,
                187,
                188
              ]
            }
          },
          "work": {
            "frames": [
              45,
              46,
              47
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                21,
                22,
                23
              ],
              "se": [
                45,
                46,
                47
              ],
              "e": [
                69,
                70,
                71
              ],
              "ne": [
                93,
                94,
                95
              ],
              "n": [
                117,
                118,
                119
              ],
              "nw": [
                141,
                142,
                143
              ],
              "w": [
                165,
                166,
                167
              ],
              "sw": [
                189,
                190,
                191
              ]
            }
          },
          "receive": {
            "frames": [
              195
            ],
            "facings": {
              "s": [
                192
              ],
              "se": [
                195
              ],
              "e": [
                198
              ],
              "ne": [
                201
              ],
              "n": [
                204
              ],
              "nw": [
                207
              ],
              "w": [
                210
              ],
              "sw": [
                213
              ]
            },
            "fps": 1,
            "loop": false
          },
          "bind": {
            "frames": [
              196
            ],
            "facings": {
              "s": [
                193
              ],
              "se": [
                196
              ],
              "e": [
                199
              ],
              "ne": [
                202
              ],
              "n": [
                205
              ],
              "nw": [
                208
              ],
              "w": [
                211
              ],
              "sw": [
                214
              ]
            },
            "fps": 1,
            "loop": false
          },
          "shove": {
            "frames": [
              197
            ],
            "facings": {
              "s": [
                194
              ],
              "se": [
                197
              ],
              "e": [
                200
              ],
              "ne": [
                203
              ],
              "n": [
                206
              ],
              "nw": [
                209
              ],
              "w": [
                212
              ],
              "sw": [
                215
              ]
            },
            "fps": 1,
            "loop": false
          }
        },
        "source": "assets/slice/actors/painted/directional/actor-guard/s.png",
        "sourceHash": "76b5ce8741ed230e501089040837c5953663fbc49ec17fe87abfb04b633fe03f",
        "recipe": "recipes/art/painted/actors/roster.json",
        "recipeHash": "c7d56c7285f33f43d1fc9f5e3542f57ab6f9a8df4d713a21717f50b7c894475a",
        "provider": "gpt-image-2",
        "sources": {
          "assets/slice/actors/painted/directional/actor-guard/s.png": "76b5ce8741ed230e501089040837c5953663fbc49ec17fe87abfb04b633fe03f",
          "assets/slice/actors/painted/directional/actor-guard/se.png": "461cdfea5836a20a6711e208c86e355ee4e2d98919c28730b41680591394ca23",
          "assets/slice/actors/painted/directional/actor-guard/e.png": "405bbc8f9880d1f3ba0532eb198032846e64bde77097690e3716d6d96a0e2ad5",
          "assets/slice/actors/painted/directional/actor-guard/ne.png": "5104314a25bde374beea411195e8ec8278848b5d8940f4624b277f3914f89475",
          "assets/slice/actors/painted/directional/actor-guard/n.png": "c8ca73de1e6a3193b3c87571ddc9d36bd22e3b23feefba356af00c5c04e1e13c",
          "assets/slice/actors/painted/directional/actor-guard/nw.png": "f4b22733448796c2976fb42525dec86cf8f5a062cb8561f1c69852e8ebe325dd",
          "assets/slice/actors/painted/directional/actor-guard/w.png": "65828d1636bee01fab4fe8301e2b13ad751a768c1deb6b73fe1144c9730e9d24",
          "assets/slice/actors/painted/directional/actor-guard/sw.png": "6b3baaf100a91be00839cb77574f6eef36bde30eb28bf242b06dfda3ff06668c",
          "assets/slice/actors/painted/contact/actor-guard.png": "44a861950d9960196040c3f7a40a6bd8429a9e813b6d825ab0488646be23a034"
        }
      }
    },
    {
      "recipeId": "actor-thief",
      "recipe": "recipes/art/painted/actors/roster.json",
      "recipeHash": "c7d56c7285f33f43d1fc9f5e3542f57ab6f9a8df4d713a21717f50b7c894475a",
      "class": "actor-sheet",
      "provider": "gpt-image-2",
      "seed": null,
      "takes": 1,
      "generated": {
        "path": "assets/slice/actors/painted/directional/actor-thief/s.png",
        "sha256": "275a50e91c388a9e258fbf2fd92283aaa272fbebb044b7186c35a1a6213027b9"
      },
      "packed": {
        "path": "assets/slice/packed/actors/painted/actor-thief.png",
        "sha256": "6f31eeb854f9ff38dd2b8c0e5bf8493f9e3f6e35ffd2242f6866c37270166953",
        "size": [
          1248,
          1440
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "cell": {
          "width": 104,
          "height": 80
        },
        "sheet": {
          "grid": [
            12,
            18
          ],
          "cellFacings": [
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "s",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "se",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "e",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "ne",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "n",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "nw",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "w",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "sw",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null
          ]
        },
        "footY": 72
      },
      "animation": {
        "path": "assets/slice/packed/actors/painted/actor-thief.png",
        "sha256": "6f31eeb854f9ff38dd2b8c0e5bf8493f9e3f6e35ffd2242f6866c37270166953",
        "size": [
          1248,
          1440
        ],
        "cell": {
          "width": 104,
          "height": 80
        },
        "foot": [
          52,
          72
        ],
        "walkFacings": [
          "s",
          "se",
          "e",
          "ne",
          "n"
        ],
        "clips": {
          "walk": {
            "frames": [
              24,
              25,
              26,
              27,
              28,
              29
            ],
            "fps": 8,
            "loop": true,
            "facings": {
              "s": [
                0,
                1,
                2,
                3,
                4,
                5
              ],
              "se": [
                24,
                25,
                26,
                27,
                28,
                29
              ],
              "e": [
                48,
                49,
                50,
                51,
                52,
                53
              ],
              "ne": [
                72,
                73,
                74,
                75,
                76,
                77
              ],
              "n": [
                96,
                97,
                98,
                99,
                100,
                101
              ],
              "nw": [
                120,
                121,
                122,
                123,
                124,
                125
              ],
              "w": [
                144,
                145,
                146,
                147,
                148,
                149
              ],
              "sw": [
                168,
                169,
                170,
                171,
                172,
                173
              ]
            }
          },
          "attack": {
            "frames": [
              30,
              31,
              32,
              33,
              34,
              35
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                6,
                7,
                8,
                9,
                10,
                11
              ],
              "se": [
                30,
                31,
                32,
                33,
                34,
                35
              ],
              "e": [
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "ne": [
                78,
                79,
                80,
                81,
                82,
                83
              ],
              "n": [
                102,
                103,
                104,
                105,
                106,
                107
              ],
              "nw": [
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "w": [
                150,
                151,
                152,
                153,
                154,
                155
              ],
              "sw": [
                174,
                175,
                176,
                177,
                178,
                179
              ]
            }
          },
          "recoil": {
            "frames": [
              36,
              37
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                12,
                13
              ],
              "se": [
                36,
                37
              ],
              "e": [
                60,
                61
              ],
              "ne": [
                84,
                85
              ],
              "n": [
                108,
                109
              ],
              "nw": [
                132,
                133
              ],
              "w": [
                156,
                157
              ],
              "sw": [
                180,
                181
              ]
            }
          },
          "death": {
            "frames": [
              38,
              39,
              40,
              41
            ],
            "fps": 7,
            "loop": false,
            "facings": {
              "s": [
                14,
                15,
                16,
                17
              ],
              "se": [
                38,
                39,
                40,
                41
              ],
              "e": [
                62,
                63,
                64,
                65
              ],
              "ne": [
                86,
                87,
                88,
                89
              ],
              "n": [
                110,
                111,
                112,
                113
              ],
              "nw": [
                134,
                135,
                136,
                137
              ],
              "w": [
                158,
                159,
                160,
                161
              ],
              "sw": [
                182,
                183,
                184,
                185
              ]
            }
          },
          "corpse": {
            "frames": [
              41
            ],
            "fps": 1,
            "loop": false,
            "facings": {
              "s": [
                17
              ],
              "se": [
                41
              ],
              "e": [
                65
              ],
              "ne": [
                89
              ],
              "n": [
                113
              ],
              "nw": [
                137
              ],
              "w": [
                161
              ],
              "sw": [
                185
              ]
            }
          },
          "idle": {
            "frames": [
              42,
              43,
              44
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                18,
                19,
                20
              ],
              "se": [
                42,
                43,
                44
              ],
              "e": [
                66,
                67,
                68
              ],
              "ne": [
                90,
                91,
                92
              ],
              "n": [
                114,
                115,
                116
              ],
              "nw": [
                138,
                139,
                140
              ],
              "w": [
                162,
                163,
                164
              ],
              "sw": [
                186,
                187,
                188
              ]
            }
          },
          "work": {
            "frames": [
              45,
              46,
              47
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                21,
                22,
                23
              ],
              "se": [
                45,
                46,
                47
              ],
              "e": [
                69,
                70,
                71
              ],
              "ne": [
                93,
                94,
                95
              ],
              "n": [
                117,
                118,
                119
              ],
              "nw": [
                141,
                142,
                143
              ],
              "w": [
                165,
                166,
                167
              ],
              "sw": [
                189,
                190,
                191
              ]
            }
          },
          "receive": {
            "frames": [
              195
            ],
            "facings": {
              "s": [
                192
              ],
              "se": [
                195
              ],
              "e": [
                198
              ],
              "ne": [
                201
              ],
              "n": [
                204
              ],
              "nw": [
                207
              ],
              "w": [
                210
              ],
              "sw": [
                213
              ]
            },
            "fps": 1,
            "loop": false
          },
          "bind": {
            "frames": [
              196
            ],
            "facings": {
              "s": [
                193
              ],
              "se": [
                196
              ],
              "e": [
                199
              ],
              "ne": [
                202
              ],
              "n": [
                205
              ],
              "nw": [
                208
              ],
              "w": [
                211
              ],
              "sw": [
                214
              ]
            },
            "fps": 1,
            "loop": false
          },
          "shove": {
            "frames": [
              197
            ],
            "facings": {
              "s": [
                194
              ],
              "se": [
                197
              ],
              "e": [
                200
              ],
              "ne": [
                203
              ],
              "n": [
                206
              ],
              "nw": [
                209
              ],
              "w": [
                212
              ],
              "sw": [
                215
              ]
            },
            "fps": 1,
            "loop": false
          }
        },
        "source": "assets/slice/actors/painted/directional/actor-thief/s.png",
        "sourceHash": "275a50e91c388a9e258fbf2fd92283aaa272fbebb044b7186c35a1a6213027b9",
        "recipe": "recipes/art/painted/actors/roster.json",
        "recipeHash": "c7d56c7285f33f43d1fc9f5e3542f57ab6f9a8df4d713a21717f50b7c894475a",
        "provider": "gpt-image-2",
        "sources": {
          "assets/slice/actors/painted/directional/actor-thief/s.png": "275a50e91c388a9e258fbf2fd92283aaa272fbebb044b7186c35a1a6213027b9",
          "assets/slice/actors/painted/directional/actor-thief/se.png": "e5e68dd5c5e5f0e3899cc85a2e3c8d683b43b46ed8f62e115e87f0811bd44ea3",
          "assets/slice/actors/painted/directional/actor-thief/e.png": "f1bc2d945bd5f624fa940b4856e543edd760959130cb62965f335c571cbad782",
          "assets/slice/actors/painted/directional/actor-thief/ne.png": "023ea8a3085dbce161dd4b730bd5419d6745f52d2756965fe74490c5fa3faf62",
          "assets/slice/actors/painted/directional/actor-thief/n.png": "b516967784c349fc40448269730a6f87686ddbd789f5d3c4ceaa053a670315cb",
          "assets/slice/actors/painted/directional/actor-thief/nw.png": "81fe367d07f67423cccc17c92936769c1ac06364f27623d8c8c7ea303fe7ee7a",
          "assets/slice/actors/painted/directional/actor-thief/w.png": "c555548f20a22cb76b8d8df4747888ee9fb491f4531c12b923e78706e98f0843",
          "assets/slice/actors/painted/directional/actor-thief/sw.png": "e55a2d07297505fbb7be92f2a3a3e7f0099d2d8e4f7bddb76c40c1f0271fc300",
          "assets/slice/actors/painted/contact/actor-thief.png": "29decb68305990441a30502bdc11cc4fed859d05d8af5f6cb290d9bc85647b3a"
        }
      }
    },
    {
      "recipeId": "actor-z01-forum-watch",
      "recipe": "recipes/art/painted/actors/roster-Z01.json",
      "recipeHash": "c496a203f76935541499db2729f134bbe14c54a802f55a93947a5fdbda0da20c",
      "class": "actor-sheet",
      "provider": "gpt-image-2",
      "seed": null,
      "takes": 1,
      "generated": {
        "path": "assets/slice/actors/painted/directional/actor-z01-forum-watch/s.png",
        "sha256": "51007a935a1bfa9fb4c5bc68013977e9972dea2c3f2f503d3a5c831471c6adcb"
      },
      "packed": {
        "path": "assets/slice/packed/actors/painted/actor-z01-forum-watch.png",
        "sha256": "3f09044afa4c6747e92d01682e9a5f2d4486816d51a933c889fc8337ba3d73fd",
        "size": [
          1440,
          1408
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "cell": {
          "width": 120,
          "height": 88
        },
        "sheet": {
          "grid": [
            12,
            16
          ],
          "cellFacings": [
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "s",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "se",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "e",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "ne",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "n",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "nw",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "w",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "sw",
            null,
            null,
            null,
            null,
            null
          ]
        },
        "footY": 80
      },
      "animation": {
        "path": "assets/slice/packed/actors/painted/actor-z01-forum-watch.png",
        "sha256": "3f09044afa4c6747e92d01682e9a5f2d4486816d51a933c889fc8337ba3d73fd",
        "size": [
          1440,
          1408
        ],
        "cell": {
          "width": 120,
          "height": 88
        },
        "foot": [
          60,
          80
        ],
        "walkFacings": [
          "s",
          "se",
          "e",
          "ne",
          "n"
        ],
        "clips": {
          "walk": {
            "frames": [
              24,
              25,
              26,
              27,
              28,
              29
            ],
            "fps": 8,
            "loop": true,
            "facings": {
              "s": [
                0,
                1,
                2,
                3,
                4,
                5
              ],
              "se": [
                24,
                25,
                26,
                27,
                28,
                29
              ],
              "e": [
                48,
                49,
                50,
                51,
                52,
                53
              ],
              "ne": [
                72,
                73,
                74,
                75,
                76,
                77
              ],
              "n": [
                96,
                97,
                98,
                99,
                100,
                101
              ],
              "nw": [
                120,
                121,
                122,
                123,
                124,
                125
              ],
              "w": [
                144,
                145,
                146,
                147,
                148,
                149
              ],
              "sw": [
                168,
                169,
                170,
                171,
                172,
                173
              ]
            }
          },
          "attack": {
            "frames": [
              30,
              31,
              32,
              33,
              34,
              35
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                6,
                7,
                8,
                9,
                10,
                11
              ],
              "se": [
                30,
                31,
                32,
                33,
                34,
                35
              ],
              "e": [
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "ne": [
                78,
                79,
                80,
                81,
                82,
                83
              ],
              "n": [
                102,
                103,
                104,
                105,
                106,
                107
              ],
              "nw": [
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "w": [
                150,
                151,
                152,
                153,
                154,
                155
              ],
              "sw": [
                174,
                175,
                176,
                177,
                178,
                179
              ]
            }
          },
          "recoil": {
            "frames": [
              36,
              37
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                12,
                13
              ],
              "se": [
                36,
                37
              ],
              "e": [
                60,
                61
              ],
              "ne": [
                84,
                85
              ],
              "n": [
                108,
                109
              ],
              "nw": [
                132,
                133
              ],
              "w": [
                156,
                157
              ],
              "sw": [
                180,
                181
              ]
            }
          },
          "death": {
            "frames": [
              38,
              39,
              40,
              41
            ],
            "fps": 7,
            "loop": false,
            "facings": {
              "s": [
                14,
                15,
                16,
                17
              ],
              "se": [
                38,
                39,
                40,
                41
              ],
              "e": [
                62,
                63,
                64,
                65
              ],
              "ne": [
                86,
                87,
                88,
                89
              ],
              "n": [
                110,
                111,
                112,
                113
              ],
              "nw": [
                134,
                135,
                136,
                137
              ],
              "w": [
                158,
                159,
                160,
                161
              ],
              "sw": [
                182,
                183,
                184,
                185
              ]
            }
          },
          "corpse": {
            "frames": [
              41
            ],
            "fps": 1,
            "loop": false,
            "facings": {
              "s": [
                17
              ],
              "se": [
                41
              ],
              "e": [
                65
              ],
              "ne": [
                89
              ],
              "n": [
                113
              ],
              "nw": [
                137
              ],
              "w": [
                161
              ],
              "sw": [
                185
              ]
            }
          },
          "idle": {
            "frames": [
              42,
              43,
              44
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                18,
                19,
                20
              ],
              "se": [
                42,
                43,
                44
              ],
              "e": [
                66,
                67,
                68
              ],
              "ne": [
                90,
                91,
                92
              ],
              "n": [
                114,
                115,
                116
              ],
              "nw": [
                138,
                139,
                140
              ],
              "w": [
                162,
                163,
                164
              ],
              "sw": [
                186,
                187,
                188
              ]
            }
          },
          "work": {
            "frames": [
              45,
              46,
              47
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                21,
                22,
                23
              ],
              "se": [
                45,
                46,
                47
              ],
              "e": [
                69,
                70,
                71
              ],
              "ne": [
                93,
                94,
                95
              ],
              "n": [
                117,
                118,
                119
              ],
              "nw": [
                141,
                142,
                143
              ],
              "w": [
                165,
                166,
                167
              ],
              "sw": [
                189,
                190,
                191
              ]
            }
          }
        },
        "source": "assets/slice/actors/painted/directional/actor-z01-forum-watch/s.png",
        "sourceHash": "51007a935a1bfa9fb4c5bc68013977e9972dea2c3f2f503d3a5c831471c6adcb",
        "recipe": "recipes/art/painted/actors/roster-Z01.json",
        "recipeHash": "c496a203f76935541499db2729f134bbe14c54a802f55a93947a5fdbda0da20c",
        "provider": "gpt-image-2",
        "sources": {
          "assets/slice/actors/painted/directional/actor-z01-forum-watch/s.png": "51007a935a1bfa9fb4c5bc68013977e9972dea2c3f2f503d3a5c831471c6adcb",
          "assets/slice/actors/painted/directional/actor-z01-forum-watch/se.png": "4876d6f9fd42a5f5b432205b684c864b0461017804a89be91b96303e6ab98410",
          "assets/slice/actors/painted/directional/actor-z01-forum-watch/e.png": "b45e78a9b00846589d328cb0862bddbeb96b9469ae31abeda4768fb3878abe56",
          "assets/slice/actors/painted/directional/actor-z01-forum-watch/ne.png": "027d8abf484de2e225c57cc457cf45d6c81aca7158505aa4323d7e99cd9bfe5b",
          "assets/slice/actors/painted/directional/actor-z01-forum-watch/n.png": "d5ed5b91a67c526f0c8410f56815a6f4b6911cbffb815dde75f61c5b133f6991",
          "assets/slice/actors/painted/directional/actor-z01-forum-watch/nw.png": "4e8622340441ddf3cc131000ca8fbc232e65adbc81dd6ae8aa0965a89b696428",
          "assets/slice/actors/painted/directional/actor-z01-forum-watch/w.png": "1e006fe1c94b72ef9dae230f2f24cef120d31e7ad9327183c223c2cfeb4439b1",
          "assets/slice/actors/painted/directional/actor-z01-forum-watch/sw.png": "7e1fbb4c8b0933a18f2b58808b8f490b35efb0d06b0bef8f6cf1202b7347c868"
        }
      }
    },
    {
      "recipeId": "actor-z01-bread-queue",
      "recipe": "recipes/art/painted/actors/roster-Z01.json",
      "recipeHash": "c496a203f76935541499db2729f134bbe14c54a802f55a93947a5fdbda0da20c",
      "class": "actor-sheet",
      "provider": "gpt-image-2",
      "seed": null,
      "takes": 1,
      "generated": {
        "path": "assets/slice/actors/painted/directional/actor-z01-bread-queue/s.png",
        "sha256": "205a49d5f2b936f4ac2a93197ee9d1204358bb04c3abcad241571a4e059c3235"
      },
      "packed": {
        "path": "assets/slice/packed/actors/painted/actor-z01-bread-queue.png",
        "sha256": "a7a84fd305faf51488f1a29ebbb1d25294b1556af26e9c7a31c77a4a0ee2de0e",
        "size": [
          1056,
          1280
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "cell": {
          "width": 88,
          "height": 80
        },
        "sheet": {
          "grid": [
            12,
            16
          ],
          "cellFacings": [
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "s",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "se",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "e",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "ne",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "n",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "nw",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "w",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "sw",
            null,
            null,
            null,
            null,
            null
          ]
        },
        "footY": 72
      },
      "animation": {
        "path": "assets/slice/packed/actors/painted/actor-z01-bread-queue.png",
        "sha256": "a7a84fd305faf51488f1a29ebbb1d25294b1556af26e9c7a31c77a4a0ee2de0e",
        "size": [
          1056,
          1280
        ],
        "cell": {
          "width": 88,
          "height": 80
        },
        "foot": [
          44,
          72
        ],
        "walkFacings": [
          "s",
          "se",
          "e",
          "ne",
          "n"
        ],
        "clips": {
          "walk": {
            "frames": [
              24,
              25,
              26,
              27,
              28,
              29
            ],
            "fps": 8,
            "loop": true,
            "facings": {
              "s": [
                0,
                1,
                2,
                3,
                4,
                5
              ],
              "se": [
                24,
                25,
                26,
                27,
                28,
                29
              ],
              "e": [
                48,
                49,
                50,
                51,
                52,
                53
              ],
              "ne": [
                72,
                73,
                74,
                75,
                76,
                77
              ],
              "n": [
                96,
                97,
                98,
                99,
                100,
                101
              ],
              "nw": [
                120,
                121,
                122,
                123,
                124,
                125
              ],
              "w": [
                144,
                145,
                146,
                147,
                148,
                149
              ],
              "sw": [
                168,
                169,
                170,
                171,
                172,
                173
              ]
            }
          },
          "attack": {
            "frames": [
              30,
              31,
              32,
              33,
              34,
              35
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                6,
                7,
                8,
                9,
                10,
                11
              ],
              "se": [
                30,
                31,
                32,
                33,
                34,
                35
              ],
              "e": [
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "ne": [
                78,
                79,
                80,
                81,
                82,
                83
              ],
              "n": [
                102,
                103,
                104,
                105,
                106,
                107
              ],
              "nw": [
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "w": [
                150,
                151,
                152,
                153,
                154,
                155
              ],
              "sw": [
                174,
                175,
                176,
                177,
                178,
                179
              ]
            }
          },
          "recoil": {
            "frames": [
              36,
              37
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                12,
                13
              ],
              "se": [
                36,
                37
              ],
              "e": [
                60,
                61
              ],
              "ne": [
                84,
                85
              ],
              "n": [
                108,
                109
              ],
              "nw": [
                132,
                133
              ],
              "w": [
                156,
                157
              ],
              "sw": [
                180,
                181
              ]
            }
          },
          "death": {
            "frames": [
              38,
              39,
              40,
              41
            ],
            "fps": 7,
            "loop": false,
            "facings": {
              "s": [
                14,
                15,
                16,
                17
              ],
              "se": [
                38,
                39,
                40,
                41
              ],
              "e": [
                62,
                63,
                64,
                65
              ],
              "ne": [
                86,
                87,
                88,
                89
              ],
              "n": [
                110,
                111,
                112,
                113
              ],
              "nw": [
                134,
                135,
                136,
                137
              ],
              "w": [
                158,
                159,
                160,
                161
              ],
              "sw": [
                182,
                183,
                184,
                185
              ]
            }
          },
          "corpse": {
            "frames": [
              41
            ],
            "fps": 1,
            "loop": false,
            "facings": {
              "s": [
                17
              ],
              "se": [
                41
              ],
              "e": [
                65
              ],
              "ne": [
                89
              ],
              "n": [
                113
              ],
              "nw": [
                137
              ],
              "w": [
                161
              ],
              "sw": [
                185
              ]
            }
          },
          "idle": {
            "frames": [
              42,
              43,
              44
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                18,
                19,
                20
              ],
              "se": [
                42,
                43,
                44
              ],
              "e": [
                66,
                67,
                68
              ],
              "ne": [
                90,
                91,
                92
              ],
              "n": [
                114,
                115,
                116
              ],
              "nw": [
                138,
                139,
                140
              ],
              "w": [
                162,
                163,
                164
              ],
              "sw": [
                186,
                187,
                188
              ]
            }
          },
          "work": {
            "frames": [
              45,
              46,
              47
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                21,
                22,
                23
              ],
              "se": [
                45,
                46,
                47
              ],
              "e": [
                69,
                70,
                71
              ],
              "ne": [
                93,
                94,
                95
              ],
              "n": [
                117,
                118,
                119
              ],
              "nw": [
                141,
                142,
                143
              ],
              "w": [
                165,
                166,
                167
              ],
              "sw": [
                189,
                190,
                191
              ]
            }
          }
        },
        "source": "assets/slice/actors/painted/directional/actor-z01-bread-queue/s.png",
        "sourceHash": "205a49d5f2b936f4ac2a93197ee9d1204358bb04c3abcad241571a4e059c3235",
        "recipe": "recipes/art/painted/actors/roster-Z01.json",
        "recipeHash": "c496a203f76935541499db2729f134bbe14c54a802f55a93947a5fdbda0da20c",
        "provider": "gpt-image-2",
        "sources": {
          "assets/slice/actors/painted/directional/actor-z01-bread-queue/s.png": "205a49d5f2b936f4ac2a93197ee9d1204358bb04c3abcad241571a4e059c3235",
          "assets/slice/actors/painted/directional/actor-z01-bread-queue/se.png": "b0082d7dd605cb913d052a88d3dd1d6b42add630bb23975cfbe6962ea39584b0",
          "assets/slice/actors/painted/directional/actor-z01-bread-queue/e.png": "bb93dcb0d57e43aff9cd969e0dd5315d19de013bfae13457b394142b54ef0a07",
          "assets/slice/actors/painted/directional/actor-z01-bread-queue/ne.png": "41442b87b9e020de78e8c6632f7681bd1f34bc7541af4f424dc95017950f0278",
          "assets/slice/actors/painted/directional/actor-z01-bread-queue/n.png": "59cfb8ef188190524d2087277adbd9b804174f70009780413586992cbcad5f27",
          "assets/slice/actors/painted/directional/actor-z01-bread-queue/nw.png": "ea85dccedf0ff8e6419c423189f96e8bdcac3d85449dd27280dc7466b92c35e2",
          "assets/slice/actors/painted/directional/actor-z01-bread-queue/w.png": "d3d1ad455663191d999ad1d1bfa1bf307eb76f747e2634192a70a7c0296d67c9",
          "assets/slice/actors/painted/directional/actor-z01-bread-queue/sw.png": "98e35ae2352f3ac97a4539e781d3da46b50860505b69eefaed6b751176cea2c8"
        }
      }
    },
    {
      "recipeId": "actor-ildren-vos",
      "recipe": "recipes/art/painted/actors/roster-Z01.json",
      "recipeHash": "c496a203f76935541499db2729f134bbe14c54a802f55a93947a5fdbda0da20c",
      "class": "actor-sheet",
      "provider": "gpt-image-2",
      "seed": null,
      "takes": 1,
      "generated": {
        "path": "assets/slice/actors/painted/directional/actor-ildren-vos/s.png",
        "sha256": "550229bc83b5dfef7ced7278c5def95ee6918b3fc0447e65c9ec31a7f2007c7e"
      },
      "packed": {
        "path": "assets/slice/packed/actors/painted/actor-ildren-vos.png",
        "sha256": "0c1c473602f1aaa63db3f1b89ea56b6c3a50bf31cb2ffc03ed159ae821b19fbc",
        "size": [
          1248,
          1408
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "cell": {
          "width": 104,
          "height": 88
        },
        "sheet": {
          "grid": [
            12,
            16
          ],
          "cellFacings": [
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "s",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "se",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "e",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "ne",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "n",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "nw",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "w",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "sw",
            null,
            null,
            null,
            null,
            null
          ]
        },
        "footY": 80
      },
      "animation": {
        "path": "assets/slice/packed/actors/painted/actor-ildren-vos.png",
        "sha256": "0c1c473602f1aaa63db3f1b89ea56b6c3a50bf31cb2ffc03ed159ae821b19fbc",
        "size": [
          1248,
          1408
        ],
        "cell": {
          "width": 104,
          "height": 88
        },
        "foot": [
          52,
          80
        ],
        "walkFacings": [
          "s",
          "se",
          "e",
          "ne",
          "n"
        ],
        "clips": {
          "walk": {
            "frames": [
              24,
              25,
              26,
              27,
              28,
              29
            ],
            "fps": 8,
            "loop": true,
            "facings": {
              "s": [
                0,
                1,
                2,
                3,
                4,
                5
              ],
              "se": [
                24,
                25,
                26,
                27,
                28,
                29
              ],
              "e": [
                48,
                49,
                50,
                51,
                52,
                53
              ],
              "ne": [
                72,
                73,
                74,
                75,
                76,
                77
              ],
              "n": [
                96,
                97,
                98,
                99,
                100,
                101
              ],
              "nw": [
                120,
                121,
                122,
                123,
                124,
                125
              ],
              "w": [
                144,
                145,
                146,
                147,
                148,
                149
              ],
              "sw": [
                168,
                169,
                170,
                171,
                172,
                173
              ]
            }
          },
          "attack": {
            "frames": [
              30,
              31,
              32,
              33,
              34,
              35
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                6,
                7,
                8,
                9,
                10,
                11
              ],
              "se": [
                30,
                31,
                32,
                33,
                34,
                35
              ],
              "e": [
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "ne": [
                78,
                79,
                80,
                81,
                82,
                83
              ],
              "n": [
                102,
                103,
                104,
                105,
                106,
                107
              ],
              "nw": [
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "w": [
                150,
                151,
                152,
                153,
                154,
                155
              ],
              "sw": [
                174,
                175,
                176,
                177,
                178,
                179
              ]
            }
          },
          "recoil": {
            "frames": [
              36,
              37
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                12,
                13
              ],
              "se": [
                36,
                37
              ],
              "e": [
                60,
                61
              ],
              "ne": [
                84,
                85
              ],
              "n": [
                108,
                109
              ],
              "nw": [
                132,
                133
              ],
              "w": [
                156,
                157
              ],
              "sw": [
                180,
                181
              ]
            }
          },
          "death": {
            "frames": [
              38,
              39,
              40,
              41
            ],
            "fps": 7,
            "loop": false,
            "facings": {
              "s": [
                14,
                15,
                16,
                17
              ],
              "se": [
                38,
                39,
                40,
                41
              ],
              "e": [
                62,
                63,
                64,
                65
              ],
              "ne": [
                86,
                87,
                88,
                89
              ],
              "n": [
                110,
                111,
                112,
                113
              ],
              "nw": [
                134,
                135,
                136,
                137
              ],
              "w": [
                158,
                159,
                160,
                161
              ],
              "sw": [
                182,
                183,
                184,
                185
              ]
            }
          },
          "corpse": {
            "frames": [
              41
            ],
            "fps": 1,
            "loop": false,
            "facings": {
              "s": [
                17
              ],
              "se": [
                41
              ],
              "e": [
                65
              ],
              "ne": [
                89
              ],
              "n": [
                113
              ],
              "nw": [
                137
              ],
              "w": [
                161
              ],
              "sw": [
                185
              ]
            }
          },
          "idle": {
            "frames": [
              42,
              43,
              44
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                18,
                19,
                20
              ],
              "se": [
                42,
                43,
                44
              ],
              "e": [
                66,
                67,
                68
              ],
              "ne": [
                90,
                91,
                92
              ],
              "n": [
                114,
                115,
                116
              ],
              "nw": [
                138,
                139,
                140
              ],
              "w": [
                162,
                163,
                164
              ],
              "sw": [
                186,
                187,
                188
              ]
            }
          },
          "work": {
            "frames": [
              45,
              46,
              47
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                21,
                22,
                23
              ],
              "se": [
                45,
                46,
                47
              ],
              "e": [
                69,
                70,
                71
              ],
              "ne": [
                93,
                94,
                95
              ],
              "n": [
                117,
                118,
                119
              ],
              "nw": [
                141,
                142,
                143
              ],
              "w": [
                165,
                166,
                167
              ],
              "sw": [
                189,
                190,
                191
              ]
            }
          }
        },
        "source": "assets/slice/actors/painted/directional/actor-ildren-vos/s.png",
        "sourceHash": "550229bc83b5dfef7ced7278c5def95ee6918b3fc0447e65c9ec31a7f2007c7e",
        "recipe": "recipes/art/painted/actors/roster-Z01.json",
        "recipeHash": "c496a203f76935541499db2729f134bbe14c54a802f55a93947a5fdbda0da20c",
        "provider": "gpt-image-2",
        "sources": {
          "assets/slice/actors/painted/directional/actor-ildren-vos/s.png": "550229bc83b5dfef7ced7278c5def95ee6918b3fc0447e65c9ec31a7f2007c7e",
          "assets/slice/actors/painted/directional/actor-ildren-vos/se.png": "1ee8a19f8dfd6c55796ffacbd4bd56ffff4d2b525883df121739e496533264f3",
          "assets/slice/actors/painted/directional/actor-ildren-vos/e.png": "dec7be5ec40aa8a4d357a6cddd0b515c2dde5e1174518e62e90af123738cfd0a",
          "assets/slice/actors/painted/directional/actor-ildren-vos/ne.png": "36a085157b6f49049b48277a5f2329078916caf5e77e66c50d09564054634b0f",
          "assets/slice/actors/painted/directional/actor-ildren-vos/n.png": "c10eb8a274f19bfd85323a7a534f77c023762a43f416c4797550766d8db61ff8",
          "assets/slice/actors/painted/directional/actor-ildren-vos/nw.png": "1d3d2f03a0c7320a19412a5a349097751696b365caaf4c9acf4b9cf419f452dd",
          "assets/slice/actors/painted/directional/actor-ildren-vos/w.png": "530011b638b9b1e9d21715da41d159b6f0fc838a9207830f6ba0719b1cb0cdbc",
          "assets/slice/actors/painted/directional/actor-ildren-vos/sw.png": "66e6c03a9296f6d74a3a0ac96186018da6a070d010f00b28bab2f6e331d01f24"
        }
      }
    },
    {
      "recipeId": "actor-z01-clerk",
      "recipe": "recipes/art/painted/actors/roster-Z01.json",
      "recipeHash": "c496a203f76935541499db2729f134bbe14c54a802f55a93947a5fdbda0da20c",
      "class": "actor-sheet",
      "provider": "gpt-image-2",
      "seed": null,
      "takes": 1,
      "generated": {
        "path": "assets/slice/actors/painted/directional/actor-z01-clerk/s.png",
        "sha256": "6ceffa4f51f1b2ce27a0d35901d8f87286abc74d3e30cb1771580735baebca12"
      },
      "packed": {
        "path": "assets/slice/packed/actors/painted/actor-z01-clerk.png",
        "sha256": "b94aa51c61ade593cb96c9c812ec34b7b286ace6e32320c6a11c26bad0927576",
        "size": [
          1152,
          1280
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "cell": {
          "width": 96,
          "height": 80
        },
        "sheet": {
          "grid": [
            12,
            16
          ],
          "cellFacings": [
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "s",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "se",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "e",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "ne",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "n",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "nw",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "w",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "sw",
            null,
            null,
            null,
            null,
            null
          ]
        },
        "footY": 72
      },
      "animation": {
        "path": "assets/slice/packed/actors/painted/actor-z01-clerk.png",
        "sha256": "b94aa51c61ade593cb96c9c812ec34b7b286ace6e32320c6a11c26bad0927576",
        "size": [
          1152,
          1280
        ],
        "cell": {
          "width": 96,
          "height": 80
        },
        "foot": [
          48,
          72
        ],
        "walkFacings": [
          "s",
          "se",
          "e",
          "ne",
          "n"
        ],
        "clips": {
          "walk": {
            "frames": [
              24,
              25,
              26,
              27,
              28,
              29
            ],
            "fps": 8,
            "loop": true,
            "facings": {
              "s": [
                0,
                1,
                2,
                3,
                4,
                5
              ],
              "se": [
                24,
                25,
                26,
                27,
                28,
                29
              ],
              "e": [
                48,
                49,
                50,
                51,
                52,
                53
              ],
              "ne": [
                72,
                73,
                74,
                75,
                76,
                77
              ],
              "n": [
                96,
                97,
                98,
                99,
                100,
                101
              ],
              "nw": [
                120,
                121,
                122,
                123,
                124,
                125
              ],
              "w": [
                144,
                145,
                146,
                147,
                148,
                149
              ],
              "sw": [
                168,
                169,
                170,
                171,
                172,
                173
              ]
            }
          },
          "attack": {
            "frames": [
              30,
              31,
              32,
              33,
              34,
              35
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                6,
                7,
                8,
                9,
                10,
                11
              ],
              "se": [
                30,
                31,
                32,
                33,
                34,
                35
              ],
              "e": [
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "ne": [
                78,
                79,
                80,
                81,
                82,
                83
              ],
              "n": [
                102,
                103,
                104,
                105,
                106,
                107
              ],
              "nw": [
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "w": [
                150,
                151,
                152,
                153,
                154,
                155
              ],
              "sw": [
                174,
                175,
                176,
                177,
                178,
                179
              ]
            }
          },
          "recoil": {
            "frames": [
              36,
              37
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                12,
                13
              ],
              "se": [
                36,
                37
              ],
              "e": [
                60,
                61
              ],
              "ne": [
                84,
                85
              ],
              "n": [
                108,
                109
              ],
              "nw": [
                132,
                133
              ],
              "w": [
                156,
                157
              ],
              "sw": [
                180,
                181
              ]
            }
          },
          "death": {
            "frames": [
              38,
              39,
              40,
              41
            ],
            "fps": 7,
            "loop": false,
            "facings": {
              "s": [
                14,
                15,
                16,
                17
              ],
              "se": [
                38,
                39,
                40,
                41
              ],
              "e": [
                62,
                63,
                64,
                65
              ],
              "ne": [
                86,
                87,
                88,
                89
              ],
              "n": [
                110,
                111,
                112,
                113
              ],
              "nw": [
                134,
                135,
                136,
                137
              ],
              "w": [
                158,
                159,
                160,
                161
              ],
              "sw": [
                182,
                183,
                184,
                185
              ]
            }
          },
          "corpse": {
            "frames": [
              41
            ],
            "fps": 1,
            "loop": false,
            "facings": {
              "s": [
                17
              ],
              "se": [
                41
              ],
              "e": [
                65
              ],
              "ne": [
                89
              ],
              "n": [
                113
              ],
              "nw": [
                137
              ],
              "w": [
                161
              ],
              "sw": [
                185
              ]
            }
          },
          "idle": {
            "frames": [
              42,
              43,
              44
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                18,
                19,
                20
              ],
              "se": [
                42,
                43,
                44
              ],
              "e": [
                66,
                67,
                68
              ],
              "ne": [
                90,
                91,
                92
              ],
              "n": [
                114,
                115,
                116
              ],
              "nw": [
                138,
                139,
                140
              ],
              "w": [
                162,
                163,
                164
              ],
              "sw": [
                186,
                187,
                188
              ]
            }
          },
          "work": {
            "frames": [
              45,
              46,
              47
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                21,
                22,
                23
              ],
              "se": [
                45,
                46,
                47
              ],
              "e": [
                69,
                70,
                71
              ],
              "ne": [
                93,
                94,
                95
              ],
              "n": [
                117,
                118,
                119
              ],
              "nw": [
                141,
                142,
                143
              ],
              "w": [
                165,
                166,
                167
              ],
              "sw": [
                189,
                190,
                191
              ]
            }
          }
        },
        "source": "assets/slice/actors/painted/directional/actor-z01-clerk/s.png",
        "sourceHash": "6ceffa4f51f1b2ce27a0d35901d8f87286abc74d3e30cb1771580735baebca12",
        "recipe": "recipes/art/painted/actors/roster-Z01.json",
        "recipeHash": "c496a203f76935541499db2729f134bbe14c54a802f55a93947a5fdbda0da20c",
        "provider": "gpt-image-2",
        "sources": {
          "assets/slice/actors/painted/directional/actor-z01-clerk/s.png": "6ceffa4f51f1b2ce27a0d35901d8f87286abc74d3e30cb1771580735baebca12",
          "assets/slice/actors/painted/directional/actor-z01-clerk/se.png": "ec172f27f479339294b34d537151361f28793ae835c9c701d5ab6c495f68a5d4",
          "assets/slice/actors/painted/directional/actor-z01-clerk/e.png": "3d7f12aa644b5a310c7f4eb867bf3f50cc99938114510f4e860bfdaf2c94d29b",
          "assets/slice/actors/painted/directional/actor-z01-clerk/ne.png": "b85a7641e0237aef7aa537cbff84e0c8c94ff4f99bda2209305a1a99a11be33f",
          "assets/slice/actors/painted/directional/actor-z01-clerk/n.png": "2fcdfb6ff55e08bc7726ac53a7ef69efd3c6e290ab11529558447a9c80dcc846",
          "assets/slice/actors/painted/directional/actor-z01-clerk/nw.png": "2cdb1353e61bb4e9bf46f80699c5cdc87f1bb33689a65caeadf10be8d0e3ede4",
          "assets/slice/actors/painted/directional/actor-z01-clerk/w.png": "3f1b42583468a57ac028c2d60015c8022f34614419e3b880f642e8b5b99c3c0f",
          "assets/slice/actors/painted/directional/actor-z01-clerk/sw.png": "b71b8a3df8231b6049ec93884aaaf341249432b40686ba1c6131b333a20e18b4"
        }
      }
    },
    {
      "recipeId": "actor-z01-bond-runner",
      "recipe": "recipes/art/painted/actors/roster-Z01.json",
      "recipeHash": "c496a203f76935541499db2729f134bbe14c54a802f55a93947a5fdbda0da20c",
      "class": "actor-sheet",
      "provider": "gpt-image-2",
      "seed": null,
      "takes": 1,
      "generated": {
        "path": "assets/slice/actors/painted/directional/actor-z01-bond-runner/s.png",
        "sha256": "9cb6a3831f63526ae7d455b6691688985582245f3ffb9943641a548d510a4d05"
      },
      "packed": {
        "path": "assets/slice/packed/actors/painted/actor-z01-bond-runner.png",
        "sha256": "e9bc95e0c00b86c200729cc7b0f7282afb76f0157ebc2c28c0833b3c151b573f",
        "size": [
          1248,
          1408
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "cell": {
          "width": 104,
          "height": 88
        },
        "sheet": {
          "grid": [
            12,
            16
          ],
          "cellFacings": [
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "s",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "se",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "e",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "ne",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "n",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "nw",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "w",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "sw",
            null,
            null,
            null,
            null,
            null
          ]
        },
        "footY": 80
      },
      "animation": {
        "path": "assets/slice/packed/actors/painted/actor-z01-bond-runner.png",
        "sha256": "e9bc95e0c00b86c200729cc7b0f7282afb76f0157ebc2c28c0833b3c151b573f",
        "size": [
          1248,
          1408
        ],
        "cell": {
          "width": 104,
          "height": 88
        },
        "foot": [
          52,
          80
        ],
        "walkFacings": [
          "s",
          "se",
          "e",
          "ne",
          "n"
        ],
        "clips": {
          "walk": {
            "frames": [
              24,
              25,
              26,
              27,
              28,
              29
            ],
            "fps": 8,
            "loop": true,
            "facings": {
              "s": [
                0,
                1,
                2,
                3,
                4,
                5
              ],
              "se": [
                24,
                25,
                26,
                27,
                28,
                29
              ],
              "e": [
                48,
                49,
                50,
                51,
                52,
                53
              ],
              "ne": [
                72,
                73,
                74,
                75,
                76,
                77
              ],
              "n": [
                96,
                97,
                98,
                99,
                100,
                101
              ],
              "nw": [
                120,
                121,
                122,
                123,
                124,
                125
              ],
              "w": [
                144,
                145,
                146,
                147,
                148,
                149
              ],
              "sw": [
                168,
                169,
                170,
                171,
                172,
                173
              ]
            }
          },
          "attack": {
            "frames": [
              30,
              31,
              32,
              33,
              34,
              35
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                6,
                7,
                8,
                9,
                10,
                11
              ],
              "se": [
                30,
                31,
                32,
                33,
                34,
                35
              ],
              "e": [
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "ne": [
                78,
                79,
                80,
                81,
                82,
                83
              ],
              "n": [
                102,
                103,
                104,
                105,
                106,
                107
              ],
              "nw": [
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "w": [
                150,
                151,
                152,
                153,
                154,
                155
              ],
              "sw": [
                174,
                175,
                176,
                177,
                178,
                179
              ]
            }
          },
          "recoil": {
            "frames": [
              36,
              37
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                12,
                13
              ],
              "se": [
                36,
                37
              ],
              "e": [
                60,
                61
              ],
              "ne": [
                84,
                85
              ],
              "n": [
                108,
                109
              ],
              "nw": [
                132,
                133
              ],
              "w": [
                156,
                157
              ],
              "sw": [
                180,
                181
              ]
            }
          },
          "death": {
            "frames": [
              38,
              39,
              40,
              41
            ],
            "fps": 7,
            "loop": false,
            "facings": {
              "s": [
                14,
                15,
                16,
                17
              ],
              "se": [
                38,
                39,
                40,
                41
              ],
              "e": [
                62,
                63,
                64,
                65
              ],
              "ne": [
                86,
                87,
                88,
                89
              ],
              "n": [
                110,
                111,
                112,
                113
              ],
              "nw": [
                134,
                135,
                136,
                137
              ],
              "w": [
                158,
                159,
                160,
                161
              ],
              "sw": [
                182,
                183,
                184,
                185
              ]
            }
          },
          "corpse": {
            "frames": [
              41
            ],
            "fps": 1,
            "loop": false,
            "facings": {
              "s": [
                17
              ],
              "se": [
                41
              ],
              "e": [
                65
              ],
              "ne": [
                89
              ],
              "n": [
                113
              ],
              "nw": [
                137
              ],
              "w": [
                161
              ],
              "sw": [
                185
              ]
            }
          },
          "idle": {
            "frames": [
              42,
              43,
              44
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                18,
                19,
                20
              ],
              "se": [
                42,
                43,
                44
              ],
              "e": [
                66,
                67,
                68
              ],
              "ne": [
                90,
                91,
                92
              ],
              "n": [
                114,
                115,
                116
              ],
              "nw": [
                138,
                139,
                140
              ],
              "w": [
                162,
                163,
                164
              ],
              "sw": [
                186,
                187,
                188
              ]
            }
          },
          "work": {
            "frames": [
              45,
              46,
              47
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                21,
                22,
                23
              ],
              "se": [
                45,
                46,
                47
              ],
              "e": [
                69,
                70,
                71
              ],
              "ne": [
                93,
                94,
                95
              ],
              "n": [
                117,
                118,
                119
              ],
              "nw": [
                141,
                142,
                143
              ],
              "w": [
                165,
                166,
                167
              ],
              "sw": [
                189,
                190,
                191
              ]
            }
          }
        },
        "source": "assets/slice/actors/painted/directional/actor-z01-bond-runner/s.png",
        "sourceHash": "9cb6a3831f63526ae7d455b6691688985582245f3ffb9943641a548d510a4d05",
        "recipe": "recipes/art/painted/actors/roster-Z01.json",
        "recipeHash": "c496a203f76935541499db2729f134bbe14c54a802f55a93947a5fdbda0da20c",
        "provider": "gpt-image-2",
        "sources": {
          "assets/slice/actors/painted/directional/actor-z01-bond-runner/s.png": "9cb6a3831f63526ae7d455b6691688985582245f3ffb9943641a548d510a4d05",
          "assets/slice/actors/painted/directional/actor-z01-bond-runner/se.png": "97b431b9ee0ac84d056b5315f25205e46427a4bfc7b66f30daa6b370b54878db",
          "assets/slice/actors/painted/directional/actor-z01-bond-runner/e.png": "8be5fa9ce84befc69ebb25a79580486abb3a412e635856ffd32000270a30571d",
          "assets/slice/actors/painted/directional/actor-z01-bond-runner/ne.png": "2288e9e131bd9b5c7722df08c5489deb449e14df83ee4d18a67666a31be7771b",
          "assets/slice/actors/painted/directional/actor-z01-bond-runner/n.png": "252c930dd3e19335d41e1063f2622ed764fda71c61a979d62694d7817663147e",
          "assets/slice/actors/painted/directional/actor-z01-bond-runner/nw.png": "cfcdb78e60dd120a9fba15d6010065dd4224c255ae808caa56c8424d52c78507",
          "assets/slice/actors/painted/directional/actor-z01-bond-runner/w.png": "da08f9e8e71f426a62077cf0e80ee2bde2ebc5f1f0b0101da48f3d8731f17826",
          "assets/slice/actors/painted/directional/actor-z01-bond-runner/sw.png": "0f710167231e08096e03f141dcda4f5c5af2286a6234267c868f74c59e11cab3"
        }
      }
    },
    {
      "recipeId": "actor-z02-quay-guard",
      "recipe": "recipes/art/painted/actors/roster-Z02.json",
      "recipeHash": "9a0beacd644b6429eef3ae34cf31155a06b30b0849f4f38b47c90b86548f6f58",
      "class": "actor-sheet",
      "provider": "gpt-image-2",
      "seed": null,
      "takes": 1,
      "generated": {
        "path": "assets/slice/actors/painted/directional/actor-z02-quay-guard/s.png",
        "sha256": "cffe40d059a29b68ff6af31295f9612127e7212a9316a4d67d4513e6d67bb837"
      },
      "packed": {
        "path": "assets/slice/packed/actors/painted/actor-z02-quay-guard.png",
        "sha256": "3fb03163e80d5ddac2caae46233e705ec79299c3db5895691d31e3467e5aa570",
        "size": [
          1440,
          1408
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "cell": {
          "width": 120,
          "height": 88
        },
        "sheet": {
          "grid": [
            12,
            16
          ],
          "cellFacings": [
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "s",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "se",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "e",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "ne",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "n",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "nw",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "w",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "sw",
            null,
            null,
            null,
            null,
            null
          ]
        },
        "footY": 80
      },
      "animation": {
        "path": "assets/slice/packed/actors/painted/actor-z02-quay-guard.png",
        "sha256": "3fb03163e80d5ddac2caae46233e705ec79299c3db5895691d31e3467e5aa570",
        "size": [
          1440,
          1408
        ],
        "cell": {
          "width": 120,
          "height": 88
        },
        "foot": [
          60,
          80
        ],
        "walkFacings": [
          "s",
          "se",
          "e",
          "ne",
          "n"
        ],
        "clips": {
          "walk": {
            "frames": [
              24,
              25,
              26,
              27,
              28,
              29
            ],
            "fps": 8,
            "loop": true,
            "facings": {
              "s": [
                0,
                1,
                2,
                3,
                4,
                5
              ],
              "se": [
                24,
                25,
                26,
                27,
                28,
                29
              ],
              "e": [
                48,
                49,
                50,
                51,
                52,
                53
              ],
              "ne": [
                72,
                73,
                74,
                75,
                76,
                77
              ],
              "n": [
                96,
                97,
                98,
                99,
                100,
                101
              ],
              "nw": [
                120,
                121,
                122,
                123,
                124,
                125
              ],
              "w": [
                144,
                145,
                146,
                147,
                148,
                149
              ],
              "sw": [
                168,
                169,
                170,
                171,
                172,
                173
              ]
            }
          },
          "attack": {
            "frames": [
              30,
              31,
              32,
              33,
              34,
              35
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                6,
                7,
                8,
                9,
                10,
                11
              ],
              "se": [
                30,
                31,
                32,
                33,
                34,
                35
              ],
              "e": [
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "ne": [
                78,
                79,
                80,
                81,
                82,
                83
              ],
              "n": [
                102,
                103,
                104,
                105,
                106,
                107
              ],
              "nw": [
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "w": [
                150,
                151,
                152,
                153,
                154,
                155
              ],
              "sw": [
                174,
                175,
                176,
                177,
                178,
                179
              ]
            }
          },
          "recoil": {
            "frames": [
              36,
              37
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                12,
                13
              ],
              "se": [
                36,
                37
              ],
              "e": [
                60,
                61
              ],
              "ne": [
                84,
                85
              ],
              "n": [
                108,
                109
              ],
              "nw": [
                132,
                133
              ],
              "w": [
                156,
                157
              ],
              "sw": [
                180,
                181
              ]
            }
          },
          "death": {
            "frames": [
              38,
              39,
              40,
              41
            ],
            "fps": 7,
            "loop": false,
            "facings": {
              "s": [
                14,
                15,
                16,
                17
              ],
              "se": [
                38,
                39,
                40,
                41
              ],
              "e": [
                62,
                63,
                64,
                65
              ],
              "ne": [
                86,
                87,
                88,
                89
              ],
              "n": [
                110,
                111,
                112,
                113
              ],
              "nw": [
                134,
                135,
                136,
                137
              ],
              "w": [
                158,
                159,
                160,
                161
              ],
              "sw": [
                182,
                183,
                184,
                185
              ]
            }
          },
          "corpse": {
            "frames": [
              41
            ],
            "fps": 1,
            "loop": false,
            "facings": {
              "s": [
                17
              ],
              "se": [
                41
              ],
              "e": [
                65
              ],
              "ne": [
                89
              ],
              "n": [
                113
              ],
              "nw": [
                137
              ],
              "w": [
                161
              ],
              "sw": [
                185
              ]
            }
          },
          "idle": {
            "frames": [
              42,
              43,
              44
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                18,
                19,
                20
              ],
              "se": [
                42,
                43,
                44
              ],
              "e": [
                66,
                67,
                68
              ],
              "ne": [
                90,
                91,
                92
              ],
              "n": [
                114,
                115,
                116
              ],
              "nw": [
                138,
                139,
                140
              ],
              "w": [
                162,
                163,
                164
              ],
              "sw": [
                186,
                187,
                188
              ]
            }
          },
          "work": {
            "frames": [
              45,
              46,
              47
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                21,
                22,
                23
              ],
              "se": [
                45,
                46,
                47
              ],
              "e": [
                69,
                70,
                71
              ],
              "ne": [
                93,
                94,
                95
              ],
              "n": [
                117,
                118,
                119
              ],
              "nw": [
                141,
                142,
                143
              ],
              "w": [
                165,
                166,
                167
              ],
              "sw": [
                189,
                190,
                191
              ]
            }
          }
        },
        "source": "assets/slice/actors/painted/directional/actor-z02-quay-guard/s.png",
        "sourceHash": "cffe40d059a29b68ff6af31295f9612127e7212a9316a4d67d4513e6d67bb837",
        "recipe": "recipes/art/painted/actors/roster-Z02.json",
        "recipeHash": "9a0beacd644b6429eef3ae34cf31155a06b30b0849f4f38b47c90b86548f6f58",
        "provider": "gpt-image-2",
        "sources": {
          "assets/slice/actors/painted/directional/actor-z02-quay-guard/s.png": "cffe40d059a29b68ff6af31295f9612127e7212a9316a4d67d4513e6d67bb837",
          "assets/slice/actors/painted/directional/actor-z02-quay-guard/se.png": "567ff47e776f93c6c6e6c36530109de83afd0ba8f4912c4cef73e8eaf5572674",
          "assets/slice/actors/painted/directional/actor-z02-quay-guard/e.png": "5464e93c2214dee92a360c5153966d7cc9bea595f46ae6e93cc964aa715f9c7c",
          "assets/slice/actors/painted/directional/actor-z02-quay-guard/ne.png": "4124d32e6651c3798ffb19b53989d245c2a0e1efd6bd4d46e02b4854279e85a5",
          "assets/slice/actors/painted/directional/actor-z02-quay-guard/n.png": "2de6ddf8b03407f696f6f49eefe6805c184a1b10e141548127748fe7c13054c7",
          "assets/slice/actors/painted/directional/actor-z02-quay-guard/nw.png": "885f01d02d60cfba34b993396a546103adb794d2d445d27659cb783b52b27084",
          "assets/slice/actors/painted/directional/actor-z02-quay-guard/w.png": "52fba911bacb2b8a59072bc18e3d1ac6f4b0997a6d6f8c10212931c7ec94e3f3",
          "assets/slice/actors/painted/directional/actor-z02-quay-guard/sw.png": "a0b1254583897785cebf74007774a549e993f84d86f6b91cf5d653c2d9a920ce"
        }
      }
    },
    {
      "recipeId": "actor-z02-dock-worker",
      "recipe": "recipes/art/painted/actors/roster-Z02.json",
      "recipeHash": "9a0beacd644b6429eef3ae34cf31155a06b30b0849f4f38b47c90b86548f6f58",
      "class": "actor-sheet",
      "provider": "gpt-image-2",
      "seed": null,
      "takes": 1,
      "generated": {
        "path": "assets/slice/actors/painted/directional/actor-z02-dock-worker/s.png",
        "sha256": "af709b24cc2e5e86b6e732168251c9bd961ca08646cb87481bb9a35be9ed6d1d"
      },
      "packed": {
        "path": "assets/slice/packed/actors/painted/actor-z02-dock-worker.png",
        "sha256": "b3db56199c6da14d8f3a1da4a9a7fd1badc2db01c98653728eda7204cc2803ae",
        "size": [
          1152,
          1280
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "cell": {
          "width": 96,
          "height": 80
        },
        "sheet": {
          "grid": [
            12,
            16
          ],
          "cellFacings": [
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "s",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "se",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "e",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "ne",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "n",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "nw",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "w",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "sw",
            null,
            null,
            null,
            null,
            null
          ]
        },
        "footY": 72
      },
      "animation": {
        "path": "assets/slice/packed/actors/painted/actor-z02-dock-worker.png",
        "sha256": "b3db56199c6da14d8f3a1da4a9a7fd1badc2db01c98653728eda7204cc2803ae",
        "size": [
          1152,
          1280
        ],
        "cell": {
          "width": 96,
          "height": 80
        },
        "foot": [
          48,
          72
        ],
        "walkFacings": [
          "s",
          "se",
          "e",
          "ne",
          "n"
        ],
        "clips": {
          "walk": {
            "frames": [
              24,
              25,
              26,
              27,
              28,
              29
            ],
            "fps": 8,
            "loop": true,
            "facings": {
              "s": [
                0,
                1,
                2,
                3,
                4,
                5
              ],
              "se": [
                24,
                25,
                26,
                27,
                28,
                29
              ],
              "e": [
                48,
                49,
                50,
                51,
                52,
                53
              ],
              "ne": [
                72,
                73,
                74,
                75,
                76,
                77
              ],
              "n": [
                96,
                97,
                98,
                99,
                100,
                101
              ],
              "nw": [
                120,
                121,
                122,
                123,
                124,
                125
              ],
              "w": [
                144,
                145,
                146,
                147,
                148,
                149
              ],
              "sw": [
                168,
                169,
                170,
                171,
                172,
                173
              ]
            }
          },
          "attack": {
            "frames": [
              30,
              31,
              32,
              33,
              34,
              35
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                6,
                7,
                8,
                9,
                10,
                11
              ],
              "se": [
                30,
                31,
                32,
                33,
                34,
                35
              ],
              "e": [
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "ne": [
                78,
                79,
                80,
                81,
                82,
                83
              ],
              "n": [
                102,
                103,
                104,
                105,
                106,
                107
              ],
              "nw": [
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "w": [
                150,
                151,
                152,
                153,
                154,
                155
              ],
              "sw": [
                174,
                175,
                176,
                177,
                178,
                179
              ]
            }
          },
          "recoil": {
            "frames": [
              36,
              37
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                12,
                13
              ],
              "se": [
                36,
                37
              ],
              "e": [
                60,
                61
              ],
              "ne": [
                84,
                85
              ],
              "n": [
                108,
                109
              ],
              "nw": [
                132,
                133
              ],
              "w": [
                156,
                157
              ],
              "sw": [
                180,
                181
              ]
            }
          },
          "death": {
            "frames": [
              38,
              39,
              40,
              41
            ],
            "fps": 7,
            "loop": false,
            "facings": {
              "s": [
                14,
                15,
                16,
                17
              ],
              "se": [
                38,
                39,
                40,
                41
              ],
              "e": [
                62,
                63,
                64,
                65
              ],
              "ne": [
                86,
                87,
                88,
                89
              ],
              "n": [
                110,
                111,
                112,
                113
              ],
              "nw": [
                134,
                135,
                136,
                137
              ],
              "w": [
                158,
                159,
                160,
                161
              ],
              "sw": [
                182,
                183,
                184,
                185
              ]
            }
          },
          "corpse": {
            "frames": [
              41
            ],
            "fps": 1,
            "loop": false,
            "facings": {
              "s": [
                17
              ],
              "se": [
                41
              ],
              "e": [
                65
              ],
              "ne": [
                89
              ],
              "n": [
                113
              ],
              "nw": [
                137
              ],
              "w": [
                161
              ],
              "sw": [
                185
              ]
            }
          },
          "idle": {
            "frames": [
              42,
              43,
              44
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                18,
                19,
                20
              ],
              "se": [
                42,
                43,
                44
              ],
              "e": [
                66,
                67,
                68
              ],
              "ne": [
                90,
                91,
                92
              ],
              "n": [
                114,
                115,
                116
              ],
              "nw": [
                138,
                139,
                140
              ],
              "w": [
                162,
                163,
                164
              ],
              "sw": [
                186,
                187,
                188
              ]
            }
          },
          "work": {
            "frames": [
              45,
              46,
              47
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                21,
                22,
                23
              ],
              "se": [
                45,
                46,
                47
              ],
              "e": [
                69,
                70,
                71
              ],
              "ne": [
                93,
                94,
                95
              ],
              "n": [
                117,
                118,
                119
              ],
              "nw": [
                141,
                142,
                143
              ],
              "w": [
                165,
                166,
                167
              ],
              "sw": [
                189,
                190,
                191
              ]
            }
          }
        },
        "source": "assets/slice/actors/painted/directional/actor-z02-dock-worker/s.png",
        "sourceHash": "af709b24cc2e5e86b6e732168251c9bd961ca08646cb87481bb9a35be9ed6d1d",
        "recipe": "recipes/art/painted/actors/roster-Z02.json",
        "recipeHash": "9a0beacd644b6429eef3ae34cf31155a06b30b0849f4f38b47c90b86548f6f58",
        "provider": "gpt-image-2",
        "sources": {
          "assets/slice/actors/painted/directional/actor-z02-dock-worker/s.png": "af709b24cc2e5e86b6e732168251c9bd961ca08646cb87481bb9a35be9ed6d1d",
          "assets/slice/actors/painted/directional/actor-z02-dock-worker/se.png": "539a5a1a7b52de6bd054c16253b19bd6912bba0ba6bc6e512fccc68904747469",
          "assets/slice/actors/painted/directional/actor-z02-dock-worker/e.png": "edab63731273a61949a06b0f308e00e5aa93a99de86aff63eb8a9167a7d7659e",
          "assets/slice/actors/painted/directional/actor-z02-dock-worker/ne.png": "296c5087447bbb3e3494183099aaf5f20382a9faf3845f4237048a2c09160eb9",
          "assets/slice/actors/painted/directional/actor-z02-dock-worker/n.png": "5eb0ffe3d3af0e91163b83ef704103d41e674cc0ae9b6bb53f68003179c0767e",
          "assets/slice/actors/painted/directional/actor-z02-dock-worker/nw.png": "b86a42a10cdef562f4fe751fb41255a16e08286b1b65993d04d968d4a4eaacb7",
          "assets/slice/actors/painted/directional/actor-z02-dock-worker/w.png": "da41c693901b501b1ab5d34f2bb289fafece7e7367fc03c1de4ce4d1d5b98b94",
          "assets/slice/actors/painted/directional/actor-z02-dock-worker/sw.png": "c9826e4894c489c46e89fd74888c8c2880dbc751b8b9fc9cfaf08187552c52a0"
        }
      }
    },
    {
      "recipeId": "actor-z06-toll-guard",
      "recipe": "recipes/art/painted/actors/roster-Z06.json",
      "recipeHash": "5ebd52edb54735e40b372e36179b7f8ea04d76f2176b71037ff152aae6e3a122",
      "class": "actor-sheet",
      "provider": "gpt-image-2",
      "seed": null,
      "takes": 1,
      "generated": {
        "path": "assets/slice/actors/painted/directional/actor-z06-toll-guard/s.png",
        "sha256": "874924b0676935f9ad2b8dd8383cf6f6ddf997c27f5cf8feb63bb10bbe66f9c3"
      },
      "packed": {
        "path": "assets/slice/packed/actors/painted/actor-z06-toll-guard.png",
        "sha256": "d2f986065fcd1c0c5c295bebd2edff2a20c9cff24f7e11414756aac9f3fd4e67",
        "size": [
          1248,
          1408
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "cell": {
          "width": 104,
          "height": 88
        },
        "sheet": {
          "grid": [
            12,
            16
          ],
          "cellFacings": [
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "s",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "se",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "e",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "ne",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "n",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "nw",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "w",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "sw",
            null,
            null,
            null,
            null,
            null
          ]
        },
        "footY": 80
      },
      "animation": {
        "path": "assets/slice/packed/actors/painted/actor-z06-toll-guard.png",
        "sha256": "d2f986065fcd1c0c5c295bebd2edff2a20c9cff24f7e11414756aac9f3fd4e67",
        "size": [
          1248,
          1408
        ],
        "cell": {
          "width": 104,
          "height": 88
        },
        "foot": [
          52,
          80
        ],
        "walkFacings": [
          "s",
          "se",
          "e",
          "ne",
          "n"
        ],
        "clips": {
          "walk": {
            "frames": [
              24,
              25,
              26,
              27,
              28,
              29
            ],
            "fps": 8,
            "loop": true,
            "facings": {
              "s": [
                0,
                1,
                2,
                3,
                4,
                5
              ],
              "se": [
                24,
                25,
                26,
                27,
                28,
                29
              ],
              "e": [
                48,
                49,
                50,
                51,
                52,
                53
              ],
              "ne": [
                72,
                73,
                74,
                75,
                76,
                77
              ],
              "n": [
                96,
                97,
                98,
                99,
                100,
                101
              ],
              "nw": [
                120,
                121,
                122,
                123,
                124,
                125
              ],
              "w": [
                144,
                145,
                146,
                147,
                148,
                149
              ],
              "sw": [
                168,
                169,
                170,
                171,
                172,
                173
              ]
            }
          },
          "attack": {
            "frames": [
              30,
              31,
              32,
              33,
              34,
              35
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                6,
                7,
                8,
                9,
                10,
                11
              ],
              "se": [
                30,
                31,
                32,
                33,
                34,
                35
              ],
              "e": [
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "ne": [
                78,
                79,
                80,
                81,
                82,
                83
              ],
              "n": [
                102,
                103,
                104,
                105,
                106,
                107
              ],
              "nw": [
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "w": [
                150,
                151,
                152,
                153,
                154,
                155
              ],
              "sw": [
                174,
                175,
                176,
                177,
                178,
                179
              ]
            }
          },
          "recoil": {
            "frames": [
              36,
              37
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                12,
                13
              ],
              "se": [
                36,
                37
              ],
              "e": [
                60,
                61
              ],
              "ne": [
                84,
                85
              ],
              "n": [
                108,
                109
              ],
              "nw": [
                132,
                133
              ],
              "w": [
                156,
                157
              ],
              "sw": [
                180,
                181
              ]
            }
          },
          "death": {
            "frames": [
              38,
              39,
              40,
              41
            ],
            "fps": 7,
            "loop": false,
            "facings": {
              "s": [
                14,
                15,
                16,
                17
              ],
              "se": [
                38,
                39,
                40,
                41
              ],
              "e": [
                62,
                63,
                64,
                65
              ],
              "ne": [
                86,
                87,
                88,
                89
              ],
              "n": [
                110,
                111,
                112,
                113
              ],
              "nw": [
                134,
                135,
                136,
                137
              ],
              "w": [
                158,
                159,
                160,
                161
              ],
              "sw": [
                182,
                183,
                184,
                185
              ]
            }
          },
          "corpse": {
            "frames": [
              41
            ],
            "fps": 1,
            "loop": false,
            "facings": {
              "s": [
                17
              ],
              "se": [
                41
              ],
              "e": [
                65
              ],
              "ne": [
                89
              ],
              "n": [
                113
              ],
              "nw": [
                137
              ],
              "w": [
                161
              ],
              "sw": [
                185
              ]
            }
          },
          "idle": {
            "frames": [
              42,
              43,
              44
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                18,
                19,
                20
              ],
              "se": [
                42,
                43,
                44
              ],
              "e": [
                66,
                67,
                68
              ],
              "ne": [
                90,
                91,
                92
              ],
              "n": [
                114,
                115,
                116
              ],
              "nw": [
                138,
                139,
                140
              ],
              "w": [
                162,
                163,
                164
              ],
              "sw": [
                186,
                187,
                188
              ]
            }
          },
          "work": {
            "frames": [
              45,
              46,
              47
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                21,
                22,
                23
              ],
              "se": [
                45,
                46,
                47
              ],
              "e": [
                69,
                70,
                71
              ],
              "ne": [
                93,
                94,
                95
              ],
              "n": [
                117,
                118,
                119
              ],
              "nw": [
                141,
                142,
                143
              ],
              "w": [
                165,
                166,
                167
              ],
              "sw": [
                189,
                190,
                191
              ]
            }
          }
        },
        "source": "assets/slice/actors/painted/directional/actor-z06-toll-guard/s.png",
        "sourceHash": "874924b0676935f9ad2b8dd8383cf6f6ddf997c27f5cf8feb63bb10bbe66f9c3",
        "recipe": "recipes/art/painted/actors/roster-Z06.json",
        "recipeHash": "5ebd52edb54735e40b372e36179b7f8ea04d76f2176b71037ff152aae6e3a122",
        "provider": "gpt-image-2",
        "sources": {
          "assets/slice/actors/painted/directional/actor-z06-toll-guard/s.png": "874924b0676935f9ad2b8dd8383cf6f6ddf997c27f5cf8feb63bb10bbe66f9c3",
          "assets/slice/actors/painted/directional/actor-z06-toll-guard/se.png": "86da0d0a298411a0ffe6fbfc3f9c9c96e4b2e4071db179d42e47debcc2f5b874",
          "assets/slice/actors/painted/directional/actor-z06-toll-guard/e.png": "860f3128e3b213ec1b828270b1e55543f7cad499560bc2e773a094003b492b2a",
          "assets/slice/actors/painted/directional/actor-z06-toll-guard/ne.png": "c7ce3af7de4f2c7fd49c2995e45fc1803913d8f33832b52ff1102bec6100a6bf",
          "assets/slice/actors/painted/directional/actor-z06-toll-guard/n.png": "935788e066bec586836fde51aa517f666cebcb9006a176c7d78802c621cfea77",
          "assets/slice/actors/painted/directional/actor-z06-toll-guard/nw.png": "baae3a3649f930f2e9cbeb6ff070623987aff6dd65a31adbc593016e5afc8f18",
          "assets/slice/actors/painted/directional/actor-z06-toll-guard/w.png": "8ccab0cad4d0ced65438027dbe11b4c353d1917c1413db631318ea18e82afe31",
          "assets/slice/actors/painted/directional/actor-z06-toll-guard/sw.png": "7491170d8db68f924689f1560320142c8ed6b59d4b19b274eb94f45a2f846d2d"
        }
      }
    },
    {
      "recipeId": "actor-z06-causeway-labourer",
      "recipe": "recipes/art/painted/actors/roster-Z06.json",
      "recipeHash": "5ebd52edb54735e40b372e36179b7f8ea04d76f2176b71037ff152aae6e3a122",
      "class": "actor-sheet",
      "provider": "gpt-image-2",
      "seed": null,
      "takes": 1,
      "generated": {
        "path": "assets/slice/actors/painted/directional/actor-z06-causeway-labourer/s.png",
        "sha256": "4dc99723d90980bf360835da9a9a002d009dff90862a4d6a2a099d314ed6c675"
      },
      "packed": {
        "path": "assets/slice/packed/actors/painted/actor-z06-causeway-labourer.png",
        "sha256": "6265295025fa0eb4eebf079c41fc15a9037a6ba2df7e81ba5f47c0f1f50c4241",
        "size": [
          1152,
          1280
        ],
        "mediaType": "image/png"
      },
      "geometry": {
        "cell": {
          "width": 96,
          "height": 80
        },
        "sheet": {
          "grid": [
            12,
            16
          ],
          "cellFacings": [
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "s",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "se",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "e",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "ne",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "n",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "nw",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "w",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "sw",
            null,
            null,
            null,
            null,
            null
          ]
        },
        "footY": 72
      },
      "animation": {
        "path": "assets/slice/packed/actors/painted/actor-z06-causeway-labourer.png",
        "sha256": "6265295025fa0eb4eebf079c41fc15a9037a6ba2df7e81ba5f47c0f1f50c4241",
        "size": [
          1152,
          1280
        ],
        "cell": {
          "width": 96,
          "height": 80
        },
        "foot": [
          48,
          72
        ],
        "walkFacings": [
          "s",
          "se",
          "e",
          "ne",
          "n"
        ],
        "clips": {
          "walk": {
            "frames": [
              24,
              25,
              26,
              27,
              28,
              29
            ],
            "fps": 8,
            "loop": true,
            "facings": {
              "s": [
                0,
                1,
                2,
                3,
                4,
                5
              ],
              "se": [
                24,
                25,
                26,
                27,
                28,
                29
              ],
              "e": [
                48,
                49,
                50,
                51,
                52,
                53
              ],
              "ne": [
                72,
                73,
                74,
                75,
                76,
                77
              ],
              "n": [
                96,
                97,
                98,
                99,
                100,
                101
              ],
              "nw": [
                120,
                121,
                122,
                123,
                124,
                125
              ],
              "w": [
                144,
                145,
                146,
                147,
                148,
                149
              ],
              "sw": [
                168,
                169,
                170,
                171,
                172,
                173
              ]
            }
          },
          "attack": {
            "frames": [
              30,
              31,
              32,
              33,
              34,
              35
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                6,
                7,
                8,
                9,
                10,
                11
              ],
              "se": [
                30,
                31,
                32,
                33,
                34,
                35
              ],
              "e": [
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "ne": [
                78,
                79,
                80,
                81,
                82,
                83
              ],
              "n": [
                102,
                103,
                104,
                105,
                106,
                107
              ],
              "nw": [
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "w": [
                150,
                151,
                152,
                153,
                154,
                155
              ],
              "sw": [
                174,
                175,
                176,
                177,
                178,
                179
              ]
            }
          },
          "recoil": {
            "frames": [
              36,
              37
            ],
            "fps": 10,
            "loop": false,
            "facings": {
              "s": [
                12,
                13
              ],
              "se": [
                36,
                37
              ],
              "e": [
                60,
                61
              ],
              "ne": [
                84,
                85
              ],
              "n": [
                108,
                109
              ],
              "nw": [
                132,
                133
              ],
              "w": [
                156,
                157
              ],
              "sw": [
                180,
                181
              ]
            }
          },
          "death": {
            "frames": [
              38,
              39,
              40,
              41
            ],
            "fps": 7,
            "loop": false,
            "facings": {
              "s": [
                14,
                15,
                16,
                17
              ],
              "se": [
                38,
                39,
                40,
                41
              ],
              "e": [
                62,
                63,
                64,
                65
              ],
              "ne": [
                86,
                87,
                88,
                89
              ],
              "n": [
                110,
                111,
                112,
                113
              ],
              "nw": [
                134,
                135,
                136,
                137
              ],
              "w": [
                158,
                159,
                160,
                161
              ],
              "sw": [
                182,
                183,
                184,
                185
              ]
            }
          },
          "corpse": {
            "frames": [
              41
            ],
            "fps": 1,
            "loop": false,
            "facings": {
              "s": [
                17
              ],
              "se": [
                41
              ],
              "e": [
                65
              ],
              "ne": [
                89
              ],
              "n": [
                113
              ],
              "nw": [
                137
              ],
              "w": [
                161
              ],
              "sw": [
                185
              ]
            }
          },
          "idle": {
            "frames": [
              42,
              43,
              44
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                18,
                19,
                20
              ],
              "se": [
                42,
                43,
                44
              ],
              "e": [
                66,
                67,
                68
              ],
              "ne": [
                90,
                91,
                92
              ],
              "n": [
                114,
                115,
                116
              ],
              "nw": [
                138,
                139,
                140
              ],
              "w": [
                162,
                163,
                164
              ],
              "sw": [
                186,
                187,
                188
              ]
            }
          },
          "work": {
            "frames": [
              45,
              46,
              47
            ],
            "fps": 2,
            "loop": true,
            "facings": {
              "s": [
                21,
                22,
                23
              ],
              "se": [
                45,
                46,
                47
              ],
              "e": [
                69,
                70,
                71
              ],
              "ne": [
                93,
                94,
                95
              ],
              "n": [
                117,
                118,
                119
              ],
              "nw": [
                141,
                142,
                143
              ],
              "w": [
                165,
                166,
                167
              ],
              "sw": [
                189,
                190,
                191
              ]
            }
          }
        },
        "source": "assets/slice/actors/painted/directional/actor-z06-causeway-labourer/s.png",
        "sourceHash": "4dc99723d90980bf360835da9a9a002d009dff90862a4d6a2a099d314ed6c675",
        "recipe": "recipes/art/painted/actors/roster-Z06.json",
        "recipeHash": "5ebd52edb54735e40b372e36179b7f8ea04d76f2176b71037ff152aae6e3a122",
        "provider": "gpt-image-2",
        "sources": {
          "assets/slice/actors/painted/directional/actor-z06-causeway-labourer/s.png": "4dc99723d90980bf360835da9a9a002d009dff90862a4d6a2a099d314ed6c675",
          "assets/slice/actors/painted/directional/actor-z06-causeway-labourer/se.png": "4402e3434e45a5bdcbfdc5a609dee286c542733c480dfab867671e2135aeaf42",
          "assets/slice/actors/painted/directional/actor-z06-causeway-labourer/e.png": "8ae502e5b0dcddd14f23ec475585a5016daf06a3f4bfe7024fc32c5b5b5ff890",
          "assets/slice/actors/painted/directional/actor-z06-causeway-labourer/ne.png": "7eab0319b9756c592b983021bc6ffcb019e3cd76c02b8e638c8fd03d5d8d587e",
          "assets/slice/actors/painted/directional/actor-z06-causeway-labourer/n.png": "22f92a505d90d6d7f1fe7933bd99a192c55f9599bea409a7a3b2913e8125cfe8",
          "assets/slice/actors/painted/directional/actor-z06-causeway-labourer/nw.png": "b3ee695b0c6fc946f674561234f398811516dfe0a63a8a642fe28fc493ebd69e",
          "assets/slice/actors/painted/directional/actor-z06-causeway-labourer/w.png": "68132034dee50070ec5c46ea1a5e4537d157e3daebc98d7dad4c67541691b9ff",
          "assets/slice/actors/painted/directional/actor-z06-causeway-labourer/sw.png": "15d54cc95edf634413ae994cff088e43f0213c0c344a1eaffc8263690e61a4f8"
        }
      }
    }
  ]
}
